// Generated by AvenyModelEditor

import { IClientSubSystemModel } from '../../Types/ClientModelTypes';
import { TEDSelectionOperator as T} from '../../globalQueryTypes';

const TI: IClientSubSystemModel = {
  Code: 'TI',
  DisplayLabel: 'Tidredovisning',
  BusinessModels: {
    TIAnstalldStampling: {
      CollectionName: 'TIAnstalldStampling',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AnstalldStampling',
        Abstract: false,
        SOLabel: 'AnstalldStampling',
        SOGLabel: 'AnstalldStampling',
        SBLabel: 'AnstalldStampling',
        SBGLabel: 'AnstalldStampling',
        POLabel: 'AnstalldStampling',
        POGLabel: 'AnstalldStampling',
        PBLabel: 'AnstalldStampling',
        PBGLabel: 'AnstalldStampling',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'AnstalldStampling primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'AnstalldStampling versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'AnstalldStampling id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'AnstalldStampling fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SENASTE_STAMPEL_ID: {
          AttributeName: 'SENASTE_STAMPEL_ID',
          DisplayLabel: 'Senaste stämpel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SENASTE_STAMPLING: {
          AttributeName: 'SENASTE_STAMPLING',
          DisplayLabel: 'Senaste stämplingstid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
        },
        SENASTE_ARBETSUPPGIFT_ID: {
          AttributeName: 'SENASTE_ARBETSUPPGIFT_ID',
          DisplayLabel: 'Senaste arbetsuppgift',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SENASTE_RAPPORTERINGSKOD2_ID: {
          AttributeName: 'SENASTE_RAPPORTERINGSKOD2_ID',
          DisplayLabel: 'Senaste rapporteringskod 2',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Anstalld: {
          AssociationName: 'Anstalld',
          DisplayLabel: 'Anställd',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAnstalld',
          AssociatedComponentName: 'Anstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        senasteStampel: {
          AssociationName: 'senasteStampel',
          DisplayLabel: 'Senaste stämpel',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIStampel',
          AssociatedComponentName: 'Stampel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        senasteArbetsuppgift: {
          AssociationName: 'senasteArbetsuppgift',
          DisplayLabel: 'Senaste arbetsuppgift',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIArbetsuppgift',
          AssociatedComponentName: 'Arbetsuppgift',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIAnstalld: {
      CollectionName: 'TIAnstalld',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['GroupAssociation', 'tidgrupp'], ['USER_DEF_REPORT_ROUTINE', '14007']]),
      RootType: {
        TypeValue: 'Anstalld',
        Abstract: false,
        SOLabel: 'Anställd',
        SOGLabel: 'Anställd',
        SBLabel: 'Anställda',
        SBGLabel: 'Anställda',
        POLabel: 'Anställda',
        POGLabel: 'Anställda',
        PBLabel: 'Anställda',
        PBGLabel: 'Anställda',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Anställda primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Anställda versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Anställda id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Anställda fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TID_GRUPP_ID: {
          AttributeName: 'TID_GRUPP_ID',
          DisplayLabel: 'Tidredovisningsgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANSTALLNINGSNR: {
          AttributeName: 'ANSTALLNINGSNR',
          DisplayLabel: 'Anställningsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        ADRESS_ID: {
          AttributeName: 'ADRESS_ID',
          DisplayLabel: 'ADRESS_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORESLAGEN_LONEART_ID: {
          AttributeName: 'FORESLAGEN_LONEART_ID',
          DisplayLabel: 'Föreslagen rapporteringskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSTIDSFAKTOR: {
          AttributeName: 'ARBETSTIDSFAKTOR',
          DisplayLabel: 'Arbetstidsfaktor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          FormatterValidateParams: 'MinValue="0";MaxValue="1"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Arbetstidsfaktor',
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        FOREG_FAKTOR: {
          AttributeName: 'FOREG_FAKTOR',
          DisplayLabel: 'Tidigare arbetstidsfaktor',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          FormatterValidateParams: 'MinValue="0";MaxValue="1"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Arbetstidsfaktor',
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        DATUM_NY_FAKTOR: {
          AttributeName: 'DATUM_NY_FAKTOR',
          DisplayLabel: 'Ny faktor per månad',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          FormatterParseParams: 'Format="y-m/ymm"',
          FormatterDisplayParams: 'Format="yyyy-mm"',
          FormatterValidateParams: 'MaxRecommendedDate="+12m";MinRecommendedDate="-12m"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Arbetstidsfaktor',
        },
        INSTALLNINGAR_ID: {
          AttributeName: 'INSTALLNINGAR_ID',
          DisplayLabel: 'Inställningar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVENYANVANDARE_ID: {
          AttributeName: 'AVENYANVANDARE_ID',
          DisplayLabel: 'AVENYANVANDARE_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AUT_TIDSSTAMPLING: {
          AttributeName: 'AUT_TIDSSTAMPLING',
          DisplayLabel: 'Visas i stämpelklocka',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        EXPORT_EK: {
          AttributeName: 'EXPORT_EK',
          DisplayLabel: 'Internbokföring',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        EXPORT_LO: {
          AttributeName: 'EXPORT_LO',
          DisplayLabel: 'Överföring till löneprogram',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Löneexport',
        },
        ANSTALLD_FROM: {
          AttributeName: 'ANSTALLD_FROM',
          DisplayLabel: 'Anställd fr o m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxRecommendedDate="+12m";MinRecommendedDate="-1000m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        ANSTALLD_TOM: {
          AttributeName: 'ANSTALLD_TOM',
          DisplayLabel: 'Anställd t o m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MinDate="-120m";MaxDate="+120m";MinRecommendedDate="-12m";MaxRecommendedDate="+24m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        INSTAMPLINGSKOD: {
          AttributeName: 'INSTAMPLINGSKOD',
          DisplayLabel: 'Instämplingskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SCHEMA_ID: {
          AttributeName: 'SCHEMA_ID',
          DisplayLabel: 'Schema',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM_NYTT_SCHEMA: {
          AttributeName: 'DATUM_NYTT_SCHEMA',
          DisplayLabel: 'Nytt schema per månad',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateMonth',
          FormatterParseParams: 'Format="y-m/ymm"',
          FormatterDisplayParams: 'Format="yyyy-mm"',
          FormatterValidateParams: 'MaxRecommendedDate="+12m";MinRecommendedDate="-12m"',
        },
        FOREG_SCHEMA_ID: {
          AttributeName: 'FOREG_SCHEMA_ID',
          DisplayLabel: 'Tidigare schema',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KATEGORI_ID: {
          AttributeName: 'KATEGORI_ID',
          DisplayLabel: 'Anställdkategori',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VANTAS_TILLBAKA: {
          AttributeName: 'VANTAS_TILLBAKA',
          DisplayLabel: 'Väntas tillbaka',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxRecommendedDate="+12m";MinRecommendedDate="-1m"',
        },
        VANTAS_TILLBAKA_TEXT: {
          AttributeName: 'VANTAS_TILLBAKA_TEXT',
          DisplayLabel: 'Väntas tillbaka, kommentar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SEMESTERFAKTOR: {
          AttributeName: 'SEMESTERFAKTOR',
          DisplayLabel: 'Semesterfaktor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          FormatterValidateParams: 'MinValue="1";MaxValue="20"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Semesterfaktor',
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        DATUM_NY_SEMESTERFAKTOR: {
          AttributeName: 'DATUM_NY_SEMESTERFAKTOR',
          DisplayLabel: 'Ny semesterfaktor per månad',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          FormatterParseParams: 'Format="y-m/ymm"',
          FormatterDisplayParams: 'Format="yyyy-mm"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Semesterfaktor',
        },
        FOREG_SEMESTERFAKTOR: {
          AttributeName: 'FOREG_SEMESTERFAKTOR',
          DisplayLabel: 'Föregående semesterfaktor',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Semesterfaktor',
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        DEMO_SOMMARSCHEMA: {
          AttributeName: 'DEMO_SOMMARSCHEMA',
          DisplayLabel: 'DEMO_SOMMARSCHEMA',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        TIDRAPP_FROM: {
          AttributeName: 'TIDRAPP_FROM',
          DisplayLabel: 'Tidrapportering fr.o.m.',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          FormatterParseParams: 'Format="y-m/ymm"',
          FormatterDisplayParams: 'Format="yyyy-mm"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FORDELA_TID: {
          AttributeName: 'FORDELA_TID',
          DisplayLabel: 'Fördelning av tid',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        PERIODREGISTRERING: {
          AttributeName: 'PERIODREGISTRERING',
          DisplayLabel: 'Periodregistrering',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        ATTESTOMRADE_ID: {
          AttributeName: 'ATTESTOMRADE_ID',
          DisplayLabel: 'Attestområde',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LO_ANSTALLNINGSNR: {
          AttributeName: 'LO_ANSTALLNINGSNR',
          DisplayLabel: 'Anställningsnr i löneprogram',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Löneexport',
        },
        namn: {
          AttributeName: 'namn',
          DisplayLabel: 'Namn/Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.contains,
        },
        adress_radXXXX: {
          AttributeName: 'adress_radXXXX',
          DisplayLabel: 'Adress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        installningarBenamning: {
          AttributeName: 'installningarBenamning',
          DisplayLabel: 'Inställningar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        loneartBenamning: {
          AttributeName: 'loneartBenamning',
          DisplayLabel: 'Normal rapporteringskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        nrNamn: {
          AttributeName: 'nrNamn',
          DisplayLabel: 'Nummer och namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBTIIntern: {
          AttributeName: 'KBTIIntern',
          DisplayLabel: 'KBTIIntern',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBTILon: {
          AttributeName: 'KBTILon',
          DisplayLabel: 'KBTILon',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBTIInternKre: {
          AttributeName: 'KBTIInternKre',
          DisplayLabel: 'KBTIInternKre',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        arbetstidsfaktorText: {
          AttributeName: 'arbetstidsfaktorText',
          DisplayLabel: 'Arbetstidsfaktor',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        aktuellUppgift: {
          AttributeName: 'aktuellUppgift',
          DisplayLabel: 'Aktuell uppgift',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        aktuelltProjekt: {
          AttributeName: 'aktuelltProjekt',
          DisplayLabel: 'Aktuellt projekt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ankom: {
          AttributeName: 'ankom',
          DisplayLabel: 'Ankom',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
        },
        lamnade: {
          AttributeName: 'lamnade',
          DisplayLabel: 'Lämnade',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
        },
        ankomLamnade: {
          AttributeName: 'ankomLamnade',
          DisplayLabel: 'ankomLamnade',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        aktuellFranTid: {
          AttributeName: 'aktuellFranTid',
          DisplayLabel: 'Inloggad på senaste uppgift',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
        },
        aktuellStampel: {
          AttributeName: 'aktuellStampel',
          DisplayLabel: 'aktuellStampel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        senastInlUtd: {
          AttributeName: 'senastInlUtd',
          DisplayLabel: 'Senast inloggade uppgift',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        status: {
          AttributeName: 'status',
          DisplayLabel: 'Status',
          Hint: 'Rast/Ledig/Ej instämplad/Arbetspaus/Instämplad på uppgift',
          DataType: 'Enum',
          EnumValues: new Map([['RAST', 'Rast'], ['LEDIG', 'Ledig'], ['EJ_INSTAMPLAD', 'Ej instämplad'], ['ARBETSPAUS', 'Arbetspaus'], ['INSTAMPLAD_PA_UPPGIFT', 'Instämplad på uppgift']]),
          EnumSortValues: new Map([['RAST', 'R'], ['LEDIG', 'L'], ['EJ_INSTAMPLAD', 'E'], ['ARBETSPAUS', 'P'], ['INSTAMPLAD_PA_UPPGIFT', 'A']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="RAST=Rast;LEDIG=Ledig;EJ_INSTAMPLAD=Ej instämplad;ARBETSPAUS=Arbetspaus;INSTAMPLAD_PA_UPPGIFT=Instämplad på uppgift"',
        },
        vantasTillbaka: {
          AttributeName: 'vantasTillbaka',
          DisplayLabel: 'Väntas tillbaka',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        statusText: {
          AttributeName: 'statusText',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        schemaText: {
          AttributeName: 'schemaText',
          DisplayLabel: 'Schema',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        aktuellUppgiftID: {
          AttributeName: 'aktuellUppgiftID',
          DisplayLabel: 'Aktuell uppgift',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        namnNr: {
          AttributeName: 'namnNr',
          DisplayLabel: 'Anställd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        semesterfaktorText: {
          AttributeName: 'semesterfaktorText',
          DisplayLabel: 'Semesterfaktor',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        sqlENamn: {
          AttributeName: 'sqlENamn',
          DisplayLabel: 'sqlENamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        namnFE: {
          AttributeName: 'namnFE',
          DisplayLabel: 'Namn/Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals],
          DefaultCondOperator: T.contains,
        },
        tidgruppBenamning: {
          AttributeName: 'tidgruppBenamning',
          DisplayLabel: 'Tidredovisningsgrupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        kategoriBenamning: {
          AttributeName: 'kategoriBenamning',
          DisplayLabel: 'Kategori',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        anvandareNamn: {
          AttributeName: 'anvandareNamn',
          DisplayLabel: 'Användare',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        aktuellRastID: {
          AttributeName: 'aktuellRastID',
          DisplayLabel: 'aktuellRastID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        aktuelltDatum: {
          AttributeName: 'aktuelltDatum',
          DisplayLabel: 'Aktuellt datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        aktuellUppgiftNrBenamning: {
          AttributeName: 'aktuellUppgiftNrBenamning',
          DisplayLabel: 'Aktuell uppgift',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCase',
        },
        attestomradeBenamning: {
          AttributeName: 'attestomradeBenamning',
          DisplayLabel: 'Attestområde',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        senasteRegTid: {
          AttributeName: 'senasteRegTid',
          DisplayLabel: 'Senaste registreringstid',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTime',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Anställd/Rapporteringsobjekt',
          Hint: 'Anställd/Rapporteringsobjekt',
          DataType: 'Enum',
          EnumValues: new Map([['ANSTALLD', 'Anställd'], ['RAPPORTERINGSOBJEKT', 'Rapporteringsobjekt']]),
          EnumSortValues: new Map([['ANSTALLD', 'A'], ['RAPPORTERINGSOBJEKT', 'R']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANSTALLD=Anställd;RAPPORTERINGSOBJEKT=Rapporteringsobjekt"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        simpleNamn: {
          AttributeName: 'simpleNamn',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        franvaroText: {
          AttributeName: 'franvaroText',
          DisplayLabel: 'Frånvaro',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleKBTIInternKre: {
          AttributeName: 'RuleKBTIInternKre',
          DisplayLabel: 'RuleKBTIInternKre',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        aktuellKod2Id: {
          AttributeName: 'aktuellKod2Id',
          DisplayLabel: 'Instämplad på Rapporteringskod 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        senasteKod2Id: {
          AttributeName: 'senasteKod2Id',
          DisplayLabel: 'senasteKod2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        aktuellKod2NrBenamning: {
          AttributeName: 'aktuellKod2NrBenamning',
          DisplayLabel: 'Aktuell Rapporteringskod 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        OB: {
          AttributeName: 'OB',
          DisplayLabel: 'Berättigad till OB-tillägg',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OB_ENLIGT_SCHEMA: {
          AttributeName: 'OB_ENLIGT_SCHEMA',
          DisplayLabel: 'OB-tillägg enligt normal arbtid',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANSTALLD_FORNAMN: {
          AttributeName: 'ANSTALLD_FORNAMN',
          DisplayLabel: 'Förnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANSTALLD_EFTERNAMN: {
          AttributeName: 'ANSTALLD_EFTERNAMN',
          DisplayLabel: 'Efternamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SEMESTERRATT: {
          AttributeName: 'SEMESTERRATT',
          DisplayLabel: 'Semesterrätt',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        installningar: {
          AssociationName: 'installningar',
          DisplayLabel: 'Inställningar',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIInstallningar',
          AssociatedComponentName: 'Installningar',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        normalLoneart: {
          AssociationName: 'normalLoneart',
          DisplayLabel: 'Föreslagen rapporteringskod',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIRapporteringskod',
          AssociatedComponentName: 'Rapporteringskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        adress: {
          AssociationName: 'adress',
          DisplayLabel: 'Adress',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        tidgrupp: {
          AssociationName: 'tidgrupp',
          DisplayLabel: 'Tidredovisningsgrupp',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidGrupp',
          AssociatedComponentName: 'TidGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        anvandare: {
          AssociationName: 'anvandare',
          DisplayLabel: 'Avenyanvändare',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        veckoschema: {
          AssociationName: 'veckoschema',
          DisplayLabel: 'Schema',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIVeckoschema',
          AssociatedComponentName: 'Veckoschema',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        TIDINTERN: {
          AssociationName: 'TIDINTERN',
          DisplayLabel: 'Kontering internbokföring, debet',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        TIDLON: {
          AssociationName: 'TIDLON',
          DisplayLabel: 'Kontering överföring till löneprogram',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        TIDINTERN_KRE: {
          AssociationName: 'TIDINTERN_KRE',
          DisplayLabel: 'Kontering internbokföring, kredit',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        anstalldKategori: {
          AssociationName: 'anstalldKategori',
          DisplayLabel: 'Anställdkategori',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAnstalldKategori',
          AssociatedComponentName: 'AnstalldKategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        foregSchema: {
          AssociationName: 'foregSchema',
          DisplayLabel: 'Tidigare schema',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIVeckoschema',
          AssociatedComponentName: 'Veckoschema',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        stampling: {
          AssociationName: 'stampling',
          DisplayLabel: 'Stämpling',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIAnstalldStampling',
          AssociatedComponentName: 'AnstalldStampling',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        manader: {
          AssociationName: 'manader',
          DisplayLabel: 'Månadsrapportering',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIManAnstalld',
          AssociatedComponentName: 'ManAnstalld',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        utdelatTill: {
          AssociationName: 'utdelatTill',
          DisplayLabel: 'Utdelad arbetsuppgift',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIUtdelatTill',
          AssociatedComponentName: 'UtdelatTill',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        ansvarigForUpg: {
          AssociationName: 'ansvarigForUpg',
          DisplayLabel: 'Ansvarig för arbetsuppgift',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIArbetsuppgift',
          AssociatedComponentName: 'Arbetsuppgift',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        kalkylpris: {
          AssociationName: 'kalkylpris',
          DisplayLabel: 'Kalkylpris',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIPrisAnstalld',
          AssociatedComponentName: 'PrisAnstalld',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        dagAnstalld: {
          AssociationName: 'dagAnstalld',
          DisplayLabel: 'Dagrapporteringar',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIDagAnstalld',
          AssociatedComponentName: 'DagAnstalld',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        tidrapporteringar: {
          AssociationName: 'tidrapporteringar',
          DisplayLabel: 'Tidrapporteringar',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidrapportering',
          AssociatedComponentName: 'Tidrapportering',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        aoAnstalld: {
          AssociationName: 'aoAnstalld',
          DisplayLabel: 'Attestområde',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAOAnstalld',
          AssociatedComponentName: 'AOAnstalld',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Barn: {
          AssociationName: 'Barn',
          DisplayLabel: 'Barn',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITEDTIBarn',
          AssociatedComponentName: 'Barn',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIArbetspass: {
      CollectionName: 'TIArbetspass',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Arbetspass',
        Abstract: false,
        SOLabel: 'Arbetspass',
        SOGLabel: 'Arbetspass',
        SBLabel: 'Arbetspasset',
        SBGLabel: 'Arbetspasset',
        POLabel: 'Arbetspass',
        POGLabel: 'Arbetspass',
        PBLabel: 'Arbetspassen',
        PBGLabel: 'Arbetspassen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Arbetspasset primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Arbetspasset versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Arbetspasset id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Arbetspasset fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LONEFIL_ID: {
          AttributeName: 'LONEFIL_ID',
          DisplayLabel: 'Löneunderlag',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        ANSTALLD_ID: {
          AttributeName: 'ANSTALLD_ID',
          DisplayLabel: 'Anställd',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FRAN: {
          AttributeName: 'FRAN',
          DisplayLabel: 'Från',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TILL: {
          AttributeName: 'TILL',
          DisplayLabel: 'Till',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Tid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatMinutes',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        anstalldNamnNr: {
          AttributeName: 'anstalldNamnNr',
          DisplayLabel: 'Anställd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        anstalld: {
          AssociationName: 'anstalld',
          DisplayLabel: 'Anställd',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAnstalld',
          AssociatedComponentName: 'Anstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIArbetsuppgift: {
      CollectionName: 'TIArbetsuppgift',
      UDAEnabled: true,
      UDNEnabled: false,
      Properties: new Map([['GroupAssociation', 'tidredovisningsgrupp'], ['USER_DEF_REPORT_ROUTINE', '14009']]),
      RootType: {
        TypeValue: 'Arbetsuppgift',
        Abstract: false,
        SOLabel: 'arbetsuppgift',
        SOGLabel: 'arbetsuppgift',
        SBLabel: 'arbetsuppgiften',
        SBGLabel: 'arbetsuppgiften',
        POLabel: 'arbetsuppgifter',
        POGLabel: 'arbetsuppgifter',
        PBLabel: 'arbetsuppgifterna',
        PBGLabel: 'arbetsuppgifterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'arbetsuppgiften primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'arbetsuppgiften versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'arbetsuppgiften id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'arbetsuppgiften fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TIDGRUPP_ID: {
          AttributeName: 'TIDGRUPP_ID',
          DisplayLabel: 'Tidredovisningsgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UPG_NR: {
          AttributeName: 'UPG_NR',
          DisplayLabel: 'Uppgiftsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 14,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        FAKTSATT_ID: {
          AttributeName: 'FAKTSATT_ID',
          DisplayLabel: 'Typ av fakturering',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTAKT_ID: {
          AttributeName: 'KONTAKT_ID',
          DisplayLabel: 'KONTAKT_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PROJEKT_ID: {
          AttributeName: 'PROJEKT_ID',
          DisplayLabel: 'Projekt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KUND_ID: {
          AttributeName: 'KUND_ID',
          DisplayLabel: 'KUND_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PU_ID: {
          AttributeName: 'PU_ID',
          DisplayLabel: 'PU_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDER_ID: {
          AttributeName: 'ORDER_ID',
          DisplayLabel: 'ORDER_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANSVARIG_ID: {
          AttributeName: 'ANSVARIG_ID',
          DisplayLabel: 'Ansvarig',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TELEFON_KUND: {
          AttributeName: 'TELEFON_KUND',
          DisplayLabel: 'Telefon, kund',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TELEFON_KONTAKT: {
          AttributeName: 'TELEFON_KONTAKT',
          DisplayLabel: 'Kontaktinfo',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Internal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.isnull],
          DefaultCondOperator: T.interval,
        },
        REFERENS_NR: {
          AttributeName: 'REFERENS_NR',
          DisplayLabel: 'Referensnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MAIL_KONTAKT: {
          AttributeName: 'MAIL_KONTAKT',
          DisplayLabel: 'Mail',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.isnull],
          DefaultCondOperator: T.interval,
        },
        STANDIG: {
          AttributeName: 'STANDIG',
          DisplayLabel: 'Ständig',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        REG_ANV_ID: {
          AttributeName: 'REG_ANV_ID',
          DisplayLabel: 'REG_ANV_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REG_TID: {
          AttributeName: 'REG_TID',
          DisplayLabel: 'Registrerad, tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
        },
        RAPPKOD_ID: {
          AttributeName: 'RAPPKOD_ID',
          DisplayLabel: 'Föreslagen Rapporteringskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RAPPKOD2_ID: {
          AttributeName: 'RAPPKOD2_ID',
          DisplayLabel: 'Föreslagen Rapporteringskod 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANVAND_KOD2: {
          AttributeName: 'ANVAND_KOD2',
          DisplayLabel: 'Använd rapporteringskod 2',
          Hint: 'Får anges/Måste anges/Får ej anges',
          DataType: 'Enum',
          EnumValues: new Map([['FAR_ANGES', 'Får anges'], ['MASTE_ANGES', 'Måste anges'], ['FAR_EJ_ANGES', 'Får ej anges']]),
          EnumSortValues: new Map([['FAR_ANGES', 'F'], ['MASTE_ANGES', 'M'], ['FAR_EJ_ANGES', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAR_ANGES=Får anges;MASTE_ANGES=Måste anges;FAR_EJ_ANGES=Får ej anges"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        UTDELAD_TILL_ALLA: {
          AttributeName: 'UTDELAD_TILL_ALLA',
          DisplayLabel: 'Utdelad till alla',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        registreradAvNamn: {
          AttributeName: 'registreradAvNamn',
          DisplayLabel: 'Registrerad av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        projektNrBenamning: {
          AttributeName: 'projektNrBenamning',
          DisplayLabel: 'Projekt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        utdeladTill: {
          AttributeName: 'utdeladTill',
          DisplayLabel: 'Utdelad till',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        kundNamn: {
          AttributeName: 'kundNamn',
          DisplayLabel: 'Kund',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        arbetstid: {
          AttributeName: 'arbetstid',
          DisplayLabel: 'Tid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatMinutes',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ansvarigNamn: {
          AttributeName: 'ansvarigNamn',
          DisplayLabel: 'Ansvarig',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        kundNrNamn: {
          AttributeName: 'kundNrNamn',
          DisplayLabel: 'Kund',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        avslutadTid: {
          AttributeName: 'avslutadTid',
          DisplayLabel: 'Avslutad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        avslutad: {
          AttributeName: 'avslutad',
          DisplayLabel: 'Avslutad',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        kontaktNamn: {
          AttributeName: 'kontaktNamn',
          DisplayLabel: 'Kontakt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.starts,
        },
        nrRubrik: {
          AttributeName: 'nrRubrik',
          DisplayLabel: 'Uppgiftsnummer och rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KBTIIntern: {
          AttributeName: 'KBTIIntern',
          DisplayLabel: 'KBTIIntern',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBTILon: {
          AttributeName: 'KBTILon',
          DisplayLabel: 'KBTILon',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBTIInternKre: {
          AttributeName: 'KBTIInternKre',
          DisplayLabel: 'KBTIInternKre',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        rubrikForslag: {
          AttributeName: 'rubrikForslag',
          DisplayLabel: 'Föreslagen rubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        poborjad: {
          AttributeName: 'poborjad',
          DisplayLabel: 'Påbörjad',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        ansvarigNamnFE: {
          AttributeName: 'ansvarigNamnFE',
          DisplayLabel: 'Ansvarig',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Rapporteringskod2: {
          AttributeName: 'Rapporteringskod2',
          DisplayLabel: 'Rapporteringskod2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BeskrivningSQL: {
          AttributeName: 'BeskrivningSQL',
          DisplayLabel: 'BeskrivningSQL',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KommentarSQL: {
          AttributeName: 'KommentarSQL',
          DisplayLabel: 'KommentarSQL',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        faktureringstypBenamning: {
          AttributeName: 'faktureringstypBenamning',
          DisplayLabel: 'Typ av fakturering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        fakturerasAntal: {
          AttributeName: 'fakturerasAntal',
          DisplayLabel: 'Faktureras',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KOMMENTAR: {
          AttributeName: 'KOMMENTAR',
          DisplayLabel: 'Kommentar',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.isnull],
          DefaultCondOperator: T.contains,
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleKBTIInternKre: {
          AttributeName: 'RuleKBTIInternKre',
          DisplayLabel: 'RuleKBTIInternKre',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAQ_ID: {
          AttributeName: 'FAQ_ID',
          DisplayLabel: 'FAQ, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RegDatum: {
          AttributeName: 'RegDatum',
          DisplayLabel: 'Registrerad, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIArbetsuppgiftBlob',
          AssociatedComponentName: 'ArbetsuppgiftBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        tidredovisningsgrupp: {
          AssociationName: 'tidredovisningsgrupp',
          DisplayLabel: 'Tidredovisningsgrupp',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidGrupp',
          AssociatedComponentName: 'TidGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        kund: {
          AssociationName: 'kund',
          DisplayLabel: 'Kund',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        registreradAv: {
          AssociationName: 'registreradAv',
          DisplayLabel: 'Registrerad av',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        uppgiftIPU: {
          AssociationName: 'uppgiftIPU',
          DisplayLabel: 'UppgiftIPU',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'PUProgramAndring',
          AssociatedComponentName: 'ProgramAndring',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        projekt: {
          AssociationName: 'projekt',
          DisplayLabel: 'Projekt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIProjekt',
          AssociatedComponentName: 'Projekt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        faktureringstyp: {
          AssociationName: 'faktureringstyp',
          DisplayLabel: 'Faktureringstyp',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIFaktureringstyp',
          AssociatedComponentName: 'Faktureringstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        ansvarig: {
          AssociationName: 'ansvarig',
          DisplayLabel: 'Ansvarig',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAnstalld',
          AssociatedComponentName: 'Anstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        TIDINTERN: {
          AssociationName: 'TIDINTERN',
          DisplayLabel: 'Kontering Internbokf, debet',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        TIDLON: {
          AssociationName: 'TIDLON',
          DisplayLabel: 'Kontering Export till löneprogram',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        TIDINTERN_KRE: {
          AssociationName: 'TIDINTERN_KRE',
          DisplayLabel: 'Kontering Internbokf, kredit',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        rapporteringskod: {
          AssociationName: 'rapporteringskod',
          DisplayLabel: 'Rapporteringskod',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIRapporteringskod',
          AssociatedComponentName: 'Rapporteringskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        rapporteringskod2: {
          AssociationName: 'rapporteringskod2',
          DisplayLabel: 'Rapporteringskod 2',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIRapporteringskod2',
          AssociatedComponentName: 'Rapporteringskod2',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        utdeladTill: {
          AssociationName: 'utdeladTill',
          DisplayLabel: 'Utdelningar',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIUtdelatTill',
          AssociatedComponentName: 'UtdelatTill',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        tidrapporteringar: {
          AssociationName: 'tidrapporteringar',
          DisplayLabel: 'Tidrapporteringar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidrapportering',
          AssociatedComponentName: 'Rapportering',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIArbetsuppgiftOLE',
          AssociatedComponentName: 'ArbetsuppgiftOLE',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIArbetsuppgiftBlob: {
      CollectionName: 'TIArbetsuppgiftBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbetsuppgiftBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'TIArbetsuppgiftBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'TIArbetsuppgiftBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'TIArbetsuppgiftBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'TIArbetsuppgiftBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KOMMENTAR: {
          AttributeName: 'KOMMENTAR',
          DisplayLabel: 'Kommentar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    TIAKArbetsuppgift: {
      CollectionName: 'TIAKArbetsuppgift',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AKArbetsuppgift',
        Abstract: false,
        SOLabel: 'Arbetsuppgiftsurval',
        SOGLabel: 'Arbetsuppgiftsurval',
        SBLabel: 'Arbetsuppgiftsurvalet',
        SBGLabel: 'Arbetsuppgiftsurvalet',
        POLabel: 'Arbetsuppgiftsurval',
        POGLabel: 'Arbetsuppgiftsurval',
        PBLabel: 'Arbetsuppgiftsurvalen',
        PBGLabel: 'Arbetsuppgiftsurvalen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Arbetsuppgiftsurvalet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Arbetsuppgiftsurvalet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Arbetsuppgiftsurvalet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTKATEGORI_ID: {
          AttributeName: 'ATTESTKATEGORI_ID',
          DisplayLabel: 'Attestkategori',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        FRAN: {
          AttributeName: 'FRAN',
          DisplayLabel: 'Från',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
        },
        TILL: {
          AttributeName: 'TILL',
          DisplayLabel: 'Till',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    TIAttest: {
      CollectionName: 'TIAttest',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Attest',
        Abstract: false,
        SOLabel: 'Attest',
        SOGLabel: 'Attest',
        SBLabel: 'Attesten',
        SBGLabel: 'Attesten',
        POLabel: 'Attester',
        POGLabel: 'Attester',
        PBLabel: 'Attesterna',
        PBGLabel: 'Attesterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attesten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attesten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Attesten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attesten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TIDRAPPORTERING_ID: {
          AttributeName: 'TIDRAPPORTERING_ID',
          DisplayLabel: 'Tidrapportering',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        ATTESTANT_ID: {
          AttributeName: 'ATTESTANT_ID',
          DisplayLabel: 'Attestant',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ATTESTKATEGORI_ID: {
          AttributeName: 'ATTESTKATEGORI_ID',
          DisplayLabel: 'Attestkategori',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        REG_TID: {
          AttributeName: 'REG_TID',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.interval,
        },
        MEDDELANDE: {
          AttributeName: 'MEDDELANDE',
          DisplayLabel: 'Meddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        BORTTAGEN_MEDDELANDE: {
          AttributeName: 'BORTTAGEN_MEDDELANDE',
          DisplayLabel: 'Borttagen meddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        attestkategoriBenamning: {
          AttributeName: 'attestkategoriBenamning',
          DisplayLabel: 'Attestkategori',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        attestantNameSign: {
          AttributeName: 'attestantNameSign',
          DisplayLabel: 'Attestant',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        attesteradEfter: {
          AttributeName: 'attesteradEfter',
          DisplayLabel: 'Efterföljande attestering',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        attestant: {
          AssociationName: 'attestant',
          DisplayLabel: 'Attestant',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        attestkategori: {
          AssociationName: 'attestkategori',
          DisplayLabel: 'Attestkategori',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAttestkategori',
          AssociatedComponentName: 'Attestkategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIAttestkategori: {
      CollectionName: 'TIAttestkategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '14035']]),
      RootType: {
        TypeValue: 'Attestkategori',
        Abstract: false,
        SOLabel: 'Attestkategori',
        SOGLabel: 'Attestkategori',
        SBLabel: 'Attestkategorin',
        SBGLabel: 'Attestkategorin',
        POLabel: 'Attestkategorier',
        POGLabel: 'Attestkategorier',
        PBLabel: 'Attestkategorierna',
        PBGLabel: 'Attestkategorierna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attestkategorin primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attestkategorin versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attestkategorin fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FOR_LON: {
          AttributeName: 'FOR_LON',
          DisplayLabel: 'Krävs för export till löneprogram',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        FOR_BOKFORING: {
          AttributeName: 'FOR_BOKFORING',
          DisplayLabel: 'Krävs för bokföring',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        FOR_MANADSAVSLUT: {
          AttributeName: 'FOR_MANADSAVSLUT',
          DisplayLabel: 'Krävs för månadsavslut',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        LASER_TIDRAPPORTERING: {
          AttributeName: 'LASER_TIDRAPPORTERING',
          DisplayLabel: 'Låser tidrapporteringar',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        projekturval: {
          AssociationName: 'projekturval',
          DisplayLabel: 'Projekturval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIAKProjekt',
          AssociatedComponentName: 'AKProjekt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        rappkodUrval: {
          AssociationName: 'rappkodUrval',
          DisplayLabel: 'Rapporteringskodsurval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIAKRapporteringskod',
          AssociatedComponentName: 'AKRapporteringskod',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        rappkod2Urval: {
          AssociationName: 'rappkod2Urval',
          DisplayLabel: 'Rapporteringskod2 urval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIAKRapporteringskod2',
          AssociatedComponentName: 'AKRapporteringskod2',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        arbetsuppgiftsurval: {
          AssociationName: 'arbetsuppgiftsurval',
          DisplayLabel: 'Arbetsuppgiftsurval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIAKArbetsuppgift',
          AssociatedComponentName: 'AKArbetsuppgift',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        attestratter: {
          AssociationName: 'attestratter',
          DisplayLabel: 'Attesträtter',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        forberedande: {
          AssociationName: 'forberedande',
          DisplayLabel: 'Förberedande Attestkategori',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIForberedandeAK',
          AssociatedComponentName: 'ForberedandeAK',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIAOAnstalld: {
      CollectionName: 'TIAOAnstalld',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AOAnstalld',
        Abstract: false,
        SOLabel: 'Attestområde/Anställd',
        SOGLabel: 'Attestområde/Anställd',
        SBLabel: 'Attestområde/Anställd',
        SBGLabel: 'Attestområde/Anställd',
        POLabel: 'Attestområde/Anställd',
        POGLabel: 'Attestområde/Anställd',
        PBLabel: 'Attestområde/Anställd',
        PBGLabel: 'Attestområde/Anställd',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attestområde/Anställd primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attestområde/Anställd versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attestområde/Anställd fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTOMRADE_ID: {
          AttributeName: 'ATTESTOMRADE_ID',
          DisplayLabel: 'Attestområde',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ANSTALLD_ID: {
          AttributeName: 'ANSTALLD_ID',
          DisplayLabel: 'Anställd',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        namn: {
          AttributeName: 'namn',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        anstallningsnr: {
          AttributeName: 'anstallningsnr',
          DisplayLabel: 'Anställningsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Attestomrade: {
          AssociationName: 'Attestomrade',
          DisplayLabel: 'Attestområde',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAttestomrade',
          AssociatedComponentName: 'Attestomrade',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
        anstalld: {
          AssociationName: 'anstalld',
          DisplayLabel: 'Anställd',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIAnstalld',
          AssociatedComponentName: 'Anstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIAOAttestratt: {
      CollectionName: 'TIAOAttestratt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AOAttestratt',
        Abstract: false,
        SOLabel: 'Attestområde/Attesträtt',
        SOGLabel: 'Attestområde/Attesträtt',
        SBLabel: 'Attestområde/Attesträtt',
        SBGLabel: 'Attestområde/Attesträtt',
        POLabel: 'Attestområde/Attesträtt',
        POGLabel: 'Attestområde/Attesträtt',
        PBLabel: 'Attestområde/Attesträtt',
        PBGLabel: 'Attestområde/Attesträtt',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attestområde/Attesträtt primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attestområde/Attesträtt versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attestområde/Attesträtt fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTOMRADE_ID: {
          AttributeName: 'ATTESTOMRADE_ID',
          DisplayLabel: 'Attestområde',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ATTESTRATT_ID: {
          AttributeName: 'ATTESTRATT_ID',
          DisplayLabel: 'Attesträtt',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Attestomrade: {
          AssociationName: 'Attestomrade',
          DisplayLabel: 'Attestområde',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAttestomrade',
          AssociatedComponentName: 'Attestomrade',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        attestratt: {
          AssociationName: 'attestratt',
          DisplayLabel: 'Attesträtt',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIAttestomrade: {
      CollectionName: 'TIAttestomrade',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '14036']]),
      RootType: {
        TypeValue: 'Attestomrade',
        Abstract: false,
        SOLabel: 'Attestområde',
        SOGLabel: 'Attestområde',
        SBLabel: 'Attestområdet',
        SBGLabel: 'Attestområdet',
        POLabel: 'Attestområden',
        POGLabel: 'Attestområden',
        PBLabel: 'Attestområdena',
        PBGLabel: 'Attestområdena',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attestområdet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attestområdet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Attestområdet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attestområdet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesHintAttribute', 'Benamning;']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        kodBenamning: {
          AttributeName: 'kodBenamning',
          DisplayLabel: 'kodBenamning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        anstallda: {
          AssociationName: 'anstallda',
          DisplayLabel: 'Anställda',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIAnstalld',
          AssociatedComponentName: 'Anstalld',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        attestratter: {
          AssociationName: 'attestratter',
          DisplayLabel: 'Attesträtter',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        aoAnstalld: {
          AssociationName: 'aoAnstalld',
          DisplayLabel: 'Anställda',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIAOAnstalld',
          AssociatedComponentName: 'AOAnstalld',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        aoAttestratt: {
          AssociationName: 'aoAttestratt',
          DisplayLabel: 'Attesträtter',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAOAttestratt',
          AssociatedComponentName: 'AOAttestratt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIAttestratt: {
      CollectionName: 'TIAttestratt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Attestratt',
        Abstract: false,
        SOLabel: 'Attesträtt',
        SOGLabel: 'Attesträtt',
        SBLabel: 'Attesträtten',
        SBGLabel: 'Attesträtten',
        POLabel: 'Attesträtter',
        POGLabel: 'Attesträtter',
        PBLabel: 'Attesträtterna',
        PBGLabel: 'Attesträtterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Attesträtten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Attesträtten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Attesträtten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FRAN: {
          AttributeName: 'FRAN',
          DisplayLabel: 'Från datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        TILL: {
          AttributeName: 'TILL',
          DisplayLabel: 'Till datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ATTESTKATEGORI_ID: {
          AttributeName: 'ATTESTKATEGORI_ID',
          DisplayLabel: 'Attestkategori',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ATTESTOMRADE_ID: {
          AttributeName: 'ATTESTOMRADE_ID',
          DisplayLabel: 'Attestområde',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användare',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        EGEN_TID: {
          AttributeName: 'EGEN_TID',
          DisplayLabel: 'Attest av egen tid',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        SUMMERING1: {
          AttributeName: 'SUMMERING1',
          DisplayLabel: 'Summering 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUMMERING2: {
          AttributeName: 'SUMMERING2',
          DisplayLabel: 'Summering 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EDITERA: {
          AttributeName: 'EDITERA',
          DisplayLabel: 'Särskilt ändringsformulär',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        EJ_RAPPORTERADE_DAGAR: {
          AttributeName: 'EJ_RAPPORTERADE_DAGAR',
          DisplayLabel: 'Visa även ej rapporterade dagar',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        attestomradeBenamning: {
          AttributeName: 'attestomradeBenamning',
          DisplayLabel: 'Attestområde',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        anvandareNameSign: {
          AttributeName: 'anvandareNameSign',
          DisplayLabel: 'Användare',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        attestkategoriBenamning: {
          AttributeName: 'attestkategoriBenamning',
          DisplayLabel: 'Attestkategoribenämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        anstalld_id: {
          AttributeName: 'anstalld_id',
          DisplayLabel: 'Anställd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        anvandare: {
          AssociationName: 'anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        attestkategori: {
          AssociationName: 'attestkategori',
          DisplayLabel: 'Attestkategori',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAttestkategori',
          AssociatedComponentName: 'Attestkategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        anstalld: {
          AssociationName: 'anstalld',
          DisplayLabel: 'Anställd',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIAnstalld',
          AssociatedComponentName: 'Anstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        aoAttestratt: {
          AssociationName: 'aoAttestratt',
          DisplayLabel: 'Attestområde',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAOAttestratt',
          AssociatedComponentName: 'AOAttestratt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIAtteststatus: {
      CollectionName: 'TIAtteststatus',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Atteststatus',
        Abstract: false,
        SOLabel: 'Atteststatus',
        SOGLabel: 'Atteststatus',
        SBLabel: 'Atteststatus',
        SBGLabel: 'Atteststatus',
        POLabel: 'Atteststatus',
        POGLabel: 'Atteststatus',
        PBLabel: 'Atteststatus',
        PBGLabel: 'Atteststatus',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Atteststatus primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Atteststatus versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Atteststatus id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Atteststatus fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TIDRAPPORTERING_ID: {
          AttributeName: 'TIDRAPPORTERING_ID',
          DisplayLabel: 'Tidrapportering',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        ATTESTKATEGORI_ID: {
          AttributeName: 'ATTESTKATEGORI_ID',
          DisplayLabel: 'Attestkategori',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ATTESTKATEGORI_BENAMNING: {
          AttributeName: 'ATTESTKATEGORI_BENAMNING',
          DisplayLabel: 'Attestkategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
        },
        ATTEST_TEXT: {
          AttributeName: 'ATTEST_TEXT',
          DisplayLabel: 'Attest',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
        },
        ATTEST_ID: {
          AttributeName: 'ATTEST_ID',
          DisplayLabel: 'Attest',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Attesterad: {
          AttributeName: 'Attesterad',
          DisplayLabel: 'Attesterad',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        attest: {
          AssociationName: 'attest',
          DisplayLabel: 'Attest',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAttest',
          AssociatedComponentName: 'Attest',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestkategori: {
          AssociationName: 'Attestkategori',
          DisplayLabel: 'Attestkategori',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAttestkategori',
          AssociatedComponentName: 'Attestkategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    TITEDTIBarn: {
      CollectionName: 'TITEDTIBarn',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Barn',
        Abstract: false,
        SOLabel: 'Barn',
        SOGLabel: 'Barn',
        SBLabel: 'Barnet',
        SBGLabel: 'Barnet',
        POLabel: 'Barn',
        POGLabel: 'Barn',
        PBLabel: 'Barnen',
        PBGLabel: 'Barnen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Barnet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Barnet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Barnet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Barnet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANSTALLD_ID: {
          AttributeName: 'ANSTALLD_ID',
          DisplayLabel: 'ANSTALLD_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        PERS_NR: {
          AttributeName: 'PERS_NR',
          DisplayLabel: 'Personnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Internal',
          Formatter: 'TEDFormatPersNr',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Barn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        namnNr: {
          AttributeName: 'namnNr',
          DisplayLabel: 'Namn och personnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Anstalld: {
          AssociationName: 'Anstalld',
          DisplayLabel: 'Anställd',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAnstalld',
          AssociatedComponentName: 'Anstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIDag: {
      CollectionName: 'TIDag',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Dag',
        Abstract: false,
        SOLabel: 'Dag',
        SOGLabel: 'Dag',
        SBLabel: 'Dagen',
        SBGLabel: 'Dagen',
        POLabel: 'Dagar',
        POGLabel: 'Dagar',
        PBLabel: 'Dagarna',
        PBGLabel: 'Dagarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dagen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dagen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Dagen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dagen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.interval,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        DAG_TYP: {
          AttributeName: 'DAG_TYP',
          DisplayLabel: 'Markering',
          Hint: 'Normal/Ledig/Avkortad',
          DataType: 'Enum',
          EnumValues: new Map([['NORMAL', 'Normal'], ['LEDIG', 'Ledig'], ['AVKORTAD', 'Avkortad']]),
          EnumSortValues: new Map([['NORMAL', 'N'], ['LEDIG', 'L'], ['AVKORTAD', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NORMAL=Normal;LEDIG=Ledig;AVKORTAD=Avkortad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        DAGSCHEMA_ID: {
          AttributeName: 'DAGSCHEMA_ID',
          DisplayLabel: 'Dagschema',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HELGDAG: {
          AttributeName: 'HELGDAG',
          DisplayLabel: 'Helgdagsnamn',
          Hint: 'Helgdagens namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        arbetstid: {
          AttributeName: 'arbetstid',
          DisplayLabel: 'Arbetstidsmått',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
          FormatterParseParams: 'ValidTimeSeps=":. ;"',
          FormatterDisplayParams: 'ShowZeroAsBlank="Y"',
        },
        veckodag: {
          AttributeName: 'veckodag',
          DisplayLabel: 'Veckodag',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        calcHelgdag: {
          AttributeName: 'calcHelgdag',
          DisplayLabel: 'Helgdag',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        veckodagSql: {
          AttributeName: 'veckodagSql',
          DisplayLabel: 'Veckodag',
          Hint: 'Måndag/Tisdag/Onsdag/Torsdag/Fredag/Lördag/Söndag',
          DataType: 'Enum',
          EnumValues: new Map([['MANDAG', 'Måndag'], ['TISDAG', 'Tisdag'], ['ONSDAG', 'Onsdag'], ['TORSDAG', 'Torsdag'], ['FREDAG', 'Fredag'], ['LORDAG', 'Lördag'], ['SONDAG', 'Söndag']]),
          EnumSortValues: new Map([['MANDAG', '2'], ['TISDAG', '3'], ['ONSDAG', '4'], ['TORSDAG', '5'], ['FREDAG', '6'], ['LORDAG', '7'], ['SONDAG', '1']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MANDAG=Måndag;TISDAG=Tisdag;ONSDAG=Onsdag;TORSDAG=Torsdag;FREDAG=Fredag;LORDAG=Lördag;SONDAG=Söndag"',
          InterfaceType: 'ifChecklist',
        },
        ar: {
          AttributeName: 'ar',
          DisplayLabel: 'År',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        arbetstidEjNoll: {
          AttributeName: 'arbetstidEjNoll',
          DisplayLabel: 'Arbetstid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
          FormatterParseParams: 'ValidTimeSeps=":. ;"',
          FormatterDisplayParams: 'ShowZeroAsBlank="Y"',
        },
        arHelgdag: {
          AttributeName: 'arHelgdag',
          DisplayLabel: 'Helgdag',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        dagschemaBenamning: {
          AttributeName: 'dagschemaBenamning',
          DisplayLabel: 'Dagschema',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        veckonr: {
          AttributeName: 'veckonr',
          DisplayLabel: 'Veckonummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        dagForeHelgdag: {
          AttributeName: 'dagForeHelgdag',
          DisplayLabel: 'Dag före helgdag',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        dagDatum: {
          AttributeName: 'dagDatum',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTimeGeneral',
          FormatterParseParams: 'AllowIncomplete="Y"',
          FormatterDisplayParams: 'Format="d\'/\'m"',
        },
        dagVeckodag: {
          AttributeName: 'dagVeckodag',
          DisplayLabel: 'Veckodag',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTime',
          FormatterParseParams: 'AllowIncomplete="Y"',
          FormatterDisplayParams: 'Format="ddd"',
        },
        dagschemaTidText: {
          AttributeName: 'dagschemaTidText',
          DisplayLabel: 'Tider',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        dagschemaFranTill: {
          AttributeName: 'dagschemaFranTill',
          DisplayLabel: 'Tider',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        kalenderHelgdag: {
          AttributeName: 'kalenderHelgdag',
          DisplayLabel: 'Helgdag',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        schemaVeckonr: {
          AttributeName: 'schemaVeckonr',
          DisplayLabel: 'Schemats vecka',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VeckodagHelNamn: {
          AttributeName: 'VeckodagHelNamn',
          DisplayLabel: 'Veckodag',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Veckoschema: {
          AssociationName: 'Veckoschema',
          DisplayLabel: 'Veckoschema',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIVeckoschema',
          AssociatedComponentName: 'Veckoschema',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        dagschema: {
          AssociationName: 'dagschema',
          DisplayLabel: 'Dagschema',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIDagSchema',
          AssociatedComponentName: 'Dagschema',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        dagAnstalld: {
          AssociationName: 'dagAnstalld',
          DisplayLabel: 'Dagrapporteringar',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIDagAnstalld',
          AssociatedComponentName: 'DagAnstalld',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIDagAnstalld: {
      CollectionName: 'TIDagAnstalld',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['GroupAssociation', 'tidGrupp']]),
      RootType: {
        TypeValue: 'DagAnstalld',
        Abstract: false,
        SOLabel: 'Dagrapportering',
        SOGLabel: 'Dagrapportering',
        SBLabel: 'Dagrapporteringen',
        SBGLabel: 'Dagrapporteringen',
        POLabel: 'Dagrapporteringar',
        POGLabel: 'Dagrapporteringar',
        PBLabel: 'Dagrapporteringarna',
        PBGLabel: 'Dagrapporteringarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dagrapporteringen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dagrapporteringen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Dagrapporteringen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dagrapporteringen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        AVSLUTAD: {
          AttributeName: 'AVSLUTAD',
          DisplayLabel: 'Avslutad',
          Hint: 'Avslutad/Ej Avslutad',
          DataType: 'Enum',
          EnumValues: new Map([['AVSLUTAD', 'Avslutad'], ['EJ_AVSLUTAD', 'Ej Avslutad']]),
          EnumSortValues: new Map([['AVSLUTAD', 'Y'], ['EJ_AVSLUTAD', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AVSLUTAD=Avslutad;EJ_AVSLUTAD=Ej Avslutad"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        SCHEMA_ID: {
          AttributeName: 'SCHEMA_ID',
          DisplayLabel: 'Schema',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Veckodag: {
          AttributeName: 'Veckodag',
          DisplayLabel: 'Dag',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        anstalldNamn: {
          AttributeName: 'anstalldNamn',
          DisplayLabel: 'Anställd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        rapporteradTid: {
          AttributeName: 'rapporteradTid',
          DisplayLabel: 'Tid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatMinutes',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        rapporteratFran: {
          AttributeName: 'rapporteratFran',
          DisplayLabel: 'Fråntid',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tider',
        },
        rapporteratTill: {
          AttributeName: 'rapporteratTill',
          DisplayLabel: 'Tilltid',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tider',
        },
        dagArbetstid: {
          AttributeName: 'dagArbetstid',
          DisplayLabel: 'Arbetstidsmått',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        manadAvslutad: {
          AttributeName: 'manadAvslutad',
          DisplayLabel: 'Månad avslutad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        anstalldGrupp: {
          AttributeName: 'anstalldGrupp',
          DisplayLabel: 'Grupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        tidgrupp: {
          AttributeName: 'tidgrupp',
          DisplayLabel: 'Grupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        debiteradTid: {
          AttributeName: 'debiteradTid',
          DisplayLabel: 'Faktureras, antal',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
        },
        arbetstid: {
          AttributeName: 'arbetstid',
          DisplayLabel: 'Tid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatMinutes',
          FormatterParseParams: 'ValidTimeSeps=":. ;"',
          FormatterDisplayParams: 'ShowZeroAsBlank="Y"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tider',
        },
        rapporteringar: {
          AttributeName: 'rapporteringar',
          DisplayLabel: 'Rapporteringar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        dagTyp: {
          AttributeName: 'dagTyp',
          DisplayLabel: 'dagTyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterParseParams: 'TranslateValues=""',
          FormatterDisplayParams: 'TranslateValues=""',
          FormatterValidateParams: 'ValidValues=""',
        },
        markeradKod: {
          AttributeName: 'markeradKod',
          DisplayLabel: 'markeradKod',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        rast1Stamplad: {
          AttributeName: 'rast1Stamplad',
          DisplayLabel: 'Har stämplat rast 1',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        rast2Stamplad: {
          AttributeName: 'rast2Stamplad',
          DisplayLabel: 'Har stämplat rast 2',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        rast3Stamplad: {
          AttributeName: 'rast3Stamplad',
          DisplayLabel: 'Har stämplat rast 3',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        varningsbeskrivning: {
          AttributeName: 'varningsbeskrivning',
          DisplayLabel: 'Varningsbeskrivning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        varningMinstaRast: {
          AttributeName: 'varningMinstaRast',
          DisplayLabel: 'Mindre än minsta rast',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        typAvRapporteringar: {
          AttributeName: 'typAvRapporteringar',
          DisplayLabel: 'Typ av rapporteringar',
          Hint: 'Registrerad/Instämplad/Registrerad och instämplad/Saknar tidrapporteringar',
          DataType: 'Enum',
          EnumValues: new Map([['REGISTRERAD', 'Registrerad'], ['INSTAMPLAD', 'Instämplad'], ['REGISTRERAD_OCH_INSTAMPLAD', 'Registrerad och instämplad'], ['SAKNAR_TIDRAPPORTERINGAR', 'Saknar tidrapporteringar']]),
          EnumSortValues: new Map([['REGISTRERAD', 'E'], ['INSTAMPLAD', 'I'], ['REGISTRERAD_OCH_INSTAMPLAD', 'B'], ['SAKNAR_TIDRAPPORTERINGAR', 'U']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="REGISTRERAD=Registrerad;INSTAMPLAD=Instämplad;REGISTRERAD_OCH_INSTAMPLAD=Registrerad och instämplad;SAKNAR_TIDRAPPORTERINGAR=Saknar tidrapporteringar"',
          InterfaceType: 'ifChecklist',
        },
        flextid: {
          AttributeName: 'flextid',
          DisplayLabel: 'Flextid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
          FormatterParseParams: 'ValidTimeSeps=":. ;"',
          FormatterDisplayParams: 'ShowZeroAsBlank="Y"',
        },
        kvarAttFordela: {
          AttributeName: 'kvarAttFordela',
          DisplayLabel: 'Arbetstid kvar att fördela',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatMinutes',
          FormatterParseParams: 'ValidTimeSeps=":. ;"',
          FormatterDisplayParams: 'ShowZeroAsBlank="Y"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        attFordela: {
          AttributeName: 'attFordela',
          DisplayLabel: 'Att fördela',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
          FormatterParseParams: 'ValidTimeSeps=":. ;"',
          FormatterDisplayParams: 'ShowZeroAsBlank="Y"',
        },
        attFordelaTillDatum: {
          AttributeName: 'attFordelaTillDatum',
          DisplayLabel: 'Att fördela t.o.m. datum',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        kvarAttFordelaTillDatum: {
          AttributeName: 'kvarAttFordelaTillDatum',
          DisplayLabel: 'Kvar att fördela t.o.m. datum',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        fordelatTillDatum: {
          AttributeName: 'fordelatTillDatum',
          DisplayLabel: 'Fördelat t.o.m. datum',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        fordelningState: {
          AttributeName: 'fordelningState',
          DisplayLabel: 'fordelningState',
          Hint: 'Senare/Registreringsdatum/Fördelad/Aktuell period',
          DataType: 'Enum',
          EnumValues: new Map([['SENARE', 'Senare'], ['REGISTRERINGSDATUM', 'Registreringsdatum'], ['FORDELAD', 'Fördelad'], ['AKTUELL_PERIOD', 'Aktuell period']]),
          EnumSortValues: new Map([['SENARE', 'S'], ['REGISTRERINGSDATUM', 'R'], ['FORDELAD', 'F'], ['AKTUELL_PERIOD', 'A']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SENARE=Senare;REGISTRERINGSDATUM=Registreringsdatum;FORDELAD=Fördelad;AKTUELL_PERIOD=Aktuell period"',
          AttributeParams: {'reg_datum': {type: 'Date', defaultValue: ''}},
        },
        rapporteringskoder: {
          AttributeName: 'rapporteringskoder',
          DisplayLabel: 'Rapporteringskoder',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        fordelningsDag: {
          AttributeName: 'fordelningsDag',
          DisplayLabel: 'Fördelningsdag',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeParams: {'period': {type: 'String', defaultValue: ''}},
        },
        fordelat: {
          AttributeName: 'fordelat',
          DisplayLabel: 'Fördelat',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
          FormatterParseParams: 'ValidTimeSeps=":. ;"',
          FormatterDisplayParams: 'ShowZeroAsBlank="Y"',
        },
        kvarIPeriod: {
          AttributeName: 'kvarIPeriod',
          DisplayLabel: 'Kvar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
          FormatterParseParams: 'ValidTimeSeps=":. ;"',
          FormatterDisplayParams: 'ShowZeroAsBlank="Y"',
          AttributeParams: {'period': {type: 'String', defaultValue: ''}},
        },
        normalTid: {
          AttributeName: 'normalTid',
          DisplayLabel: 'normalTid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
          FormatterParseParams: 'ValidTimeSeps=":. ;"',
          FormatterDisplayParams: 'ShowZeroAsBlank="Y"',
        },
        dagDagschemaId: {
          AttributeName: 'dagDagschemaId',
          DisplayLabel: 'dagDagschemaId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        dagDatum: {
          AttributeName: 'dagDatum',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTimeGeneral',
          FormatterParseParams: 'AllowIncomplete="Y"',
          FormatterDisplayParams: 'Format="d\'/\'m"',
        },
        dagVeckodag: {
          AttributeName: 'dagVeckodag',
          DisplayLabel: 'Veckodag',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTimeGeneral',
          FormatterParseParams: 'AllowIncomplete="Y"',
          FormatterDisplayParams: 'Format="ddd"',
        },
        schemaOchDagschema: {
          AttributeName: 'schemaOchDagschema',
          DisplayLabel: 'Schema',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LunchEjRapp: {
          AttributeName: 'LunchEjRapp',
          DisplayLabel: 'Lunch ej rapporterad för anställd',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        redigeraText: {
          AttributeName: 'redigeraText',
          DisplayLabel: 'redigeraText',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSTIDSFAKTOR: {
          AttributeName: 'ARBETSTIDSFAKTOR',
          DisplayLabel: 'Arbetstidsfaktor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SEMESTERFAKTOR: {
          AttributeName: 'SEMESTERFAKTOR',
          DisplayLabel: 'Semesterfaktor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VeckodagSort: {
          AttributeName: 'VeckodagSort',
          DisplayLabel: 'Dag',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        dag: {
          AssociationName: 'dag',
          DisplayLabel: 'Schemadag',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIDag',
          AssociatedComponentName: 'Dag',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        anstalld: {
          AssociationName: 'anstalld',
          DisplayLabel: 'Anställd',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAnstalld',
          AssociatedComponentName: 'Anstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        manad: {
          AssociationName: 'manad',
          DisplayLabel: 'Månadsrapportering',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIManAnstalld',
          AssociatedComponentName: 'ManAnstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        tidGrupp: {
          AssociationName: 'tidGrupp',
          DisplayLabel: 'Tidredovisningsgrupp',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidGrupp',
          AssociatedComponentName: 'TidGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        veckoschema: {
          AssociationName: 'veckoschema',
          DisplayLabel: 'Schema',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIVeckoschema',
          AssociatedComponentName: 'Veckoschema',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        dagraportering: {
          AssociationName: 'dagraportering',
          DisplayLabel: 'Tidrapportering',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidrapportering',
          AssociatedComponentName: 'RapporteringOchRast',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIDagSchema: {
      CollectionName: 'TIDagSchema',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '14020']]),
      RootType: {
        TypeValue: 'Dagschema',
        Abstract: false,
        SOLabel: 'Dagschema',
        SOGLabel: 'Dagschema',
        SBLabel: 'Dagschemat',
        SBGLabel: 'Dagschemat',
        POLabel: 'Dagschema',
        POGLabel: 'Dagschema',
        PBLabel: 'Dagscheman',
        PBGLabel: 'Dagscheman',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dagschemat primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dagschemat versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Dagschemat id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dagschemat fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        DAG_FRAN: {
          AttributeName: 'DAG_FRAN',
          DisplayLabel: 'Normalarbetstid, från',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tider',
        },
        DAG_FRAN_FLEX1: {
          AttributeName: 'DAG_FRAN_FLEX1',
          DisplayLabel: 'Flextid från, fr.o.m.',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tider',
        },
        DAG_FRAN_FLEX2: {
          AttributeName: 'DAG_FRAN_FLEX2',
          DisplayLabel: 'Flextid från, t.o.m.',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tider',
        },
        DAG_TILL: {
          AttributeName: 'DAG_TILL',
          DisplayLabel: 'Normalarbetstid, till',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tider',
        },
        DAG_TILL_FLEX1: {
          AttributeName: 'DAG_TILL_FLEX1',
          DisplayLabel: 'Flextid till, fr.o.m.',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tider',
        },
        DAG_TILL_FLEX2: {
          AttributeName: 'DAG_TILL_FLEX2',
          DisplayLabel: 'Flextid till, t.o.m.',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tider',
        },
        RAST1: {
          AttributeName: 'RAST1',
          DisplayLabel: 'Rast 1',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Rast 1',
        },
        RAST1_BENAMNING: {
          AttributeName: 'RAST1_BENAMNING',
          DisplayLabel: 'Rast 1, benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 1',
        },
        RAST1_FRAN: {
          AttributeName: 'RAST1_FRAN',
          DisplayLabel: 'Rast 1, från',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 1',
        },
        RAST1_TILL: {
          AttributeName: 'RAST1_TILL',
          DisplayLabel: 'Rast 1, till',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 1',
        },
        RAST1_FLEX_FRAN: {
          AttributeName: 'RAST1_FLEX_FRAN',
          DisplayLabel: 'Rast 1, flextid från',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 1',
        },
        RAST1_FLEX_TILL: {
          AttributeName: 'RAST1_FLEX_TILL',
          DisplayLabel: 'Rast 1, flextid till',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 1',
        },
        RAST1_MIN: {
          AttributeName: 'RAST1_MIN',
          DisplayLabel: 'Rast 1, minsta tid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="600"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 1',
        },
        RAST2: {
          AttributeName: 'RAST2',
          DisplayLabel: 'Rast 2',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Rast 2',
        },
        RAST2_BENAMNING: {
          AttributeName: 'RAST2_BENAMNING',
          DisplayLabel: 'Rast 2, benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 2',
        },
        RAST2_FRAN: {
          AttributeName: 'RAST2_FRAN',
          DisplayLabel: 'Rast 2, från',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 2',
        },
        RAST2_TILL: {
          AttributeName: 'RAST2_TILL',
          DisplayLabel: 'Rast 2, till',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 2',
        },
        RAST2_FLEX_FRAN: {
          AttributeName: 'RAST2_FLEX_FRAN',
          DisplayLabel: 'Rast 2, flextid från',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 2',
        },
        RAST2_FLEX_TILL: {
          AttributeName: 'RAST2_FLEX_TILL',
          DisplayLabel: 'Rast 2, flextid till',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 2',
        },
        RAST2_MIN: {
          AttributeName: 'RAST2_MIN',
          DisplayLabel: 'Rast 2, minsta tid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="600"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 2',
        },
        RAST3: {
          AttributeName: 'RAST3',
          DisplayLabel: 'Rast 3',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Rast 3',
        },
        RAST3_BENAMNING: {
          AttributeName: 'RAST3_BENAMNING',
          DisplayLabel: 'Rast 3, benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 3',
        },
        RAST3_FRAN: {
          AttributeName: 'RAST3_FRAN',
          DisplayLabel: 'Rast 3, från',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 3',
        },
        RAST3_TILL: {
          AttributeName: 'RAST3_TILL',
          DisplayLabel: 'Rast 3, till',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 3',
        },
        RAST3_FLEX_FRAN: {
          AttributeName: 'RAST3_FLEX_FRAN',
          DisplayLabel: 'Rast 3, flextid från',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 3',
        },
        RAST3_FLEX_TILL: {
          AttributeName: 'RAST3_FLEX_TILL',
          DisplayLabel: 'Rast 3, flextid till',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 3',
        },
        RAST3_MIN: {
          AttributeName: 'RAST3_MIN',
          DisplayLabel: 'Rast 3, minsta tid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="600"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Rast 3',
        },
        FLEX: {
          AttributeName: 'FLEX',
          DisplayLabel: 'Flextid',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        FLEX_RAST1: {
          AttributeName: 'FLEX_RAST1',
          DisplayLabel: 'Rast 1, flextid',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Rast 1',
        },
        FLEX_RAST2: {
          AttributeName: 'FLEX_RAST2',
          DisplayLabel: 'Rast 2, flextid',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Rast 2',
        },
        FLEX_RAST3: {
          AttributeName: 'FLEX_RAST3',
          DisplayLabel: 'Rast 3, flextid',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Rast 3',
        },
        ARBETSTID: {
          AttributeName: 'ARBETSTID',
          DisplayLabel: 'Arbetstidsmått',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatMinutes',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        LOKAL: {
          AttributeName: 'LOKAL',
          DisplayLabel: 'Lokal',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        SKAPAD_FRAN: {
          AttributeName: 'SKAPAD_FRAN',
          DisplayLabel: 'SKAPAD_FRAN',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        calcArbetstid: {
          AttributeName: 'calcArbetstid',
          DisplayLabel: 'Arbetstidsmått',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        calcArbetstid2: {
          AttributeName: 'calcArbetstid2',
          DisplayLabel: 'Arbetstidsmått',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        tidText: {
          AttributeName: 'tidText',
          DisplayLabel: 'Tider',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Noteringar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        skapadFran: {
          AssociationName: 'skapadFran',
          DisplayLabel: 'Skapad Från',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIDagSchema',
          AssociatedComponentName: 'DagSchema',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        dag: {
          AssociationName: 'dag',
          DisplayLabel: 'Schemadag',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIDag',
          AssociatedComponentName: 'Dag',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIArbetsuppgiftOLE: {
      CollectionName: 'TIArbetsuppgiftOLE',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'ArbetsuppgiftOLE',
        Abstract: false,
        SOLabel: 'Dokument',
        SOGLabel: 'Dokument',
        SBLabel: 'Dokumentet',
        SBGLabel: 'Dokumentet',
        POLabel: 'Dokument',
        POGLabel: 'Dokument',
        PBLabel: 'Dokumenten',
        PBGLabel: 'Dokumenten',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokumentet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokumentet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Dokumentet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokumentet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.starts,
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filtillägg',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OLECLASSNAME: {
          AttributeName: 'OLECLASSNAME',
          DisplayLabel: 'OLE klassnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BINARDATA: {
          AttributeName: 'BINARDATA',
          DisplayLabel: 'Dokument',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BinarDataSize: {
          AttributeName: 'BinarDataSize',
          DisplayLabel: 'BlobStorlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ApplicationIdentifier: {
          AttributeName: 'ApplicationIdentifier',
          DisplayLabel: 'Applikation',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FileIdentifier: {
          AttributeName: 'FileIdentifier',
          DisplayLabel: 'Filidentifikation',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Arbetsuppgift: {
          AssociationName: 'Arbetsuppgift',
          DisplayLabel: 'Arbetsuppgift',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIArbetsuppgift',
          AssociatedComponentName: 'Arbetsuppgift',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIEnhet: {
      CollectionName: 'TIEnhet',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Enhet',
        Abstract: false,
        SOLabel: 'Enhet',
        SOGLabel: 'Enhet',
        SBLabel: 'Enheten',
        SBGLabel: 'Enheten',
        POLabel: 'Enheter',
        POGLabel: 'Enheter',
        PBLabel: 'Enheterna',
        PBGLabel: 'Enheterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Enheten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Enheten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Enheten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Enheten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ENHET: {
          AttributeName: 'ENHET',
          DisplayLabel: 'Enhet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ENHETSTYP: {
          AttributeName: 'ENHETSTYP',
          DisplayLabel: 'Typ',
          Hint: 'Min/St',
          DataType: 'Enum',
          EnumValues: new Map([['MIN', 'Min'], ['ST', 'St']]),
          EnumSortValues: new Map([['MIN', 'M'], ['ST', 'S']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MIN=Min;ST=St"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    TIFaktureringstyp: {
      CollectionName: 'TIFaktureringstyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '14001']]),
      RootType: {
        TypeValue: 'Faktureringstyp',
        Abstract: false,
        SOLabel: 'Faktureringstyp',
        SOGLabel: 'Faktureringstyp',
        SBLabel: 'Faktureringstypen',
        SBGLabel: 'Faktureringstypen',
        POLabel: 'Fakureringstyper',
        POGLabel: 'Fakureringstyper',
        PBLabel: 'Faktureringstyperna',
        PBGLabel: 'Faktureringstyperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Faktureringstypen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Faktureringstypen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Faktureringstypen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Faktureringstypen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.interval, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        FORDEFINERAD: {
          AttributeName: 'FORDEFINERAD',
          DisplayLabel: 'Fördefinerad',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        STANDARD: {
          AttributeName: 'STANDARD',
          DisplayLabel: 'Föreslagen faktureringstyp',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        standardText: {
          AttributeName: 'standardText',
          DisplayLabel: 'standardText',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    TIForberedandeAK: {
      CollectionName: 'TIForberedandeAK',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ForberedandeAK',
        Abstract: false,
        SOLabel: 'Föberedande attestkategori',
        SOGLabel: 'Föberedande attestkategori',
        SBLabel: 'Förberedande attestkategorien',
        SBGLabel: 'Förberedande attestkategorien',
        POLabel: 'Förberedande attestkategorier',
        POGLabel: 'Förberedande attestkategorier',
        PBLabel: 'Förberedande attestkategorierna',
        PBGLabel: 'Förberedande attestkategorierna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Förberedande attestkategorien primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Förberedande attestkategorien versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Förberedande attestkategorien fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTKATEGORI_ID: {
          AttributeName: 'ATTESTKATEGORI_ID',
          DisplayLabel: 'Attestkategori',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        FORBEREDANDE: {
          AttributeName: 'FORBEREDANDE',
          DisplayLabel: 'Förberedande attestkategori',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        attestkategoriBenamning: {
          AttributeName: 'attestkategoriBenamning',
          DisplayLabel: 'Attestkategori',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        forberedandeBenamning: {
          AttributeName: 'forberedandeBenamning',
          DisplayLabel: 'Förberedande attestkategori',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        attestkategori: {
          AssociationName: 'attestkategori',
          DisplayLabel: 'Attestkategori',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAttestkategori',
          AssociatedComponentName: 'Attestkategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        forberedandeAttestkategori: {
          AssociationName: 'forberedandeAttestkategori',
          DisplayLabel: 'Förberedande attestkategori',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAttestkategori',
          AssociatedComponentName: 'Attestkategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TITEDTIGrunddata: {
      CollectionName: 'TITEDTIGrunddata',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Grunddata',
        Abstract: false,
        SOLabel: 'Grunddata',
        SOGLabel: 'Grunddata',
        SBLabel: 'Grunddatat',
        SBGLabel: 'Grunddatat',
        POLabel: 'Grunddata',
        POGLabel: 'Grunddata',
        PBLabel: 'Grunddatan',
        PBGLabel: 'Grunddatan',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Grunddatat primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Grunddatat versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Grunddatat id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Grunddatat fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SCHEMA_ID: {
          AttributeName: 'SCHEMA_ID',
          DisplayLabel: 'SCHEMA_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ORDNINGSNR: {
          AttributeName: 'ORDNINGSNR',
          DisplayLabel: 'Ordningsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          Required: true,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Grundschema/Veckodag/Byt dagschema/Dagar/Datum',
          DataType: 'Enum',
          EnumValues: new Map([['GRUNDSCHEMA', 'Grundschema'], ['VECKODAG', 'Veckodag'], ['BYT_DAGSCHEMA', 'Byt dagschema'], ['DAGAR', 'Dagar'], ['DATUM', 'Datum']]),
          EnumSortValues: new Map([['GRUNDSCHEMA', 'U'], ['VECKODAG', 'V'], ['BYT_DAGSCHEMA', 'B'], ['DAGAR', 'D'], ['DATUM', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GRUNDSCHEMA=Grundschema;VECKODAG=Veckodag;BYT_DAGSCHEMA=Byt dagschema;DAGAR=Dagar;DATUM=Datum"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        VECKA: {
          AttributeName: 'VECKA',
          DisplayLabel: 'Vecka',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        SASONG_ID: {
          AttributeName: 'SASONG_ID',
          DisplayLabel: 'SASONG_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        UTGA_FRAN_SCHEMA_ID: {
          AttributeName: 'UTGA_FRAN_SCHEMA_ID',
          DisplayLabel: 'UTGA_FRAN_SCHEMA_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        MAN_DAGSCHEMA_ID: {
          AttributeName: 'MAN_DAGSCHEMA_ID',
          DisplayLabel: 'MAN_DAGSCHEMA_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        TIS_DAGSCHEMA_ID: {
          AttributeName: 'TIS_DAGSCHEMA_ID',
          DisplayLabel: 'TIS_DAGSCHEMA_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        ONS_DAGSCHEMA_ID: {
          AttributeName: 'ONS_DAGSCHEMA_ID',
          DisplayLabel: 'ONS_DAGSCHEMA_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        TOR_DAGSCHEMA_ID: {
          AttributeName: 'TOR_DAGSCHEMA_ID',
          DisplayLabel: 'TOR_DAGSCHEMA_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        FRE_DAGSCHEMA_ID: {
          AttributeName: 'FRE_DAGSCHEMA_ID',
          DisplayLabel: 'FRE_DAGSCHEMA_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        LOR_DAGSCHEMA_ID: {
          AttributeName: 'LOR_DAGSCHEMA_ID',
          DisplayLabel: 'LOR_DAGSCHEMA_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        SON_DAGSCHEMA_ID: {
          AttributeName: 'SON_DAGSCHEMA_ID',
          DisplayLabel: 'SON_DAGSCHEMA_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        ANVAND_PA_HELGDAGAR: {
          AttributeName: 'ANVAND_PA_HELGDAGAR',
          DisplayLabel: 'ANVAND_PA_HELGDAGAR',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        MAN_BEHALL_SCHEMA: {
          AttributeName: 'MAN_BEHALL_SCHEMA',
          DisplayLabel: 'MAN_BEHALL_SCHEMA',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        TIS_BEHALL_SCHEMA: {
          AttributeName: 'TIS_BEHALL_SCHEMA',
          DisplayLabel: 'TIS_BEHALL_SCHEMA',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        ONS_BEHALL_SCHEMA: {
          AttributeName: 'ONS_BEHALL_SCHEMA',
          DisplayLabel: 'ONS_BEHALL_SCHEMA',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        TOR_BEHALL_SCHEMA: {
          AttributeName: 'TOR_BEHALL_SCHEMA',
          DisplayLabel: 'TOR_BEHALL_SCHEMA',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        FRE_BEHALL_SCHEMA: {
          AttributeName: 'FRE_BEHALL_SCHEMA',
          DisplayLabel: 'FRE_BEHALL_SCHEMA',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        LOR_BEHALL_SCHEMA: {
          AttributeName: 'LOR_BEHALL_SCHEMA',
          DisplayLabel: 'LOR_BEHALL_SCHEMA',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        SON_BEHALL_SCHEMA: {
          AttributeName: 'SON_BEHALL_SCHEMA',
          DisplayLabel: 'SON_BEHALL_SCHEMA',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        BYT_UT_DAGSCHEMA_ID: {
          AttributeName: 'BYT_UT_DAGSCHEMA_ID',
          DisplayLabel: 'Byt ut dagschema',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        ERSATT_MED_DAGSCHEMA_ID: {
          AttributeName: 'ERSATT_MED_DAGSCHEMA_ID',
          DisplayLabel: 'Ersätt dagschema med',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        beskrivning: {
          AttributeName: 'beskrivning',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        sasongBenamning: {
          AttributeName: 'sasongBenamning',
          DisplayLabel: 'Säsong',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DAGAR_DAGSCHEMA_ID: {
          AttributeName: 'DAGAR_DAGSCHEMA_ID',
          DisplayLabel: 'DAGAR_DAGSCHEMA_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        DAGAR_LISTA: {
          AttributeName: 'DAGAR_LISTA',
          DisplayLabel: 'DAGAR_LISTA',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        dagLista: {
          AttributeName: 'dagLista',
          DisplayLabel: 'Daglista',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM_DAGSCHEMA_ID: {
          AttributeName: 'DATUM_DAGSCHEMA_ID',
          DisplayLabel: 'DATUM_DAGSCHEMA_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        AVEN_LEDIGA_VECKODAGAR: {
          AttributeName: 'AVEN_LEDIGA_VECKODAGAR',
          DisplayLabel: 'Även lediga veckodagar',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        VISA_HELGDAGAR: {
          AttributeName: 'VISA_HELGDAGAR',
          DisplayLabel: 'Visa helgdagar',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        VISA_DAGAR_FORE_HELG: {
          AttributeName: 'VISA_DAGAR_FORE_HELG',
          DisplayLabel: 'Visa dagar före helgdag',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        VECKONR: {
          AttributeName: 'VECKONR',
          DisplayLabel: 'Veckonummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1";MaxValue="10"',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Schema: {
          AssociationName: 'Schema',
          DisplayLabel: 'Schema',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIVeckoschema',
          AssociatedComponentName: 'Veckoschema',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        utgaFranSchema: {
          AssociationName: 'utgaFranSchema',
          DisplayLabel: 'Grundschema',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIVeckoschema',
          AssociatedComponentName: 'Veckoschema',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Sasong: {
          AssociationName: 'Sasong',
          DisplayLabel: 'Säsong',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TITEDTISasong',
          AssociatedComponentName: 'Sasong',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIInstallningar: {
      CollectionName: 'TIInstallningar',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '14003']]),
      RootType: {
        TypeValue: 'Installningar',
        Abstract: false,
        SOLabel: 'Inställningar',
        SOGLabel: 'Inställningar',
        SBLabel: 'Inställningarna',
        SBGLabel: 'Inställningarna',
        POLabel: 'Inställningar',
        POGLabel: 'Inställningar',
        PBLabel: 'Inställningarna',
        PBGLabel: 'Inställningarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Inställningarna primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Inställningarna versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Inställningarna id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Inställningarna fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benäming',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        MAX_FLEXTID: {
          AttributeName: 'MAX_FLEXTID',
          DisplayLabel: 'Max flextidssaldo',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatMinutes',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Flextidssaldo',
        },
        MIN_FLEXTID: {
          AttributeName: 'MIN_FLEXTID',
          DisplayLabel: 'Min flextidssaldo',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatMinutes',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Flextidssaldo',
        },
        AVRUNDNING: {
          AttributeName: 'AVRUNDNING',
          DisplayLabel: 'Avrundning vid utstämpling',
          Hint: 'Y/N',
          DataType: 'Enum',
          EnumValues: new Map([['Y', 'Y'], ['N', 'N']]),
          EnumSortValues: new Map([['Y', 'Y'], ['N', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="Y=Y;N=N"',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        TID_UTSTAMPLING: {
          AttributeName: 'TID_UTSTAMPLING',
          DisplayLabel: 'Extra tid vid utstämpling',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="60"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Extra tid',
        },
        TID_INSTAMPLING: {
          AttributeName: 'TID_INSTAMPLING',
          DisplayLabel: 'Extra tid vid instämpling',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="60"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Extra tid',
        },
        ARBETSTIDSBLOCK: {
          AttributeName: 'ARBETSTIDSBLOCK',
          DisplayLabel: 'Arbetstidsblock',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="60"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.equals,
        },
        MAN_STAMPEL_TID: {
          AttributeName: 'MAN_STAMPEL_TID',
          DisplayLabel: 'Avvikande tid vid stämpling',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        TILLAT_BORTTAG: {
          AttributeName: 'TILLAT_BORTTAG',
          DisplayLabel: 'Tillåt borttag av instämplade tidrapporteringar',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        TID_UTSTAMPLING_WEB: {
          AttributeName: 'TID_UTSTAMPLING_WEB',
          DisplayLabel: 'Extra tid vid utstämpling via webbgränssnitt',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="60"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Extra tid',
        },
        TID_INSTAMPLING_WEB: {
          AttributeName: 'TID_INSTAMPLING_WEB',
          DisplayLabel: 'Extra tid vid instämpling via webgränssnitt',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="60"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Extra tid',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        installningRappkod: {
          AssociationName: 'installningRappkod',
          DisplayLabel: 'Rapporteringskoder',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIInstallningRappkod',
          AssociatedComponentName: 'InstallningRappkod',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        installningTidbank: {
          AssociationName: 'installningTidbank',
          DisplayLabel: 'Tidbanker',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIInstallningTidbank',
          AssociatedComponentName: 'InstallningTidbank',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIInstallningTidbank: {
      CollectionName: 'TIInstallningTidbank',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'InstallningTidbank',
        Abstract: false,
        SOLabel: 'Inställnings koppling till tidbank',
        SOGLabel: 'Inställnings koppling till tidbank',
        SBLabel: 'Inställnings koppling till tidbank',
        SBGLabel: 'Inställnings koppling till tidbank',
        POLabel: 'Inställnings koppling till tidbank',
        POGLabel: 'Inställnings koppling till tidbank',
        PBLabel: 'Inställnings koppling till tidbank',
        PBGLabel: 'Inställnings koppling till tidbank',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Inställnings koppling till tidbank primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Inställnings koppling till tidbank versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Inställnings koppling till tidbank fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    TIInstallningRappkod: {
      CollectionName: 'TIInstallningRappkod',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'InstallningRappkod',
        Abstract: false,
        SOLabel: 'Inställnings koppling till rapporteringskod',
        SOGLabel: 'Inställnings koppling till rapporteringskod',
        SBLabel: 'Inställningens koppling till rapporteringskod',
        SBGLabel: 'Inställningens koppling till rapporteringskod',
        POLabel: 'Inställnings kopplingar till rapporteringskod',
        POGLabel: 'Inställnings kopplingar till rapporteringskod',
        PBLabel: 'Inställnings kopplingar till rapporteringskod',
        PBGLabel: 'Inställnings kopplingar till rapporteringskod',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Inställningens koppling till rapporteringskod primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Inställningens koppling till rapporteringskod versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Inställningens koppling till rapporteringskod id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Inställningens koppling till rapporteringskod fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Rapporteringskod: {
          AssociationName: 'Rapporteringskod',
          DisplayLabel: 'Rapporteringskod',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIRapporteringskod',
          AssociatedComponentName: 'Rapporteringskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Installning: {
          AssociationName: 'Installning',
          DisplayLabel: 'Inställning',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIInstallningar',
          AssociatedComponentName: 'Installningar',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIAnstalldKategori: {
      CollectionName: 'TIAnstalldKategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '14016']]),
      RootType: {
        TypeValue: 'AnstalldKategori',
        Abstract: false,
        SOLabel: 'Kategori av anställda',
        SOGLabel: 'Kategori av anställda',
        SBLabel: 'Kategorin av anställda',
        SBGLabel: 'Kategorin av anställda',
        POLabel: 'Kategorier av anställda',
        POGLabel: 'Kategorier av anställda',
        PBLabel: 'Kategorierna av anställda',
        PBGLabel: 'Kategorierna av anställda',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kategorin av anställda primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kategorin av anställda versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kategorin av anställda id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kategorin av anställda fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesHintAttribute', 'Benamning;']]),
          Required: true,
        },
        kodBenamning: {
          AttributeName: 'kodBenamning',
          DisplayLabel: 'kodBenamning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SEMESTERRATT: {
          AttributeName: 'SEMESTERRATT',
          DisplayLabel: 'Semesterrätt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        anstallda: {
          AssociationName: 'anstallda',
          DisplayLabel: 'Anställda',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAnstalld',
          AssociatedComponentName: 'Anstalld',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIRapportfaltSpec: {
      CollectionName: 'TIRapportfaltSpec',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'RapportfaltSpec',
        Abstract: true,
        SOLabel: 'Kolumnspecifikation',
        SOGLabel: 'Kolumnspecifikation',
        SBLabel: 'Kolumnspecifikationen',
        SBGLabel: 'Kolumnspecifikationen',
        POLabel: 'Kolumnspecifikationer',
        POGLabel: 'Kolumnspecifikationer',
        PBLabel: 'Kolumnspecifikationerna',
        PBGLabel: 'Kolumnspecifikationerna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'RapportfaltspecFalt',
            Abstract: false,
            SOLabel: 'Kolumn',
            SOGLabel: 'Kolumn',
            SBLabel: 'Kolumnen',
            SBGLabel: 'Kolumnen',
            POLabel: 'Kolumner',
            POGLabel: 'Kolumner',
            PBLabel: 'Kolumnerna',
            PBGLabel: 'Kolumnerna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'RapportfaltspecOperator',
            Abstract: false,
            SOLabel: 'Operator',
            SOGLabel: 'Operator',
            SBLabel: 'Operatorn',
            SBGLabel: 'Operatorn',
            POLabel: 'Operatorer',
            POGLabel: 'Operatorer',
            PBLabel: 'Operatorerna',
            PBGLabel: 'Operatorerna',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'RapportfaltspecKonstant',
            Abstract: false,
            SOLabel: 'Konstant',
            SOGLabel: 'Konstant',
            SBLabel: 'Konstanten',
            SBGLabel: 'Konstanten',
            POLabel: 'Konstanter',
            POGLabel: 'Konstanter',
            PBLabel: 'Konstanterna',
            PBGLabel: 'Konstanterna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kolumnspecifikationen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kolumnspecifikationen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['RAPPORTFALTSPECFALT', 'Kolumn'], ['RAPPORTFALTSPECOPERATOR', 'Operator'], ['RAPPORTFALTSPECKONSTANT', 'Konstant']]),
          EnumSortValues: new Map([['RAPPORTFALTSPECFALT', 'F'], ['RAPPORTFALTSPECOPERATOR', 'O'], ['RAPPORTFALTSPECKONSTANT', 'C']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kolumnspecifikationen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kolumnspecifikationen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RAPPORT_ID: {
          AttributeName: 'RAPPORT_ID',
          DisplayLabel: 'Rapport id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ORDNINGSNR: {
          AttributeName: 'ORDNINGSNR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        REF_RAPPORT_ID: {
          AttributeName: 'REF_RAPPORT_ID',
          DisplayLabel: 'Ref rapport id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          ValidInComps: ['RapportfaltspecFalt'],
        },
        REF_LOPNR: {
          AttributeName: 'REF_LOPNR',
          DisplayLabel: 'Ref lopnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          ValidInComps: ['RapportfaltspecFalt'],
        },
        OPERATOR: {
          AttributeName: 'OPERATOR',
          DisplayLabel: 'Operator',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
          ValidInComps: ['RapportfaltspecOperator'],
        },
        CONSTANT: {
          AttributeName: 'CONSTANT',
          DisplayLabel: 'Konstant',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          ValidInComps: ['RapportfaltspecKonstant'],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    TILoneart: {
      CollectionName: 'TILoneart',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '14038']]),
      RootType: {
        TypeValue: 'Loneart',
        Abstract: false,
        SOLabel: 'Löneart',
        SOGLabel: 'Löneart',
        SBLabel: 'Lönearten',
        SBGLabel: 'Lönearten',
        POLabel: 'Lönearter',
        POGLabel: 'Lönearter',
        PBLabel: 'Lönearterna',
        PBGLabel: 'Lönearterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Lönearten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Lönearten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Lönearten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Lönearten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NR: {
          AttributeName: 'NR',
          DisplayLabel: 'Nummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        SUMMERING: {
          AttributeName: 'SUMMERING',
          DisplayLabel: 'Summering',
          Hint: 'Löneunderlag/Månad/Period/Rapportering/Dag',
          DataType: 'Enum',
          EnumValues: new Map([['LONEUNDERLAG', 'Löneunderlag'], ['MANAD', 'Månad'], ['PERIOD', 'Period'], ['RAPPORTERING', 'Rapportering'], ['DAG', 'Dag']]),
          EnumSortValues: new Map([['LONEUNDERLAG', 'L'], ['MANAD', 'M'], ['PERIOD', 'P'], ['RAPPORTERING', 'R'], ['DAG', 'D']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LONEUNDERLAG=Löneunderlag;MANAD=Månad;PERIOD=Period;RAPPORTERING=Rapportering;DAG=Dag"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        EXPORTERA_ANTAL: {
          AttributeName: 'EXPORTERA_ANTAL',
          DisplayLabel: 'Exportera',
          Hint: 'Antal/Omfattning',
          DataType: 'Enum',
          EnumValues: new Map([['ANTAL', 'Antal'], ['OMFATTNING', 'Omfattning']]),
          EnumSortValues: new Map([['ANTAL', 'Y'], ['OMFATTNING', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANTAL=Antal;OMFATTNING=Omfattning"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        AV_LONEART: {
          AttributeName: 'AV_LONEART',
          DisplayLabel: 'Typ',
          Hint: 'Löneart/Avvikelseart',
          DataType: 'Enum',
          EnumValues: new Map([['LONEART', 'Löneart'], ['AVVIKELSEART', 'Avvikelseart']]),
          EnumSortValues: new Map([['LONEART', 'L'], ['AVVIKELSEART', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LONEART=Löneart;AVVIKELSEART=Avvikelseart"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        nrBenamning: {
          AttributeName: 'nrBenamning',
          DisplayLabel: 'Löneart',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUMMERA_DAGAR: {
          AttributeName: 'SUMMERA_DAGAR',
          DisplayLabel: 'Summera dagar',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        SUMMERA_DAGAR_NR: {
          AttributeName: 'SUMMERA_DAGAR_NR',
          DisplayLabel: 'Summera dagar till löneartsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
        },
        RAPPORTERA_BARN: {
          AttributeName: 'RAPPORTERA_BARN',
          DisplayLabel: 'Rapportera barn',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        loneartAlder: {
          AssociationName: 'loneartAlder',
          DisplayLabel: 'Löneartsnummer per åldersgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TILoneartAlder',
          AssociatedComponentName: 'LoneartAlder',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TILoneartAlder: {
      CollectionName: 'TILoneartAlder',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'LoneartAlder',
        Abstract: false,
        SOLabel: 'Löneart/Ålder',
        SOGLabel: 'Löneart/Ålder',
        SBLabel: 'Lönearten/Ålder',
        SBGLabel: 'Lönearten/Ålder',
        POLabel: 'Lönearter/Ålder',
        POGLabel: 'Lönearter/Ålder',
        PBLabel: 'Lönearterna/Ålder',
        PBGLabel: 'Lönearterna/Ålder',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Lönearten/Ålder primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Lönearten/Ålder versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Lönearten/Ålder id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Lönearten/Ålder fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LONEART_ID: {
          AttributeName: 'LONEART_ID',
          DisplayLabel: 'LONEART_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'LOPNR',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        FRAN: {
          AttributeName: 'FRAN',
          DisplayLabel: 'Från',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1";MaxValue="100"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        TILL: {
          AttributeName: 'TILL',
          DisplayLabel: 'Till',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1";MaxValue="100"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        LONEARTSNR: {
          AttributeName: 'LONEARTSNR',
          DisplayLabel: 'Löneartsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        loneart: {
          AssociationName: 'loneart',
          DisplayLabel: 'Löneart',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TILoneart',
          AssociatedComponentName: 'Loneart',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TILonerad: {
      CollectionName: 'TILonerad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Lonerad',
        Abstract: false,
        SOLabel: 'Lönerad',
        SOGLabel: 'Lönerad',
        SBLabel: 'Löneraden',
        SBGLabel: 'Löneraden',
        POLabel: 'Lönerader',
        POGLabel: 'Lönerader',
        PBLabel: 'Löneraderna',
        PBGLabel: 'Löneraderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Löneraden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Löneraden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Löneraden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Löneraden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANSTALLNINGSNR: {
          AttributeName: 'ANSTALLNINGSNR',
          DisplayLabel: 'Anställningsnr i löneprogram',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AvLoneart: {
          AttributeName: 'AvLoneart',
          DisplayLabel: 'Avvikelse/Löneart',
          Hint: 'Avvikelseart/Löneart',
          DataType: 'Enum',
          EnumValues: new Map([['AVVIKELSEART', 'Avvikelseart'], ['LONEART', 'Löneart']]),
          EnumSortValues: new Map([['AVVIKELSEART', 'A'], ['LONEART', 'L']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AVVIKELSEART=Avvikelseart;LONEART=Löneart"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        LONEARTSNR: {
          AttributeName: 'LONEARTSNR',
          DisplayLabel: 'Löneart/Avvikelseartsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Antal',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        OMFATTNING: {
          AttributeName: 'OMFATTNING',
          DisplayLabel: 'Omfattning',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FRAN: {
          AttributeName: 'FRAN',
          DisplayLabel: 'Från',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Datumintervall',
        },
        TILL: {
          AttributeName: 'TILL',
          DisplayLabel: 'Till',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Datumintervall',
        },
        LONEFIL_ID: {
          AttributeName: 'LONEFIL_ID',
          DisplayLabel: 'Lönefil',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        loneartTypNr: {
          AttributeName: 'loneartTypNr',
          DisplayLabel: 'Löneart',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANSTALLD_ID: {
          AttributeName: 'ANSTALLD_ID',
          DisplayLabel: 'Anställd',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 60,
        },
        anstalldNamnNr: {
          AttributeName: 'anstalldNamnNr',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        anstalld: {
          AssociationName: 'anstalld',
          DisplayLabel: 'Anställd',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAnstalld',
          AssociatedComponentName: 'Anstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Tidrapportering: {
          AssociationName: 'Tidrapportering',
          DisplayLabel: 'Tidrapportering per lönerad',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIRappLonerad',
          AssociatedComponentName: 'RappLonerad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        OBTidrapportering: {
          AssociationName: 'OBTidrapportering',
          DisplayLabel: 'OBTidrapportering per lönerad',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIOBRappLonerad',
          AssociatedComponentName: 'OBRappLonerad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TILonefil: {
      CollectionName: 'TILonefil',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Lonefil',
        Abstract: false,
        SOLabel: 'Lönefil',
        SOGLabel: 'Lönefil',
        SBLabel: 'Lönefilen',
        SBGLabel: 'Lönefilen',
        POLabel: 'Lönefiler',
        POGLabel: 'Lönefiler',
        PBLabel: 'Lönefilerna',
        PBGLabel: 'Lönefilerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Lönefilen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Lönefilen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Lönefilen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Lönefilen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Skapad, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'USER_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        XML: {
          AttributeName: 'XML',
          DisplayLabel: 'XML',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BACKAD: {
          AttributeName: 'BACKAD',
          DisplayLabel: 'Backad',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        BACKAD_DATUM: {
          AttributeName: 'BACKAD_DATUM',
          DisplayLabel: 'Backad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        UTBETALNINGSMANAD: {
          AttributeName: 'UTBETALNINGSMANAD',
          DisplayLabel: 'Utbetalningsmånad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        RAPP_TILL: {
          AttributeName: 'RAPP_TILL',
          DisplayLabel: 'Tidrapporteringar t o m datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SCHEMATEXT: {
          AttributeName: 'SCHEMATEXT',
          DisplayLabel: 'Schema',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        manLonefil: {
          AssociationName: 'manLonefil',
          DisplayLabel: 'Månadsrapporteringar',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIManLonefil',
          AssociatedComponentName: 'ManLonefil',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        lonerader: {
          AssociationName: 'lonerader',
          DisplayLabel: 'Lönerader',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TILonerad',
          AssociatedComponentName: 'Lonerad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        arbetspass: {
          AssociationName: 'arbetspass',
          DisplayLabel: 'Arbetspass',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIArbetspass',
          AssociatedComponentName: 'Arbetspass',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIManLonefil: {
      CollectionName: 'TIManLonefil',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ManLonefil',
        Abstract: false,
        SOLabel: 'ManLonefil',
        SOGLabel: 'ManLonefil',
        SBLabel: 'ManLonefil',
        SBGLabel: 'ManLonefil',
        POLabel: 'ManLonefil',
        POGLabel: 'ManLonefil',
        PBLabel: 'ManLonefil',
        PBGLabel: 'ManLonefil',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'ManLonefil primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'ManLonefil versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'ManLonefil id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'ManLonefil fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MANAD: {
          AttributeName: 'MANAD',
          DisplayLabel: 'Månad',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'Format="y-m/ymm"',
          FormatterDisplayParams: 'Format="yyyy-mm"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANSTALLD_ID: {
          AttributeName: 'ANSTALLD_ID',
          DisplayLabel: 'Anställd',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        LONEFIL_ID: {
          AttributeName: 'LONEFIL_ID',
          DisplayLabel: 'Lönefil',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        lonefil: {
          AssociationName: 'lonefil',
          DisplayLabel: 'Löneunderlag',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TILonefil',
          AssociatedComponentName: 'Lonefil',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIManAnstalld: {
      CollectionName: 'TIManAnstalld',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ManAnstalld',
        Abstract: false,
        SOLabel: 'Månadsrapportering',
        SOGLabel: 'Månadsrapportering',
        SBLabel: 'Månadsrapporteringen',
        SBGLabel: 'Månadsrapporteringen',
        POLabel: 'Månadsrapporteringar',
        POGLabel: 'Månadsrapporteringar',
        PBLabel: 'Månadsrapporteringarna',
        PBGLabel: 'Månadsrapporteringarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Månadsrapporteringen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Månadsrapporteringen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Månadsrapporteringen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Månadsrapporteringen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MANAD: {
          AttributeName: 'MANAD',
          DisplayLabel: 'Månad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        KORR_ARBETSTIDSMATT: {
          AttributeName: 'KORR_ARBETSTIDSMATT',
          DisplayLabel: 'Korrigering av arbetstidsmått',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        AVSLUTAD: {
          AttributeName: 'AVSLUTAD',
          DisplayLabel: 'Avslutad',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        ARBETSTIDSFAKTOR: {
          AttributeName: 'ARBETSTIDSFAKTOR',
          DisplayLabel: 'Arbetstidsfaktor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        JOURNAL_ID: {
          AttributeName: 'JOURNAL_ID',
          DisplayLabel: 'Bokföringsjournal',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SEMESTERFAKTOR: {
          AttributeName: 'SEMESTERFAKTOR',
          DisplayLabel: 'Semesterfaktor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'BOKF_AR',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'Format="y"',
          FormatterDisplayParams: 'Format="yyyy"',
        },
        VER_NR: {
          AttributeName: 'VER_NR',
          DisplayLabel: 'VER_NR',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        AVSLUTLISTA_ID: {
          AttributeName: 'AVSLUTLISTA_ID',
          DisplayLabel: 'Varningslista för månadsavslut',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        arbetstidsmatt: {
          AttributeName: 'arbetstidsmatt',
          DisplayLabel: 'Arbetstidsmått',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatMinutes',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        schemaArbetstid: {
          AttributeName: 'schemaArbetstid',
          DisplayLabel: 'Timmar enligt schema',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatMinutes',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        korrArbetstidsmUtanNoll: {
          AttributeName: 'korrArbetstidsmUtanNoll',
          DisplayLabel: 'Korrigering av arbetstidsmått',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        korrUtanNoll: {
          AttributeName: 'korrUtanNoll',
          DisplayLabel: 'Korr Arbetstidsmatt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        arbetstid: {
          AttributeName: 'arbetstid',
          DisplayLabel: 'Tid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        debiteradTid: {
          AttributeName: 'debiteradTid',
          DisplayLabel: 'Faktureras, antal',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
        },
        firstMonthInYear: {
          AttributeName: 'firstMonthInYear',
          DisplayLabel: 'Första reg. månad per år',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
        },
        anstalldNamn: {
          AttributeName: 'anstalldNamn',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        anstalldNr: {
          AttributeName: 'anstalldNr',
          DisplayLabel: 'Anställningsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        anstalldNrNamn: {
          AttributeName: 'anstalldNrNamn',
          DisplayLabel: 'Anställd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        schemaOchFaktor: {
          AttributeName: 'schemaOchFaktor',
          DisplayLabel: 'Arbetstidsmått',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        status: {
          AttributeName: 'status',
          DisplayLabel: 'Status',
          Hint: 'isnull((select m2.avslutad from ti_man_anstalld m2 where m2.anstalld_id = alias.anstalld_id and m2.manad = (select max(manad) from ti_man_anstalld m3 where m3.anstalld_id = alias.anstalld_id and m3.manad < alias.manad)),\'Y\') = \'N\' then \'F\' - Kan avslutas/Föregående ej avslutad/Avslutad/Ej attesterad för avslut/Senare månad avslutad',
          DataType: 'Enum',
          EnumValues: new Map([['KAN_AVSLUTAS', 'Kan avslutas'], ['FOREGAENDE_EJ_AVSLUTAD', 'Föregående ej avslutad'], ['AVSLUTAD', 'Avslutad'], ['EJ_ATTESTERAD_FOR_AVSLUT', 'Ej attesterad för avslut'], ['SENARE_MANAD_AVSLUTAD', 'Senare månad avslutad']]),
          EnumSortValues: new Map([['KAN_AVSLUTAS', 'Y'], ['FOREGAENDE_EJ_AVSLUTAD', 'F'], ['AVSLUTAD', 'A'], ['EJ_ATTESTERAD_FOR_AVSLUT', 'E'], ['SENARE_MANAD_AVSLUTAD', 'S']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KAN_AVSLUTAS=Kan avslutas;FOREGAENDE_EJ_AVSLUTAD=Föregående ej avslutad;AVSLUTAD=Avslutad;EJ_ATTESTERAD_FOR_AVSLUT=Ej attesterad för avslut;SENARE_MANAD_AVSLUTAD=Senare månad avslutad"',
        },
        schemaBenamning: {
          AttributeName: 'schemaBenamning',
          DisplayLabel: 'Schema',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        utgFlextid: {
          AttributeName: 'utgFlextid',
          DisplayLabel: 'Utgående flextid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        foregManad: {
          AttributeName: 'foregManad',
          DisplayLabel: 'Föregående månad',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        journalStatus: {
          AttributeName: 'journalStatus',
          DisplayLabel: 'Överföring till huvudbok',
          Hint: 'Ej överförd till huvudbok/Skapad/Definitivbokförd/Backad/Bokföringsunderlag skapat/Konverterad/Felaktig journal. Skall backas/Låst',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_OVERFORD_TILL_HUVUDBOK', 'Ej överförd till huvudbok'], ['SKAPAD', 'Skapad'], ['DEFINITIVBOKFORD', 'Definitivbokförd'], ['BACKAD', 'Backad'], ['BOKFORINGSUNDERLAG_SKAPAT', 'Bokföringsunderlag skapat'], ['KONVERTERAD', 'Konverterad'], ['FELAKTIG_JOURNAL__SKALL_BACKAS', 'Felaktig journal. Skall backas'], ['LAST', 'Låst']]),
          EnumSortValues: new Map([['EJ_OVERFORD_TILL_HUVUDBOK', 'E'], ['SKAPAD', 'S'], ['DEFINITIVBOKFORD', 'H'], ['BACKAD', 'B'], ['BOKFORINGSUNDERLAG_SKAPAT', 'U'], ['KONVERTERAD', 'K'], ['FELAKTIG_JOURNAL__SKALL_BACKAS', 'F'], ['LAST', 'L']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_OVERFORD_TILL_HUVUDBOK=Ej överförd till huvudbok;SKAPAD=Skapad;DEFINITIVBOKFORD=Definitivbokförd;BACKAD=Backad;BOKFORINGSUNDERLAG_SKAPAT=Bokföringsunderlag skapat;KONVERTERAD=Konverterad;FELAKTIG_JOURNAL__SKALL_BACKAS=Felaktig journal. Skall backas;LAST=Låst"',
        },
        tidbank1: {
          AttributeName: 'tidbank1',
          DisplayLabel: 'Arbetstid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        tidbank2: {
          AttributeName: 'tidbank2',
          DisplayLabel: 'Komptid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        tidbank3: {
          AttributeName: 'tidbank3',
          DisplayLabel: 'Semester',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
        },
        tidbank4: {
          AttributeName: 'tidbank4',
          DisplayLabel: 'Semester i timmar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        verStatus: {
          AttributeName: 'verStatus',
          DisplayLabel: 'Bokföring',
          Hint: 'Ej bokförd/Backad/Skapad/Definitivbokförd/Anställd bokförs ej/Inga rapporteringar att bokföra',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_BOKFORD', 'Ej bokförd'], ['BACKAD', 'Backad'], ['SKAPAD', 'Skapad'], ['DEFINITIVBOKFORD', 'Definitivbokförd'], ['ANSTALLD_BOKFORS_EJ', 'Anställd bokförs ej'], ['INGA_RAPPORTERINGAR_ATT_BOKFORA', 'Inga rapporteringar att bokföra']]),
          EnumSortValues: new Map([['EJ_BOKFORD', 'E'], ['BACKAD', 'B'], ['SKAPAD', 'S'], ['DEFINITIVBOKFORD', 'H'], ['ANSTALLD_BOKFORS_EJ', 'A'], ['INGA_RAPPORTERINGAR_ATT_BOKFORA', 'I']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_BOKFORD=Ej bokförd;BACKAD=Backad;SKAPAD=Skapad;DEFINITIVBOKFORD=Definitivbokförd;ANSTALLD_BOKFORS_EJ=Anställd bokförs ej;INGA_RAPPORTERINGAR_ATT_BOKFORA=Inga rapporteringar att bokföra"',
        },
        varningsbeskrivning: {
          AttributeName: 'varningsbeskrivning',
          DisplayLabel: 'Varningsbeskrivning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        attFordela: {
          AttributeName: 'attFordela',
          DisplayLabel: 'Tid att fördela',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        fordeladTid: {
          AttributeName: 'fordeladTid',
          DisplayLabel: 'Fördelad tid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        kvarAttFordela: {
          AttributeName: 'kvarAttFordela',
          DisplayLabel: 'Kvar att fördela',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatMinutes',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.notless,
        },
        attestKlarForAvslut: {
          AttributeName: 'attestKlarForAvslut',
          DisplayLabel: 'Färdigattesterad för månadsavslut',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        anstalldNamnSortXXXX: {
          AttributeName: 'anstalldNamnSortXXXX',
          DisplayLabel: 'Anställd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ManadText: {
          AttributeName: 'ManadText',
          DisplayLabel: 'Månad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        anstalld: {
          AssociationName: 'anstalld',
          DisplayLabel: 'Anställd',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAnstalld',
          AssociatedComponentName: 'Anstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        forstaDagAnstalld: {
          AssociationName: 'forstaDagAnstalld',
          DisplayLabel: 'Månadens första dagrapport',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIDagAnstalld',
          AssociatedComponentName: 'DagAnstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        journal: {
          AssociationName: 'journal',
          DisplayLabel: 'Bokföringsjournal',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfjournal',
          AssociatedComponentName: 'Journal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        verifikation: {
          AssociationName: 'verifikation',
          DisplayLabel: 'Verifikation',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfver',
          AssociatedComponentName: 'BokfVer',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        avslutlista: {
          AssociationName: 'avslutlista',
          DisplayLabel: 'Varningslista vid månadsavslut',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIVarningslista',
          AssociatedComponentName: 'Varningslista',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        dagAnstalld: {
          AssociationName: 'dagAnstalld',
          DisplayLabel: 'Dagrapporteringar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIDagAnstalld',
          AssociatedComponentName: 'DagAnstalld',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        tidbanksaldo: {
          AssociationName: 'tidbanksaldo',
          DisplayLabel: 'Tidbanksaldo',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidbankSaldo',
          AssociatedComponentName: 'Tidbanksaldo',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        varningar: {
          AssociationName: 'varningar',
          DisplayLabel: 'Varningar',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIVarning',
          AssociatedComponentName: 'Varning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        varningarForAvslut: {
          AssociationName: 'varningarForAvslut',
          DisplayLabel: 'Varningar vid månadsavslut',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIVarning',
          AssociatedComponentName: 'Varning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        tidrapporteringar: {
          AssociationName: 'tidrapporteringar',
          DisplayLabel: 'Tidrapporteringar',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidrapportering',
          AssociatedComponentName: 'Tidrapportering',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        manLonefil: {
          AssociationName: 'manLonefil',
          DisplayLabel: 'Månadens löneunderlag',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIManLonefil',
          AssociatedComponentName: 'ManLonefil',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TITidrapporteringOB: {
      CollectionName: 'TITidrapporteringOB',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'TidrapporteringOB',
        Abstract: false,
        SOLabel: 'OB-Rapportering/Rast',
        SOGLabel: 'OB-Rapportering/Rast',
        SBLabel: 'OB-Rapportering/Rast',
        SBGLabel: 'OB-Rapportering/Rast',
        POLabel: 'OB-Rapportering/Rast',
        POGLabel: 'OB-Rapportering/Rast',
        PBLabel: 'OB-Rapportering/Rast',
        PBGLabel: 'OB-Rapportering/Rast',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'OB-Rapportering/Rast primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'OB-Rapportering/Rast versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'OB-Rapportering/Rast fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Tid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FinnsIEjBackadLonefil: {
          AttributeName: 'FinnsIEjBackadLonefil',
          DisplayLabel: 'Finns i lönefil',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        FinnsILonefil: {
          AttributeName: 'FinnsILonefil',
          DisplayLabel: 'Finns i lönefil',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        FRANTID: {
          AttributeName: 'FRANTID',
          DisplayLabel: 'Fråntid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TILLTID: {
          AttributeName: 'TILLTID',
          DisplayLabel: 'Tilltid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        OBTyp: {
          AssociationName: 'OBTyp',
          DisplayLabel: 'OB-typ',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIOBTyp',
          AssociatedComponentName: 'OBTyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Tidrapp: {
          AssociationName: 'Tidrapp',
          DisplayLabel: 'Tidrapportering',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidrapportering',
          AssociatedComponentName: 'Tidrapportering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        OBRappLonerad: {
          AssociationName: 'OBRappLonerad',
          DisplayLabel: 'OBRappLonerad',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIOBRappLonerad',
          AssociatedComponentName: 'OBRappLonerad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIOBTid: {
      CollectionName: 'TIOBTid',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'OBTid',
        Abstract: false,
        SOLabel: 'OB-tid',
        SOGLabel: 'OB-tid',
        SBLabel: 'OB-tid',
        SBGLabel: 'OB-tid',
        POLabel: 'OB-tid',
        POGLabel: 'OB-tid',
        PBLabel: 'OB-tid',
        PBGLabel: 'OB-tid',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'OB-tid primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'OB-tid versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'OB-tid fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'Id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FRAN_TID: {
          AttributeName: 'FRAN_TID',
          DisplayLabel: 'Fråntid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TILL_TID: {
          AttributeName: 'TILL_TID',
          DisplayLabel: 'Tilltid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        OB_TYP_ID: {
          AttributeName: 'OB_TYP_ID',
          DisplayLabel: 'Id, OB-typ',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        OB_Benamning: {
          AttributeName: 'OB_Benamning',
          DisplayLabel: 'OB-Typ',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    TIOBRappLonerad: {
      CollectionName: 'TIOBRappLonerad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'OBRappLonerad',
        Abstract: false,
        SOLabel: 'OBTidrapporteringLönerad',
        SOGLabel: 'OBTidrapporteringLönerad',
        SBLabel: 'OBTidrapporteringLönerad',
        SBGLabel: 'OBTidrapporteringLönerad',
        POLabel: 'OBTidrapporteringLönerad',
        POGLabel: 'OBTidrapporteringLönerad',
        PBLabel: 'OBTidrapporteringLönerad',
        PBGLabel: 'OBTidrapporteringLönerad',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'OBTidrapporteringLönerad primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'OBTidrapporteringLönerad versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'OBTidrapporteringLönerad fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LONERAD_ID: {
          AttributeName: 'LONERAD_ID',
          DisplayLabel: 'Lönerad',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OBTIDRAPP_TIDRAPP_ID: {
          AttributeName: 'OBTIDRAPP_TIDRAPP_ID',
          DisplayLabel: 'OB-Tidrapportering',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OBTIDRAPP_OBTYP_ID: {
          AttributeName: 'OBTIDRAPP_OBTYP_ID',
          DisplayLabel: 'OB-Typ',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        OBTidrapportering: {
          AssociationName: 'OBTidrapportering',
          DisplayLabel: 'OB-Tidrapportering',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidrapporteringOB',
          AssociatedComponentName: 'TidrapporteringOB',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIOBTyp: {
      CollectionName: 'TIOBTyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'OBTyp',
        Abstract: false,
        SOLabel: 'OB-typ',
        SOGLabel: 'OB-typ',
        SBLabel: 'OB-typ',
        SBGLabel: 'OB-typ',
        POLabel: 'OB-typ',
        POGLabel: 'OB-typ',
        PBLabel: 'OB-typ',
        PBGLabel: 'OB-typ',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'OB-typ primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'OB-typ versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'OB-typ fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'Id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LONEART_ID: {
          AttributeName: 'LONEART_ID',
          DisplayLabel: 'Id, löneart',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Loneart: {
          AssociationName: 'Loneart',
          DisplayLabel: 'Löneart',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TILoneart',
          AssociatedComponentName: 'Loneart',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIPrioritet: {
      CollectionName: 'TIPrioritet',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '14012']]),
      RootType: {
        TypeValue: 'Prioritet',
        Abstract: false,
        SOLabel: 'Prioritet',
        SOGLabel: 'Prioritet',
        SBLabel: 'Prioriteten',
        SBGLabel: 'Prioriteten',
        POLabel: 'Prioriteter',
        POGLabel: 'Prioriteter',
        PBLabel: 'Prioriteterna',
        PBGLabel: 'Prioriteterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Prioriteten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Prioriteten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Prioriteten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Prioriteten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        PRIORITET: {
          AttributeName: 'PRIORITET',
          DisplayLabel: 'Prioritetsnivå',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="100"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        STANDARD: {
          AttributeName: 'STANDARD',
          DisplayLabel: 'Föreslagen nivå',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        standardText: {
          AttributeName: 'standardText',
          DisplayLabel: 'standardText',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    TIPrisAnstalld: {
      CollectionName: 'TIPrisAnstalld',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'PrisAnstalld',
        Abstract: false,
        SOLabel: 'Pris per anställd',
        SOGLabel: 'Pris per anställd',
        SBLabel: 'Priset per anställd',
        SBGLabel: 'Priset per anställd',
        POLabel: 'Priser per anstalld',
        POGLabel: 'Priser per anstalld',
        PBLabel: 'Priserna per anstalld',
        PBGLabel: 'Priserna per anstalld',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Priset per anställd primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Priset per anställd versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Priset per anställd id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Priset per anställd fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KALKYLPRIS: {
          AttributeName: 'KALKYLPRIS',
          DisplayLabel: 'Kalkylpris',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MinValue="0";MaxValue="100000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        FOREG_KALKYLPRIS: {
          AttributeName: 'FOREG_KALKYLPRIS',
          DisplayLabel: 'Föregående kalkylpris',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        PRISANDRING_DATUM: {
          AttributeName: 'PRISANDRING_DATUM',
          DisplayLabel: 'Datum för prisändring',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        anstalldNamnXXXX: {
          AttributeName: 'anstalldNamnXXXX',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        anstalldNr: {
          AttributeName: 'anstalldNr',
          DisplayLabel: 'Anställningsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        anstalld: {
          AssociationName: 'anstalld',
          DisplayLabel: 'Anställd',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAnstalld',
          AssociatedComponentName: 'Anstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        loneart: {
          AssociationName: 'loneart',
          DisplayLabel: 'Rapporteringskod',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIRapporteringskod',
          AssociatedComponentName: 'Rapporteringskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIProjekt: {
      CollectionName: 'TIProjekt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['GroupAssociation', 'tidredovisningsgrupp'], ['USER_DEF_REPORT_ROUTINE', '14011']]),
      RootType: {
        TypeValue: 'Projekt',
        Abstract: false,
        SOLabel: 'projekt',
        SOGLabel: 'projekt',
        SBLabel: 'projektet',
        SBGLabel: 'projektet',
        POLabel: 'projekt',
        POGLabel: 'projekt',
        PBLabel: 'projekten',
        PBGLabel: 'projekten',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'projektet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'projektet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'projektet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'projektet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        PROJEKTNR: {
          AttributeName: 'PROJEKTNR',
          DisplayLabel: 'Projektnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesHintAttribute', 'Benamning;']]),
          Required: true,
        },
        LONEART_ID: {
          AttributeName: 'LONEART_ID',
          DisplayLabel: 'Föreslagen rapporteringskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURERINGSTYP_ID: {
          AttributeName: 'FAKTURERINGSTYP_ID',
          DisplayLabel: 'Faktureringstyp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PRIORITET_ID: {
          AttributeName: 'PRIORITET_ID',
          DisplayLabel: 'Föreslagen prioritet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TIDGRUPP_ID: {
          AttributeName: 'TIDGRUPP_ID',
          DisplayLabel: 'Tidredovisningsgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INTERNBOKFORING: {
          AttributeName: 'INTERNBOKFORING',
          DisplayLabel: 'Internbokföring',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        TILL_LONEPROGRAM: {
          AttributeName: 'TILL_LONEPROGRAM',
          DisplayLabel: 'Överföring till löneprogram',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        ANVAND_KOD2: {
          AttributeName: 'ANVAND_KOD2',
          DisplayLabel: 'Använd rapporteringskod2',
          Hint: 'Får anges/Måste anges/Får ej anges',
          DataType: 'Enum',
          EnumValues: new Map([['FAR_ANGES', 'Får anges'], ['MASTE_ANGES', 'Måste anges'], ['FAR_EJ_ANGES', 'Får ej anges']]),
          EnumSortValues: new Map([['FAR_ANGES', 'F'], ['MASTE_ANGES', 'M'], ['FAR_EJ_ANGES', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAR_ANGES=Får anges;MASTE_ANGES=Måste anges;FAR_EJ_ANGES=Får ej anges"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        NUMMERSERIE_ID: {
          AttributeName: 'NUMMERSERIE_ID',
          DisplayLabel: 'Nummerserie',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        arbetadTidPerAr: {
          AttributeName: 'arbetadTidPerAr',
          DisplayLabel: 'Tid per år',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
          AttributeParams: {'visaPerAr': {type: 'Int', defaultValue: ''}},
        },
        debiterbarTidPerAr: {
          AttributeName: 'debiterbarTidPerAr',
          DisplayLabel: 'Faktureras, antal',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
          AttributeParams: {'visaPerAr': {type: 'Int', defaultValue: ''}},
        },
        beloppAttFakturera: {
          AttributeName: 'beloppAttFakturera',
          DisplayLabel: 'Faktureras, belopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'visaPerAr': {type: 'Int', defaultValue: ''}},
        },
        prioritetBenamning: {
          AttributeName: 'prioritetBenamning',
          DisplayLabel: 'Prioritet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBTIIntern: {
          AttributeName: 'KBTIIntern',
          DisplayLabel: 'KBTIIntern',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBTILon: {
          AttributeName: 'KBTILon',
          DisplayLabel: 'KBTILon',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBTIInternKre: {
          AttributeName: 'KBTIInternKre',
          DisplayLabel: 'KBTIInternKre',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        foreslagenPrioritetID: {
          AttributeName: 'foreslagenPrioritetID',
          DisplayLabel: 'foreslagenPrioritetID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        nrBenamning: {
          AttributeName: 'nrBenamning',
          DisplayLabel: 'Projekt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleKBTIInternKre: {
          AttributeName: 'RuleKBTIInternKre',
          DisplayLabel: 'RuleKBTIInternKre',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        faktureringstyp: {
          AssociationName: 'faktureringstyp',
          DisplayLabel: 'Föreslagen faktureringstyp',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIFaktureringstyp',
          AssociatedComponentName: 'Faktureringstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        loneart: {
          AssociationName: 'loneart',
          DisplayLabel: 'Föreslagen rapporteringskod',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIRapporteringskod',
          AssociatedComponentName: 'Rapporteringskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        prioritet: {
          AssociationName: 'prioritet',
          DisplayLabel: 'Prioritetsnivå',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIPrioritet',
          AssociatedComponentName: 'Prioritet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        tidredovisningsgrupp: {
          AssociationName: 'tidredovisningsgrupp',
          DisplayLabel: 'Tidredovisningsgrupp',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidGrupp',
          AssociatedComponentName: 'TidGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        TIDINTERN: {
          AssociationName: 'TIDINTERN',
          DisplayLabel: 'Kontering Internbokf, debet',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        TIDLON: {
          AssociationName: 'TIDLON',
          DisplayLabel: 'Kontering Export till löneprogram',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        TIDINTERN_KRE: {
          AssociationName: 'TIDINTERN_KRE',
          DisplayLabel: 'Kontering Internbokf, kredit',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        nummerserie: {
          AssociationName: 'nummerserie',
          DisplayLabel: 'Nummerserie',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSNummerserie',
          AssociatedComponentName: 'Nummerserie',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        arbetsuppgifter: {
          AssociationName: 'arbetsuppgifter',
          DisplayLabel: 'Arbetsuppgifter',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIArbetsuppgift',
          AssociatedComponentName: 'Arbetsuppgift',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        projektGrupp: {
          AssociationName: 'projektGrupp',
          DisplayLabel: 'Tidredovisningsgrupper',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIProjektGrupp',
          AssociatedComponentName: 'ProjektGrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIProjektGrupp: {
      CollectionName: 'TIProjektGrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ProjektGrupp',
        Abstract: false,
        SOLabel: 'ProjektGrupp',
        SOGLabel: 'ProjektGrupp',
        SBLabel: 'ProjektGrupp',
        SBGLabel: 'ProjektGrupp',
        POLabel: 'ProjektGrupp',
        POGLabel: 'ProjektGrupp',
        PBLabel: 'ProjektGrupp',
        PBGLabel: 'ProjektGrupp',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'ProjektGrupp primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'ProjektGrupp versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'ProjektGrupp id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'ProjektGrupp fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PROJEKT_ID: {
          AttributeName: 'PROJEKT_ID',
          DisplayLabel: 'PROJEKT_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        GRUPP_ID: {
          AttributeName: 'GRUPP_ID',
          DisplayLabel: 'GRUPP_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        projekt: {
          AssociationName: 'projekt',
          DisplayLabel: 'Projekt',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIProjekt',
          AssociatedComponentName: 'Projekt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        tidgrupp: {
          AssociationName: 'tidgrupp',
          DisplayLabel: 'Tidredovisningsgrupp',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidGrupp',
          AssociatedComponentName: 'TidGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIAKProjekt: {
      CollectionName: 'TIAKProjekt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AKProjekt',
        Abstract: false,
        SOLabel: 'Projekturval',
        SOGLabel: 'Projekturval',
        SBLabel: 'Projekturvalet',
        SBGLabel: 'Projekturvalet',
        POLabel: 'Projekturval',
        POGLabel: 'Projekturval',
        PBLabel: 'Projekturvalen',
        PBGLabel: 'Projekturvalen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Projekturvalet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Projekturvalet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Projekturvalet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTKATEGORI_ID: {
          AttributeName: 'ATTESTKATEGORI_ID',
          DisplayLabel: 'Attestkategori',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FRAN: {
          AttributeName: 'FRAN',
          DisplayLabel: 'Från',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
        },
        TILL: {
          AttributeName: 'TILL',
          DisplayLabel: 'Till',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    TITidrapportering: {
      CollectionName: 'TITidrapportering',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '14013']]),
      RootType: {
        TypeValue: 'RapporteringOchRast',
        Abstract: true,
        SOLabel: 'Rapportering/Rast',
        SOGLabel: 'Rapportering/Rast',
        SBLabel: 'Rapportering/Rast',
        SBGLabel: 'Rapportering/Rast',
        POLabel: 'Rapportering/Rast',
        POGLabel: 'Rapportering/Rast',
        PBLabel: 'Rapportering/Rast',
        PBGLabel: 'Rapportering/Rast',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'Rapportering',
            Abstract: true,
            SOLabel: 'Rapportering',
            SOGLabel: 'Rapportering',
            SBLabel: 'Rapporteringen',
            SBGLabel: 'Rapporteringen',
            POLabel: 'Rapporteringar',
            POGLabel: 'Rapporteringar',
            PBLabel: 'Rapporteringarna',
            PBGLabel: 'Rapporteringarna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'Tidrapportering',
                Abstract: true,
                SOLabel: 'Tidrapportering',
                SOGLabel: 'Tidrapportering',
                SBLabel: 'Tidrapporteringen',
                SBGLabel: 'Tidrapporteringen',
                POLabel: 'Tidrapporteringar',
                POGLabel: 'Tidrapporteringar',
                PBLabel: 'Tidrapporteringarna',
                PBGLabel: 'Tidrapporteringarna',
                Visible: true,
                ChildTypes: [
                  {
                    TypeValue: 'InstampladRapportering',
                    Abstract: false,
                    SOLabel: 'Instämplad tidrapportering',
                    SOGLabel: 'Instämplad tidrapportering',
                    SBLabel: 'Instämplade tidrapporteringen',
                    SBGLabel: 'Instämplade tidrapporteringen',
                    POLabel: 'Instämplade tidrapporteringar',
                    POGLabel: 'Instämplade tidrapporteringar',
                    PBLabel: 'Instämplade tidrapporteringarna',
                    PBGLabel: 'Instämplade tidrapporteringarna',
                    Visible: true,
                    ChildTypes: [
                    ],
                  },
                  {
                    TypeValue: 'RegistreradRapportering',
                    Abstract: false,
                    SOLabel: 'Registrerad tidrapportering',
                    SOGLabel: 'Registrerad tidrapportering',
                    SBLabel: 'Registrerade tidrapporteringen',
                    SBGLabel: 'Registrerade tidrapporteringen',
                    POLabel: 'Registrerade tidrapporteringar',
                    POGLabel: 'Registrerade tidrapporteringar',
                    PBLabel: 'Registrerade tidrapporteringarna',
                    PBGLabel: 'Registrerade tidrapporteringarna',
                    Visible: true,
                    ChildTypes: [
                    ],
                  },
                ],
              },
              {
                TypeValue: 'AntalsRapportering',
                Abstract: false,
                SOLabel: 'Antalsrapportering',
                SOGLabel: 'Antalsrapportering',
                SBLabel: 'Antalsrapporteringen',
                SBGLabel: 'Antalsrapporteringen',
                POLabel: 'Antalsrapporteringar',
                POGLabel: 'Antalsrapporteringar',
                PBLabel: 'Antalsrapporteringarna',
                PBGLabel: 'Antalsrapporteringarna',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'Rast',
            Abstract: false,
            SOLabel: 'Rast',
            SOGLabel: 'Rast',
            SBLabel: 'Rasten',
            SBGLabel: 'Rasten',
            POLabel: 'Raster',
            POGLabel: 'Raster',
            PBLabel: 'Rasterna',
            PBGLabel: 'Rasterna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapportering/Rast primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapportering/Rast versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Inrapporteringssätt',
          DataType: 'Enum',
          EnumValues: new Map([['INSTAMPLADRAPPORTERING', 'Instämplad tidrapportering'], ['REGISTRERADRAPPORTERING', 'Registrerad tidrapportering'], ['ANTALSRAPPORTERING', 'Antalsrapportering'], ['RAST', 'Rast']]),
          EnumSortValues: new Map([['INSTAMPLADRAPPORTERING', 'A'], ['REGISTRERADRAPPORTERING', 'M'], ['ANTALSRAPPORTERING', 'O'], ['RAST', 'R']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INSTAMPLADRAPPORTERING=Instämplad tidrapportering;REGISTRERADRAPPORTERING=Registrerad tidrapportering;ANTALSRAPPORTERING=Antalsrapportering;RAST=Rast"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapportering/Rast id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapportering/Rast fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MANAD: {
          AttributeName: 'MANAD',
          DisplayLabel: 'Månad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'Format="y-m/ymm"',
          FormatterDisplayParams: 'Format="yyyy-mm"',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        ANSTALLD_ID: {
          AttributeName: 'ANSTALLD_ID',
          DisplayLabel: 'Anställd',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEMO: {
          AttributeName: 'DEMO',
          DisplayLabel: 'Demo',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        antalTid: {
          AttributeName: 'antalTid',
          DisplayLabel: 'Tid/Antal',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        veckodag: {
          AttributeName: 'veckodag',
          DisplayLabel: 'Veckodag',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        franTill: {
          AttributeName: 'franTill',
          DisplayLabel: 'franTill',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        fran: {
          AttributeName: 'fran',
          DisplayLabel: 'Fråntid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tider',
        },
        till: {
          AttributeName: 'till',
          DisplayLabel: 'Tilltid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tider',
        },
        varningsbeskrivning: {
          AttributeName: 'varningsbeskrivning',
          DisplayLabel: 'Varningsbeskrivning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        harStamplats: {
          AttributeName: 'harStamplats',
          DisplayLabel: 'harStamplats',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        anstalldNamn: {
          AttributeName: 'anstalldNamn',
          DisplayLabel: 'Anställd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        namnFE: {
          AttributeName: 'namnFE',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        manadAvslutad: {
          AttributeName: 'manadAvslutad',
          DisplayLabel: 'Avslutad månadsrapportering',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        dagAvslutad: {
          AttributeName: 'dagAvslutad',
          DisplayLabel: 'Dagrapportering avslutad',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        benamning: {
          AttributeName: 'benamning',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        aktiv: {
          AttributeName: 'aktiv',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        sorteringsTid: {
          AttributeName: 'sorteringsTid',
          DisplayLabel: 'sorteringsTid',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        rapporteringstextSql: {
          AttributeName: 'rapporteringstextSql',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        kommentarSQL: {
          AttributeName: 'kommentarSQL',
          DisplayLabel: 'Kommentar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        namn: {
          AttributeName: 'namn',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        anstalldNrNamn: {
          AttributeName: 'anstalldNrNamn',
          DisplayLabel: 'Anställd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSTID: {
          AttributeName: 'ARBETSTID',
          DisplayLabel: 'Tid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatMinutes',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tider',
          Properties: new Map([['ffIgnoreChanges', 'Y;']]),
        },
        tid: {
          AttributeName: 'tid',
          DisplayLabel: 'Tid',
          Hint: 'Används antagligen inte',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        omfattning: {
          AttributeName: 'omfattning',
          DisplayLabel: 'Omfattning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Löneunderlag',
        },
        SKAPAD_FRAN: {
          AttributeName: 'SKAPAD_FRAN',
          DisplayLabel: 'Skapad från',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOMMENTAR: {
          AttributeName: 'KOMMENTAR',
          DisplayLabel: 'Kommentar',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        RAPPORTERINGSTEXT: {
          AttributeName: 'RAPPORTERINGSTEXT',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        beskrivningFinns: {
          AttributeName: 'beskrivningFinns',
          DisplayLabel: 'Beskrivning finns',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'None',
          Condition: 'Internal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'Format="y"',
          FormatterDisplayParams: 'Format="yyyy"',
          ValidInComps: ['Rapportering'],
        },
        VER_NR: {
          AttributeName: 'VER_NR',
          DisplayLabel: 'Verifikationsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          ValidInComps: ['Rapportering'],
        },
        DEB_LOPNR: {
          AttributeName: 'DEB_LOPNR',
          DisplayLabel: 'DEB_LOPNR',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          ValidInComps: ['Rapportering'],
        },
        KRE_LOPNR: {
          AttributeName: 'KRE_LOPNR',
          DisplayLabel: 'KRE_LOPNR',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          ValidInComps: ['Rapportering'],
        },
        PA_FAKTURAUNDERLAG: {
          AttributeName: 'PA_FAKTURAUNDERLAG',
          DisplayLabel: 'Kan visas på fakturaunderlag',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        LONEART_ID: {
          AttributeName: 'LONEART_ID',
          DisplayLabel: 'Rapporteringskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        RAPPORTERINGSKOD2_ID: {
          AttributeName: 'RAPPORTERINGSKOD2_ID',
          DisplayLabel: 'Rapporteringskod2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        DEB_ANTAL: {
          AttributeName: 'DEB_ANTAL',
          DisplayLabel: 'Faktureras antal',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Rapportering'],
          AttributeGroup: 'Fakturering',
        },
        DEBITERAS: {
          AttributeName: 'DEBITERAS',
          DisplayLabel: 'Faktureras',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Fakturering',
        },
        KALKYLPRIS: {
          AttributeName: 'KALKYLPRIS',
          DisplayLabel: 'Kalkylpris',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        DEB_PRIS: {
          AttributeName: 'DEB_PRIS',
          DisplayLabel: 'Pris',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Rapportering'],
          AttributeGroup: 'Fakturering',
          Properties: new Map([['ffIgnoreChanges', 'Y;']]),
        },
        ARBETSUPPGIFT_ID: {
          AttributeName: 'ARBETSUPPGIFT_ID',
          DisplayLabel: 'Arbetsuppgift',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        UTDELAT_TILL_NR: {
          AttributeName: 'UTDELAT_TILL_NR',
          DisplayLabel: 'Utdelningsnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          ValidInComps: ['Rapportering'],
        },
        BARN_ID: {
          AttributeName: 'BARN_ID',
          DisplayLabel: 'Barn',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        anvandKod2: {
          AttributeName: 'anvandKod2',
          DisplayLabel: 'Använd rapporteringskod 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterParseParams: 'TranslateValues=""',
          FormatterDisplayParams: 'TranslateValues=""',
          FormatterValidateParams: 'ValidValues=""',
          ValidInComps: ['Rapportering'],
        },
        internredovisningAntal: {
          AttributeName: 'internredovisningAntal',
          DisplayLabel: 'internredovisningAntal',
          DataType: 'Float',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        loneartAnvandning: {
          AttributeName: 'loneartAnvandning',
          DisplayLabel: 'Användning',
          Hint: 'Normal/Tid att fördela/Fördelad tid/Tidbanksadministration/Övriga rapporteringar',
          DataType: 'Enum',
          EnumValues: new Map([['NORMAL', 'Normal'], ['TID_ATT_FORDELA', 'Tid att fördela'], ['FORDELAD_TID', 'Fördelad tid'], ['TIDBANKSADMINISTRATION', 'Tidbanksadministration'], ['OVRIGA_RAPPORTERINGAR', 'Övriga rapporteringar']]),
          EnumSortValues: new Map([['NORMAL', 'N'], ['TID_ATT_FORDELA', 'A'], ['FORDELAD_TID', 'O'], ['TIDBANKSADMINISTRATION', 'B'], ['OVRIGA_RAPPORTERINGAR', 'R']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NORMAL=Normal;TID_ATT_FORDELA=Tid att fördela;FORDELAD_TID=Fördelad tid;TIDBANKSADMINISTRATION=Tidbanksadministration;OVRIGA_RAPPORTERINGAR=Övriga rapporteringar"',
          ValidInComps: ['Rapportering'],
        },
        anvandningOrder: {
          AttributeName: 'anvandningOrder',
          DisplayLabel: 'Löneartens användning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          ValidInComps: ['Rapportering'],
        },
        visaPaFaktura: {
          AttributeName: 'visaPaFaktura',
          DisplayLabel: 'Ska visas på faktura',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Rapportering'],
          AttributeGroup: 'Fakturering',
        },
        rappkod2KodBenamning: {
          AttributeName: 'rappkod2KodBenamning',
          DisplayLabel: '@SYSOPTIONTI:TI_KOD2_BENAMNING@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        Projektid: {
          AttributeName: 'Projektid',
          DisplayLabel: 'Projektid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        arbetsuppgiftKontakt: {
          AttributeName: 'arbetsuppgiftKontakt',
          DisplayLabel: 'Kontakt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        debAntalEnhetPris: {
          AttributeName: 'debAntalEnhetPris',
          DisplayLabel: 'debAntalEnhetPris',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        kundNrNamn: {
          AttributeName: 'kundNrNamn',
          DisplayLabel: 'Kund',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        arbetsuppgiftRubrikSort: {
          AttributeName: 'arbetsuppgiftRubrikSort',
          DisplayLabel: 'Arbetsuppgift',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        kundSort: {
          AttributeName: 'kundSort',
          DisplayLabel: 'Kundnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        utdelningAvslutad: {
          AttributeName: 'utdelningAvslutad',
          DisplayLabel: 'Avslutad utdelning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        arbetsuppgiftBeskrivning: {
          AttributeName: 'arbetsuppgiftBeskrivning',
          DisplayLabel: 'Beskrivning av arbetsuppgift',
          Hint: '\0D\0A(select Convert(varchar(255), BESKRIVNING) from ti_arbetsuppgift_blob where id = alias.arbetsuppgift_id)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        arbetsuppgiftNrRubrik: {
          AttributeName: 'arbetsuppgiftNrRubrik',
          DisplayLabel: 'Uppgift',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        projektBenamning: {
          AttributeName: 'projektBenamning',
          DisplayLabel: 'Projekt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        loneartKodBenamning: {
          AttributeName: 'loneartKodBenamning',
          DisplayLabel: 'Rapporteringskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        enhetBenamningEjTid: {
          AttributeName: 'enhetBenamningEjTid',
          DisplayLabel: 'Enhet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        debBelopp: {
          AttributeName: 'debBelopp',
          DisplayLabel: 'Faktureras, Belopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Rapportering'],
          AttributeGroup: 'Fakturering',
        },
        enhet: {
          AttributeName: 'enhet',
          DisplayLabel: 'Enhet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        arbetsuppgift: {
          AttributeName: 'arbetsuppgift',
          DisplayLabel: 'Arbetsuppgift',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        loneartBenamning: {
          AttributeName: 'loneartBenamning',
          DisplayLabel: 'Rapporteringskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        belopp: {
          AttributeName: 'belopp',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          ValidInComps: ['Rapportering'],
          AttributeGroup: 'Fakturering',
        },
        debAntal: {
          AttributeName: 'debAntal',
          DisplayLabel: 'Debiteras antal',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        kundID: {
          AttributeName: 'kundID',
          DisplayLabel: 'KundId',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        readOnly: {
          AttributeName: 'readOnly',
          DisplayLabel: 'readOnly',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          ValidInComps: ['Rapportering'],
        },
        attesterad: {
          AttributeName: 'attesterad',
          DisplayLabel: 'Attesterad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
          AttributeParams: {'attestkategori': {type: 'Int', defaultValue: ''}},
        },
        loneStatus: {
          AttributeName: 'loneStatus',
          DisplayLabel: 'Lönestatus',
          Hint: 'Löneunderlag skapat/Rapporteringen exporteras inte till löneprogram/Ska attesteras/Klar för export/Anställd exporteras inte',
          DataType: 'Enum',
          EnumValues: new Map([['LONEUNDERLAG_SKAPAT', 'Löneunderlag skapat'], ['RAPPORTERINGEN_EXPORTERAS_INTE_TILL_LONEPROGRAM', 'Rapporteringen exporteras inte till löneprogram'], ['SKA_ATTESTERAS', 'Ska attesteras'], ['KLAR_FOR_EXPORT', 'Klar för export'], ['ANSTALLD_EXPORTERAS_INTE', 'Anställd exporteras inte']]),
          EnumSortValues: new Map([['LONEUNDERLAG_SKAPAT', 'U'], ['RAPPORTERINGEN_EXPORTERAS_INTE_TILL_LONEPROGRAM', 'E'], ['SKA_ATTESTERAS', 'S'], ['KLAR_FOR_EXPORT', 'K'], ['ANSTALLD_EXPORTERAS_INTE', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LONEUNDERLAG_SKAPAT=Löneunderlag skapat;RAPPORTERINGEN_EXPORTERAS_INTE_TILL_LONEPROGRAM=Rapporteringen exporteras inte till löneprogram;SKA_ATTESTERAS=Ska attesteras;KLAR_FOR_EXPORT=Klar för export;ANSTALLD_EXPORTERAS_INTE=Anställd exporteras inte"',
          InterfaceType: 'ifChecklist',
          ValidInComps: ['Rapportering'],
          AttributeGroup: 'Löneunderlag',
        },
        LoneartKod: {
          AttributeName: 'LoneartKod',
          DisplayLabel: 'LoneartKod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rapportering'],
        },
        INTERN_TEXT: {
          AttributeName: 'INTERN_TEXT',
          DisplayLabel: 'Text, används ej',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals],
          DefaultCondOperator: T.contains,
          ValidInComps: ['Tidrapportering'],
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Skapad/Behandlad',
          DataType: 'Enum',
          EnumValues: new Map([['SKAPAD', 'Skapad'], ['BEHANDLAD', 'Behandlad']]),
          EnumSortValues: new Map([['SKAPAD', 'S'], ['BEHANDLAD', 'B']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKAPAD=Skapad;BEHANDLAD=Behandlad"',
          GUIEditable: true,
          ValidInComps: ['Tidrapportering'],
        },
        maxFordelning: {
          AttributeName: 'maxFordelning',
          DisplayLabel: 'maxFordelning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIKUND: {
          AttributeName: 'RAPP_TIKUND',
          DisplayLabel: 'RAPP_Kund',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
          Properties: new Map([['GRUPPERINGSTYP', 'TIKUND;']]),
        },
        RAPP_FAKTTID: {
          AttributeName: 'RAPP_FAKTTID',
          DisplayLabel: 'Fakturerad tid',
          DataType: 'Float',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
          Properties: new Map([['FALTKOD_Kod', 'TIFAKTTID; FALTKOD_Benamning=Fakturerad tid;FALTKOD_Rubrik=Fakturerad tid; FALTKOD_Querytyp=BOKF; FALTKOD_Urval_budgettyp=False; FALTKOD_FromAr=True;FALTKOD_TomAr=True; FALTKOD_FromPer=True;FALTKOD_TomPer=True; FALTKOD_Arsbaserad=False;FALTKOD_Ingaende=False; FALTKOD_Anvander1=; FALTKOD_Anvander2=; FALTKOD_Operator=#0; FALTKOD_FromArRub=From år;FALTKOD_TomArRub=Tom år;FALTKOD_FromPerRub=From period;FALTKOD_TomPerRub=Tom period;FALTKOD_Bas=True;FALTKOD_DefRub1=Fakturerad tid;FALTKOD_DefRub2=#FPER# - #TPER#;FALTKOD_DefRub2_1=#TPER#;FALTKOD_DatumIntervall=True;FALTKOD_Typ=3']]),
        },
        RAPP_FAKT: {
          AttributeName: 'RAPP_FAKT',
          DisplayLabel: 'Fakturerat belopp',
          DataType: 'Float',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
          Properties: new Map([['FALTKOD_Kod', 'TIFAKT;FALTKOD_Benamning=Fakturerat belopp;FALTKOD_Rubrik=Fakturerat belopp;FALTKOD_Querytyp=BOKF;FALTKOD_Urval_budgettyp=False;FALTKOD_FromAr=True;FALTKOD_TomAr=True;FALTKOD_FromPer=True;FALTKOD_TomPer=True;FALTKOD_Arsbaserad=False;FALTKOD_Ingaende=False;FALTKOD_Anvander1=;FALTKOD_Anvander2=;FALTKOD_Operator=#0;FALTKOD_FromArRub=From år;FALTKOD_TomArRub=Tom år;FALTKOD_FromPerRub=From period;FALTKOD_TomPerRub=Tom period;FALTKOD_Bas=True;FALTKOD_DefRub1=Fakturerat belopp;FALTKOD_DefRub2:#FPER# - #TPER#;FALTKOD_DefRub2_1=#TPER#;FALTKOD_DatumIntervall=True;FALTKOD_Typ=0']]),
        },
        RAPP_KALKPRIS: {
          AttributeName: 'RAPP_KALKPRIS',
          DisplayLabel: 'Kalkylerat belopp',
          DataType: 'Float',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
          Properties: new Map([['FALTKOD_Kod', 'TIKALKPRIS;FALTKOD_Benamning=Kalkylerat belopp;FALTKOD_Rubrik=Kalkylerat belopp;FALTKOD_Querytyp=BOKF;FALTKOD_Urval_budgettyp=False;FALTKOD_FromAr=True;FALTKOD_TomAr=True;FALTKOD_FromPer=True;FALTKOD_TomPer=True;FALTKOD_Arsbaserad=False;FALTKOD_Ingaende=False;FALTKOD_Anvander1=;FALTKOD_Anvander2=;FALTKOD_Operator=#0;FALTKOD_FromArRub=From år;FALTKOD_TomArRub=Tom år;FALTKOD_FromPerRub=From period;FALTKOD_TomPerRub=Tom period;FALTKOD_Bas=True;FALTKOD_DefRub1=Kalkylerat belopp;FALTKOD_DefRub2=#FPER# - #TPER#;FALTKOD_DefRub2_1=#TPER#;FALTKOD_DatumIntervall=True']]),
        },
        RAPP_ARBTID: {
          AttributeName: 'RAPP_ARBTID',
          DisplayLabel: 'Arbetad tid',
          DataType: 'Float',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
          Properties: new Map([['FALTKOD_Kod', 'TIARBETSTID;FALTKOD_Benamning=Arbetstid;FALTKOD_Rubrik=Arbetstid;FALTKOD_Querytyp=BOKF;FALTKOD_Urval_budgettyp=False;FALTKOD_FromAr=True;FALTKOD_TomAr=True;FALTKOD_FromPer=True;FALTKOD_TomPer=True;FALTKOD_Arsbaserad=False;FALTKOD_Ingaende=False;FALTKOD_Anvander1=;FALTKOD_Anvander2=;FALTKOD_Operator=#0;FALTKOD_FromArRub=From år;FALTKOD_TomArRub=Tom år;FALTKOD_FromPerRub=From period;FALTKOD_TomPerRub=Tom period;FALTKOD_Bas=True;FALTKOD_DefRub1=Arbetad tid;FALTKOD_DefRub2=#FPER# - #TPER#;FALTKOD_DefRub2_1=#TPER#;FALTKOD_DatumIntervall=True;FALTKOD_Typ=3']]),
        },
        RAPP_TIAN: {
          AttributeName: 'RAPP_TIAN',
          DisplayLabel: 'Anställd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
          Properties: new Map([['GRUPPERINGSTYP', 'TIAN;']]),
        },
        RAPP_TIKUNDKAT: {
          AttributeName: 'RAPP_TIKUNDKAT',
          DisplayLabel: 'Kundkategori',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
          Properties: new Map([['GRUPPERINGSTYP', 'TIKUNDKAT;']]),
        },
        RAPP_TIPROJEKT: {
          AttributeName: 'RAPP_TIPROJEKT',
          DisplayLabel: 'Projekt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
          Properties: new Map([['GRUPPERINGSTYP', 'TIPROJEKT;']]),
        },
        RAPP_TIANKAT: {
          AttributeName: 'RAPP_TIANKAT',
          DisplayLabel: 'Användarkategori',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
          Properties: new Map([['GRUPPERINGSTYP', 'TIANKAT;']]),
        },
        RAPP_TIARB: {
          AttributeName: 'RAPP_TIARB',
          DisplayLabel: 'Arbetsuppgift',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
          Properties: new Map([['GRUPPERINGSTYP', 'TIARB;']]),
        },
        RAPP_TIRAPKOD: {
          AttributeName: 'RAPP_TIRAPKOD',
          DisplayLabel: 'Rapporteringskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
          Properties: new Map([['GRUPPERINGSTYP', 'TIRAPKOD;']]),
        },
        RAPP_TIRAPKOD2: {
          AttributeName: 'RAPP_TIRAPKOD2',
          DisplayLabel: 'Rapporteringskod2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
          Properties: new Map([['GRUPPERINGSTYP', 'TIRAPKOD2;']]),
        },
        RAPP_TIAN_BEN: {
          AttributeName: 'RAPP_TIAN_BEN',
          DisplayLabel: 'Anställd benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIKUNDKAT_BEN: {
          AttributeName: 'RAPP_TIKUNDKAT_BEN',
          DisplayLabel: 'Kundkategori benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIKUND_BEN: {
          AttributeName: 'RAPP_TIKUND_BEN',
          DisplayLabel: 'Kundnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIPROJEKT_BEN: {
          AttributeName: 'RAPP_TIPROJEKT_BEN',
          DisplayLabel: 'Projektnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIANKAT_BEN: {
          AttributeName: 'RAPP_TIANKAT_BEN',
          DisplayLabel: 'Användarkategori namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIARB_BEN: {
          AttributeName: 'RAPP_TIARB_BEN',
          DisplayLabel: 'Arbetsuppgift benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIRAPKOD_BEN: {
          AttributeName: 'RAPP_TIRAPKOD_BEN',
          DisplayLabel: 'Rapporteringskod benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIRAPKOD2_BEN: {
          AttributeName: 'RAPP_TIRAPKOD2_BEN',
          DisplayLabel: 'Rapporteringskod 2 benamning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIART: {
          AttributeName: 'RAPP_TIART',
          DisplayLabel: 'Artikel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
          Properties: new Map([['GRUPPERINGSTYP', 'TIART;']]),
        },
        RAPP_TIART_BEN: {
          AttributeName: 'RAPP_TIART_BEN',
          DisplayLabel: 'Artikelnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIDEB: {
          AttributeName: 'RAPP_TIDEB',
          DisplayLabel: 'Konto debet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
          Properties: new Map([['GRUPPERINGSTYP', 'TIDEB;']]),
        },
        RAPP_TIDEB_BEN: {
          AttributeName: 'RAPP_TIDEB_BEN',
          DisplayLabel: 'Kontonamn debet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIKRED: {
          AttributeName: 'RAPP_TIKRED',
          DisplayLabel: 'Konto kredit',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
          Properties: new Map([['GRUPPERINGSTYP', 'TIKRED;']]),
        },
        RAPP_TIKRED_BEN: {
          AttributeName: 'RAPP_TIKRED_BEN',
          DisplayLabel: 'Kontonamn kredit',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIBESK: {
          AttributeName: 'RAPP_TIBESK',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIKOMM: {
          AttributeName: 'RAPP_TIKOMM',
          DisplayLabel: 'Kommentar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIANSTALLD: {
          AttributeName: 'RAPP_TIANSTALLD',
          DisplayLabel: 'Anställd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIUPPGIFT: {
          AttributeName: 'RAPP_TIUPPGIFT',
          DisplayLabel: 'Uppgift',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIFRANTILL: {
          AttributeName: 'RAPP_TIFRANTILL',
          DisplayLabel: 'Från till',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        RAPP_TIANL: {
          AttributeName: 'RAPP_TIANL',
          DisplayLabel: 'Anställningsnr - Lön',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
          Properties: new Map([['GRUPPERINGSTYP', 'TIANL;']]),
        },
        RAPP_TIANL_BEN: {
          AttributeName: 'RAPP_TIANL_BEN',
          DisplayLabel: 'Anställd benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Tidrapportering'],
        },
        MAN_MINUTER: {
          AttributeName: 'MAN_MINUTER',
          DisplayLabel: 'Tid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
          FormatterParseParams: 'ValidTimeSeps=":. %"',
          ValidInComps: ['RegistreradRapportering'],
        },
        MAN_FRAN: {
          AttributeName: 'MAN_FRAN',
          DisplayLabel: 'Från',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
          ValidInComps: ['RegistreradRapportering'],
        },
        MAN_TILL: {
          AttributeName: 'MAN_TILL',
          DisplayLabel: 'Till',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
          ValidInComps: ['RegistreradRapportering'],
        },
        MAN_OMFATTNING: {
          AttributeName: 'MAN_OMFATTNING',
          DisplayLabel: 'Omfattning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatIntAsPercent',
          FormatterValidateParams: 'MinValue="0";MaxValue="100"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['RegistreradRapportering'],
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Antal',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterValidateParams: 'MinValue="0";MaxValue="10000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['AntalsRapportering'],
        },
        RAST_ID: {
          AttributeName: 'RAST_ID',
          DisplayLabel: 'Rast, nr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Rast'],
        },
        Rast: {
          AttributeName: 'Rast',
          DisplayLabel: 'Rast',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Internal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        avdragenRast: {
          AttributeName: 'avdragenRast',
          DisplayLabel: 'Avdragen Rast',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatMinutes',
          FormatterParseParams: 'ValidTimeSeps=":. ;"',
          FormatterDisplayParams: 'ShowZeroAsBlank="Y"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        tidText: {
          AttributeName: 'tidText',
          DisplayLabel: 'Tider',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        rastBenamning: {
          AttributeName: 'rastBenamning',
          DisplayLabel: 'Rastbenämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        OB_A: {
          AttributeName: 'OB_A',
          DisplayLabel: 'OB, A',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        OB_B: {
          AttributeName: 'OB_B',
          DisplayLabel: 'OB, B',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        OB_C: {
          AttributeName: 'OB_C',
          DisplayLabel: 'OB, C',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        OB_D: {
          AttributeName: 'OB_D',
          DisplayLabel: 'OB, D',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        TotalOBTid: {
          AttributeName: 'TotalOBTid',
          DisplayLabel: 'Total OB-tid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        OBFrom: {
          AttributeName: 'OBFrom',
          DisplayLabel: 'Fråntid',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
        },
        OBTom: {
          AttributeName: 'OBTom',
          DisplayLabel: 'Tilltid',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
        },
        OBFinnsILonefil: {
          AttributeName: 'OBFinnsILonefil',
          DisplayLabel: 'Finns i lönefil',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        anstalld: {
          AssociationName: 'anstalld',
          DisplayLabel: 'Anställd',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAnstalld',
          AssociatedComponentName: 'Anstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        dagAnstalld: {
          AssociationName: 'dagAnstalld',
          DisplayLabel: 'Dagrapportering',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIDagAnstalld',
          AssociatedComponentName: 'DagAnstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidrapporteringBlob',
          AssociatedComponentName: 'RapporteringBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        DebRad: {
          AssociationName: 'DebRad',
          DisplayLabel: 'Bokförd kontering, debet',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfkontering',
          AssociatedComponentName: 'BokfKontering',
          JoinAssociation: true,
          ValidInComps: ['Rapportering'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        KredRad: {
          AssociationName: 'KredRad',
          DisplayLabel: 'Bokförd kontering, kredit',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfkontering',
          AssociatedComponentName: 'BokfKontering',
          JoinAssociation: true,
          ValidInComps: ['Rapportering'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        rapporteringskod2: {
          AssociationName: 'rapporteringskod2',
          DisplayLabel: '@SYSOPTIONTI:TI_KOD2_BENAMNING@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIRapporteringskod2',
          AssociatedComponentName: 'Rapporteringskod2',
          JoinAssociation: true,
          ValidInComps: ['Rapportering'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        arbetsuppgift: {
          AssociationName: 'arbetsuppgift',
          DisplayLabel: 'Arbetsuppgift',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIArbetsuppgift',
          AssociatedComponentName: 'Arbetsuppgift',
          JoinAssociation: true,
          ValidInComps: ['Rapportering'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        utdelad_till: {
          AssociationName: 'utdelad_till',
          DisplayLabel: 'Utdelning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIUtdelatTill',
          AssociatedComponentName: 'UtdelatTill',
          JoinAssociation: true,
          ValidInComps: ['Rapportering'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        loneart: {
          AssociationName: 'loneart',
          DisplayLabel: 'Rapporteringskod',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIRapporteringskod',
          AssociatedComponentName: 'Rapporteringskod',
          JoinAssociation: true,
          ValidInComps: ['Rapportering'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Barn: {
          AssociationName: 'Barn',
          DisplayLabel: 'Barn',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITEDTIBarn',
          AssociatedComponentName: 'Barn',
          JoinAssociation: true,
          ValidInComps: ['Rapportering'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        skapadFran: {
          AssociationName: 'skapadFran',
          DisplayLabel: 'Skapad från',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TITidrapportering',
          AssociatedComponentName: 'Tidrapportering',
          JoinAssociation: true,
          ValidInComps: ['Rapportering'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        utdelad_till_anstalld: {
          AssociationName: 'utdelad_till_anstalld',
          DisplayLabel: 'Utdelad till',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIUtdelatTill',
          AssociatedComponentName: 'UtdelatTill',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        stampel: {
          AssociationName: 'stampel',
          DisplayLabel: 'Stämpel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIStampel',
          AssociatedComponentName: 'Stampel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        extraRapportering: {
          AssociationName: 'extraRapportering',
          DisplayLabel: 'extra rapportering',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TITidrapportering',
          AssociatedComponentName: 'Tidrapportering',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        tidAttester: {
          AssociationName: 'tidAttester',
          DisplayLabel: 'Attester',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAttest',
          AssociatedComponentName: 'Attest',
          JoinAssociation: false,
          ValidInComps: ['Rapportering'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        utdelad_till_2: {
          AssociationName: 'utdelad_till_2',
          DisplayLabel: 'utdelad till',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIUtdelatTill',
          AssociatedComponentName: 'UtdelatTill',
          JoinAssociation: false,
          ValidInComps: ['Rapportering'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        atteststatus: {
          AssociationName: 'atteststatus',
          DisplayLabel: 'Atteststatus',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAtteststatus',
          AssociatedComponentName: 'Atteststatus',
          JoinAssociation: false,
          ValidInComps: ['Rapportering'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        lonerader: {
          AssociationName: 'lonerader',
          DisplayLabel: 'Lönerader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIRappLonerad',
          AssociatedComponentName: 'RappLonerad',
          JoinAssociation: false,
          ValidInComps: ['Rapportering'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        TidrappOB: {
          AssociationName: 'TidrappOB',
          DisplayLabel: 'OB-tidrapportering',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidrapporteringOB',
          AssociatedComponentName: 'TidrapporteringOB',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TITidrapporteringBlob: {
      CollectionName: 'TITidrapporteringBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'RapporteringBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'TITidrapporteringBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'TITidrapporteringBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'TITidrapporteringBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'TITidrapporteringBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOMMENTAR: {
          AttributeName: 'KOMMENTAR',
          DisplayLabel: 'Kommentar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          ValidInComps: ['Rapportering'],
        },
        RAPPORTERINGSTEXT: {
          AttributeName: 'RAPPORTERINGSTEXT',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          ValidInComps: ['Rapportering'],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    TIRapporteringskod2Projekt: {
      CollectionName: 'TIRapporteringskod2Projekt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Rapporteringskod2Projekt',
        Abstract: false,
        SOLabel: 'Rapporteringskod2Projekt',
        SOGLabel: 'Rapporteringskod2Projekt',
        SBLabel: 'Rapporteringskod2Projekt',
        SBGLabel: 'Rapporteringskod2Projekt',
        POLabel: 'Rapporteringskod2Projekt',
        POGLabel: 'Rapporteringskod2Projekt',
        PBLabel: 'Rapporteringskod2Projekt',
        PBGLabel: 'Rapporteringskod2Projekt',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapporteringskod2Projekt primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapporteringskod2Projekt versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapporteringskod2Projekt id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapporteringskod2Projekt fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RAPPKOD2_ID: {
          AttributeName: 'RAPPKOD2_ID',
          DisplayLabel: 'Id, Rapporteringskod2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PROJEKT_ID: {
          AttributeName: 'PROJEKT_ID',
          DisplayLabel: 'Id, Projekt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Rapporteringskod: {
          AssociationName: 'Rapporteringskod',
          DisplayLabel: 'rapporteringskod',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIRapporteringskod',
          AssociatedComponentName: 'Rapporteringskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Projekt: {
          AssociationName: 'Projekt',
          DisplayLabel: 'Projekt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIProjekt',
          AssociatedComponentName: 'Projekt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIAKRapporteringskod2: {
      CollectionName: 'TIAKRapporteringskod2',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AKRapporteringskod2',
        Abstract: false,
        SOLabel: 'Rapporteringskod2urval',
        SOGLabel: 'Rapporteringskod2urval',
        SBLabel: 'Rapporteringskod2urvalet',
        SBGLabel: 'Rapporteringskod2urvalet',
        POLabel: 'Rapporteringskod2urval',
        POGLabel: 'Rapporteringskod2urval',
        PBLabel: 'Rapporteringskod2urvalen',
        PBGLabel: 'Rapporteringskod2urvalen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapporteringskod2urvalet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapporteringskod2urvalet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapporteringskod2urvalet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTKATEGORI_ID: {
          AttributeName: 'ATTESTKATEGORI_ID',
          DisplayLabel: 'Attestkategori',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        FRAN: {
          AttributeName: 'FRAN',
          DisplayLabel: 'Från',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
        },
        TILL: {
          AttributeName: 'TILL',
          DisplayLabel: 'Till',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    TIRapporteringskod: {
      CollectionName: 'TIRapporteringskod',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '14006']]),
      RootType: {
        TypeValue: 'Rapporteringskod',
        Abstract: false,
        SOLabel: 'Rapporteringskod',
        SOGLabel: 'Rapporteringskod',
        SBLabel: 'Rapporteringskoden',
        SBGLabel: 'Rapporteringskoden',
        POLabel: 'Rapporteringskoder',
        POGLabel: 'Rapporteringskoder',
        PBLabel: 'Rapporteringskoderna',
        PBGLabel: 'Rapporteringskoderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapporteringskoden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapporteringskoden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapporteringskoden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapporteringskoden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesHintAttribute', 'Benamning']]),
          Required: true,
        },
        KALKYLPRIS: {
          AttributeName: 'KALKYLPRIS',
          DisplayLabel: 'Kalkylpris',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MinValue="0";MaxValue="100000"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PRISANDRING_DATUM: {
          AttributeName: 'PRISANDRING_DATUM',
          DisplayLabel: 'Datum för prisändring',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxRecommendedDate="+12m";MinRecommendedDate="-12m"',
        },
        FOREG_KALKYLPRIS: {
          AttributeName: 'FOREG_KALKYLPRIS',
          DisplayLabel: 'Föregående kalkylpris',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MinValue="0";MaxValue="100000"',
        },
        EXPORT_EK: {
          AttributeName: 'EXPORT_EK',
          DisplayLabel: 'Export till ekonomiprogram',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        EXPORT_LO: {
          AttributeName: 'EXPORT_LO',
          DisplayLabel: 'Export till löneprogram',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        ENHET_ID: {
          AttributeName: 'ENHET_ID',
          DisplayLabel: 'Enhet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TILLAT_MAN_PRIS: {
          AttributeName: 'TILLAT_MAN_PRIS',
          DisplayLabel: 'Tillåt manuellt pris',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        AUT_TIDSSTAMPLING: {
          AttributeName: 'AUT_TIDSSTAMPLING',
          DisplayLabel: 'Används i stämpelklocka',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        DECIMALER: {
          AttributeName: 'DECIMALER',
          DisplayLabel: 'Antal decimaler',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="10"',
          GUIEditable: true,
        },
        ARTIKEL_ID: {
          AttributeName: 'ARTIKEL_ID',
          DisplayLabel: 'Artikel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KATEGORI_ID: {
          AttributeName: 'KATEGORI_ID',
          DisplayLabel: 'Kategori',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ENHETSTEXT: {
          AttributeName: 'ENHETSTEXT',
          DisplayLabel: 'Enhetstext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        MARKERAS: {
          AttributeName: 'MARKERAS',
          DisplayLabel: 'Markeras i tidrapport',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        ANVANDNING: {
          AttributeName: 'ANVANDNING',
          DisplayLabel: 'Användning',
          Hint: 'Normal/Tid att fördela/Fördelad tid/Tidbanksadministration/Övriga rapporteringar',
          DataType: 'Enum',
          EnumValues: new Map([['NORMAL', 'Normal'], ['TID_ATT_FORDELA', 'Tid att fördela'], ['FORDELAD_TID', 'Fördelad tid'], ['TIDBANKSADMINISTRATION', 'Tidbanksadministration'], ['OVRIGA_RAPPORTERINGAR', 'Övriga rapporteringar']]),
          EnumSortValues: new Map([['NORMAL', 'N'], ['TID_ATT_FORDELA', 'A'], ['FORDELAD_TID', 'O'], ['TIDBANKSADMINISTRATION', 'B'], ['OVRIGA_RAPPORTERINGAR', 'R']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NORMAL=Normal;TID_ATT_FORDELA=Tid att fördela;FORDELAD_TID=Fördelad tid;TIDBANKSADMINISTRATION=Tidbanksadministration;OVRIGA_RAPPORTERINGAR=Övriga rapporteringar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        TIDBANK_IN_ID: {
          AttributeName: 'TIDBANK_IN_ID',
          DisplayLabel: 'Insättning tidbank',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TIDBANK_UT_ID: {
          AttributeName: 'TIDBANK_UT_ID',
          DisplayLabel: 'Uttag tidbank',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TIDBANK_IN_FAKTOR: {
          AttributeName: 'TIDBANK_IN_FAKTOR',
          DisplayLabel: 'Tidbank insättningsfaktor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterValidateParams: 'MinValue="0";MaxValue="100"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tidbanksuppgifter',
        },
        TIDBANK_UT_FAKTOR: {
          AttributeName: 'TIDBANK_UT_FAKTOR',
          DisplayLabel: 'Tidbank uttagsfaktor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterValidateParams: 'MinValue="0";MaxValue="100"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Tidbanksuppgifter',
        },
        TIDBANK_IN_TYP: {
          AttributeName: 'TIDBANK_IN_TYP',
          DisplayLabel: 'Tidbank, insättningstyp',
          Hint: 'Faktor/En per rapportering/Schema',
          DataType: 'Enum',
          EnumValues: new Map([['FAKTOR', 'Faktor'], ['EN_PER_RAPPORTERING', 'En per rapportering'], ['SCHEMA', 'Schema']]),
          EnumSortValues: new Map([['FAKTOR', 'F'], ['EN_PER_RAPPORTERING', 'E'], ['SCHEMA', 'C']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAKTOR=Faktor;EN_PER_RAPPORTERING=En per rapportering;SCHEMA=Schema"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Tidbanksuppgifter',
        },
        TIDBANK_UT_TYP: {
          AttributeName: 'TIDBANK_UT_TYP',
          DisplayLabel: 'Tidbank, uttagstyp',
          Hint: 'Faktor/En per rapportering/Semesterfaktor/Schema',
          DataType: 'Enum',
          EnumValues: new Map([['FAKTOR', 'Faktor'], ['EN_PER_RAPPORTERING', 'En per rapportering'], ['SEMESTERFAKTOR', 'Semesterfaktor'], ['SCHEMA', 'Schema']]),
          EnumSortValues: new Map([['FAKTOR', 'F'], ['EN_PER_RAPPORTERING', 'E'], ['SEMESTERFAKTOR', 'S'], ['SCHEMA', 'C']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAKTOR=Faktor;EN_PER_RAPPORTERING=En per rapportering;SEMESTERFAKTOR=Semesterfaktor;SCHEMA=Schema"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Tidbanksuppgifter',
        },
        TID_ANGES_EJ: {
          AttributeName: 'TID_ANGES_EJ',
          DisplayLabel: 'Tid/antal ska ej anges',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        ENLIGT_SCHEMA: {
          AttributeName: 'ENLIGT_SCHEMA',
          DisplayLabel: 'Arbetstid enligt schema',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        LONEART_ID: {
          AttributeName: 'LONEART_ID',
          DisplayLabel: 'Löneart',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        enhet: {
          AttributeName: 'enhet',
          DisplayLabel: 'Enhet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        kodBenamning: {
          AttributeName: 'kodBenamning',
          DisplayLabel: 'KodBenamning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        nuvarandePris: {
          AttributeName: 'nuvarandePris',
          DisplayLabel: 'Nuvarande Kalkylpris',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        KBTIIntern: {
          AttributeName: 'KBTIIntern',
          DisplayLabel: 'KBTIIntern',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBTILon: {
          AttributeName: 'KBTILon',
          DisplayLabel: 'KBTILon',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBTIInternKre: {
          AttributeName: 'KBTIInternKre',
          DisplayLabel: 'KBTIInternKre',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        artikelPris: {
          AttributeName: 'artikelPris',
          DisplayLabel: 'Faktureringspris',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        kategoriBenamning: {
          AttributeName: 'kategoriBenamning',
          DisplayLabel: 'Kategori',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        enhetId: {
          AttributeName: 'enhetId',
          DisplayLabel: 'enhetId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        artikelNr: {
          AttributeName: 'artikelNr',
          DisplayLabel: 'Artikelnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        artikelNrBenamning: {
          AttributeName: 'artikelNrBenamning',
          DisplayLabel: 'Artikel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        projektFilter: {
          AttributeName: 'projektFilter',
          DisplayLabel: 'projektFilter',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        projektUrval: {
          AttributeName: 'projektUrval',
          DisplayLabel: 'Projekturval',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OMFATTNING: {
          AttributeName: 'OMFATTNING',
          DisplayLabel: 'Omfattning',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        loneartNrBenamning: {
          AttributeName: 'loneartNrBenamning',
          DisplayLabel: 'Löneart',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXPORT_LO_FRAN: {
          AttributeName: 'EXPORT_LO_FRAN',
          DisplayLabel: 'Export till lön från',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleKBTILon: {
          AttributeName: 'RuleKBTILon',
          DisplayLabel: 'RuleKBTILon',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleKBTIInternKre: {
          AttributeName: 'RuleKBTIInternKre',
          DisplayLabel: 'RuleKBTIInternKre',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MED_OB: {
          AttributeName: 'MED_OB',
          DisplayLabel: 'Med OB',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TILLAT_EGEN_RAPPORTERING: {
          AttributeName: 'TILLAT_EGEN_RAPPORTERING',
          DisplayLabel: 'Tillåt egen rapportering',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        KLOCKSLAG_ANGES: {
          AttributeName: 'KLOCKSLAG_ANGES',
          DisplayLabel: 'Klockslag måste anges',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        enhet: {
          AssociationName: 'enhet',
          DisplayLabel: 'Enhet',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIEnhet',
          AssociatedComponentName: 'Enhet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        artikel: {
          AssociationName: 'artikel',
          DisplayLabel: 'Artikel',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        TIDINTERN: {
          AssociationName: 'TIDINTERN',
          DisplayLabel: 'Kontering internbokföring, debet',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        TIDLON: {
          AssociationName: 'TIDLON',
          DisplayLabel: 'Kontering export till löneprogram',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        TIDINTERN_KRE: {
          AssociationName: 'TIDINTERN_KRE',
          DisplayLabel: 'Kontering internbokföring, kredit',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        loneartKategori: {
          AssociationName: 'loneartKategori',
          DisplayLabel: 'Rapporteringskodskategori',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TILoneartKategori',
          AssociatedComponentName: 'LoneartKategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        tidbankIn: {
          AssociationName: 'tidbankIn',
          DisplayLabel: 'Tidbank, insättning',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidbank',
          AssociatedComponentName: 'Tidbank',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        tidbankUt: {
          AssociationName: 'tidbankUt',
          DisplayLabel: 'Tidbank, uttag',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidbank',
          AssociatedComponentName: 'Tidbank',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        loneart: {
          AssociationName: 'loneart',
          DisplayLabel: 'Löneart/Avvikelseart',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TILoneart',
          AssociatedComponentName: 'Loneart',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        prisAnstalld: {
          AssociationName: 'prisAnstalld',
          DisplayLabel: 'Kalkylpris per anställd',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIPrisAnstalld',
          AssociatedComponentName: 'PrisAnstalld',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        rapporteringskodProjekt: {
          AssociationName: 'rapporteringskodProjekt',
          DisplayLabel: 'Projekturval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIRapporteringskodProjekt',
          AssociatedComponentName: 'RapporteringskodProjekt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        installningRappkod: {
          AssociationName: 'installningRappkod',
          DisplayLabel: 'Inställning',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIInstallningRappkod',
          AssociatedComponentName: 'InstallningRappkod',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIRapporteringskod2: {
      CollectionName: 'TIRapporteringskod2',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '14019']]),
      RootType: {
        TypeValue: 'Rapporteringskod2',
        Abstract: false,
        SOLabel: 'Rapporteringskod',
        SOGLabel: 'Rapporteringskod',
        SBLabel: 'Rapporteringskoden',
        SBGLabel: 'Rapporteringskoden',
        POLabel: 'Rapporteringskoder',
        POGLabel: 'Rapporteringskoder',
        PBLabel: 'Rapporteringskoderna',
        PBGLabel: 'Rapporteringskoderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapporteringskoden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapporteringskoden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapporteringskoden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapporteringskoden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesHintAttribute', 'Benamning']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        KBTIIntern: {
          AttributeName: 'KBTIIntern',
          DisplayLabel: 'KBTIIntern',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBTILon: {
          AttributeName: 'KBTILon',
          DisplayLabel: 'KBTILon',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBTIInternKre: {
          AttributeName: 'KBTIInternKre',
          DisplayLabel: 'KBTIInternKre',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        kodBenamning: {
          AttributeName: 'kodBenamning',
          DisplayLabel: 'kodBenamning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ALLA_PROJEKT: {
          AttributeName: 'ALLA_PROJEKT',
          DisplayLabel: 'Alla projekt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        TIDINTERN: {
          AssociationName: 'TIDINTERN',
          DisplayLabel: 'Kontering internbokföring, debet',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        TIDLON: {
          AssociationName: 'TIDLON',
          DisplayLabel: 'Kontering överföring till löneprogram',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        TIDINTERN_KRE: {
          AssociationName: 'TIDINTERN_KRE',
          DisplayLabel: 'Kontering internbokföring, kredit',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Rapporteringskod2Projekt: {
          AssociationName: 'Rapporteringskod2Projekt',
          DisplayLabel: 'Projekt',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIRapporteringskod2Projekt',
          AssociatedComponentName: 'Rapporteringskod2Projekt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIRapporteringskodProjekt: {
      CollectionName: 'TIRapporteringskodProjekt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'RapporteringskodProjekt',
        Abstract: false,
        SOLabel: 'RapporteringskodProjekt',
        SOGLabel: 'RapporteringskodProjekt',
        SBLabel: 'RapporteringskodProjekt',
        SBGLabel: 'RapporteringskodProjekt',
        POLabel: 'RapporteringskodProjekt',
        POGLabel: 'RapporteringskodProjekt',
        PBLabel: 'RapporteringskodProjekt',
        PBGLabel: 'RapporteringskodProjekt',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'RapporteringskodProjekt primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'RapporteringskodProjekt versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'RapporteringskodProjekt id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'RapporteringskodProjekt fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RAPPKOD_ID: {
          AttributeName: 'RAPPKOD_ID',
          DisplayLabel: 'Rapporteringskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FRAN: {
          AttributeName: 'FRAN',
          DisplayLabel: 'Från',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TILL: {
          AttributeName: 'TILL',
          DisplayLabel: 'Till',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        rapporteringskod: {
          AssociationName: 'rapporteringskod',
          DisplayLabel: 'Rapporteringskod',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIRapporteringskod',
          AssociatedComponentName: 'Rapporteringskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TILoneartKategori: {
      CollectionName: 'TILoneartKategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '14015']]),
      RootType: {
        TypeValue: 'LoneartKategori',
        Abstract: false,
        SOLabel: 'Rapporteringskodskategori',
        SOGLabel: 'Rapporteringskodskategori',
        SBLabel: 'Rapporteringskodskategorin',
        SBGLabel: 'Rapporteringskodskategorin',
        POLabel: 'Rapporteringskodskategorier',
        POGLabel: 'Rapporteringskodskategorier',
        PBLabel: 'Rapporteringskodskategorierna',
        PBGLabel: 'Rapporteringskodskategorierna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapporteringskodskategorin primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapporteringskodskategorin versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapporteringskodskategorin id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapporteringskodskategorin fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        kodBenamning: {
          AttributeName: 'kodBenamning',
          DisplayLabel: 'kodBenamning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VISA_I_STAMPELKLOCKA: {
          AttributeName: 'VISA_I_STAMPELKLOCKA',
          DisplayLabel: 'Visa i stämpelklocka',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        lonearter: {
          AssociationName: 'lonearter',
          DisplayLabel: 'Rapporteringskoder',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIRapporteringskod',
          AssociatedComponentName: 'Rapporteringskod',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIAKRapporteringskod: {
      CollectionName: 'TIAKRapporteringskod',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AKRapporteringskod',
        Abstract: false,
        SOLabel: 'Rapporteringskodsurval',
        SOGLabel: 'Rapporteringskodsurval',
        SBLabel: 'Rapporteringskodsurvalet',
        SBGLabel: 'Rapporteringskodsurvalet',
        POLabel: 'Rapporteringskodsurval',
        POGLabel: 'Rapporteringskodsurval',
        PBLabel: 'Rapporteringskodsurvalen',
        PBGLabel: 'Rapporteringskodsurvalen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapporteringskodsurvalet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapporteringskodsurvalet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapporteringskodsurvalet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTKATEGORI_ID: {
          AttributeName: 'ATTESTKATEGORI_ID',
          DisplayLabel: 'Attestkategori',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        FRAN: {
          AttributeName: 'FRAN',
          DisplayLabel: 'Från',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
        },
        TILL: {
          AttributeName: 'TILL',
          DisplayLabel: 'Till',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    TIRapportkategori: {
      CollectionName: 'TIRapportkategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Rapportkategori',
        Abstract: false,
        SOLabel: 'Rapportkategori',
        SOGLabel: 'Rapportkategori',
        SBLabel: 'Rapportkategorin',
        SBGLabel: 'Rapportkategorin',
        POLabel: 'Rapportkategorier',
        POGLabel: 'Rapportkategorier',
        PBLabel: 'Rapportkategorierna',
        PBGLabel: 'Rapportkategorierna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapportkategorin primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapportkategorin versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapportkategorin id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapportkategorin fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    TIVeckoschema: {
      CollectionName: 'TIVeckoschema',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '14005']]),
      RootType: {
        TypeValue: 'Veckoschema',
        Abstract: false,
        SOLabel: 'Shema',
        SOGLabel: 'Shema',
        SBLabel: 'Schemat',
        SBGLabel: 'Schemat',
        POLabel: 'Scheman',
        POGLabel: 'Scheman',
        PBLabel: 'Scheman',
        PBGLabel: 'Scheman',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Schemat primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Schemat versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Schemat id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Schemat fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        FAKTOR: {
          AttributeName: 'FAKTOR',
          DisplayLabel: 'Arbetstidsfaktor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Timmar: {
          AttributeName: 'Timmar',
          DisplayLabel: 'Timmar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
          AttributeParams: {'year': {type: 'Int', defaultValue: ''}},
        },
        grunddataFranAnnatSchema: {
          AttributeName: 'grunddataFranAnnatSchema',
          DisplayLabel: 'grunddataFranAnnatSchema',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        ANTAL_VECKOR: {
          AttributeName: 'ANTAL_VECKOR',
          DisplayLabel: 'Antal rullande veckor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="2";MaxValue="10"',
          GUIEditable: true,
        },
        Timmar2: {
          AttributeName: 'Timmar2',
          DisplayLabel: 'Timmar',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";DisplayZeroAsBlank="Y"',
        },
        Grundschema_Id: {
          AttributeName: 'Grundschema_Id',
          DisplayLabel: 'Grundschema_Id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Noteringar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Dag: {
          AssociationName: 'Dag',
          DisplayLabel: 'Schemadag',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIDag',
          AssociatedComponentName: 'Dag',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Grunddata: {
          AssociationName: 'Grunddata',
          DisplayLabel: 'Grunddatarader',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITEDTIGrunddata',
          AssociatedComponentName: 'Grunddata',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIStampel: {
      CollectionName: 'TIStampel',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '14047']]),
      RootType: {
        TypeValue: 'Stampel',
        Abstract: false,
        SOLabel: 'Stämpel',
        SOGLabel: 'Stämpel',
        SBLabel: 'Stämpeln',
        SBGLabel: 'Stämpeln',
        POLabel: 'Stämplar',
        POGLabel: 'Stämplar',
        PBLabel: 'Stämplarna',
        PBGLabel: 'Stämplarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Stämpeln primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Stämpeln versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Stämpeln id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Stämpeln fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DAGRAPPORTERING_ID: {
          AttributeName: 'DAGRAPPORTERING_ID',
          DisplayLabel: 'DAGRAPPORTERING_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Automatisk/Avrundning',
          DataType: 'Enum',
          EnumValues: new Map([['AUTOMATISK', 'Automatisk'], ['AVRUNDNING', 'Avrundning']]),
          EnumSortValues: new Map([['AUTOMATISK', 'A'], ['AVRUNDNING', 'R']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AUTOMATISK=Automatisk;AVRUNDNING=Avrundning"',
        },
        FRAN_TID: {
          AttributeName: 'FRAN_TID',
          DisplayLabel: 'Från tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Internal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Instämpling',
        },
        TILL_TID: {
          AttributeName: 'TILL_TID',
          DisplayLabel: 'Till tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Internal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Utstämpling',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Aktiv/Ej Aktiv',
          DataType: 'Enum',
          EnumValues: new Map([['AKTIV', 'Aktiv'], ['EJ_AKTIV', 'Ej Aktiv']]),
          EnumSortValues: new Map([['AKTIV', 'A'], ['EJ_AKTIV', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AKTIV=Aktiv;EJ_AKTIV=Ej Aktiv"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        REG_TID: {
          AttributeName: 'REG_TID',
          DisplayLabel: 'Från tid, registrerad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Internal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Instämpling',
        },
        MINUTER: {
          AttributeName: 'MINUTER',
          DisplayLabel: 'Tid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatMinutes',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        REG_UT_TID: {
          AttributeName: 'REG_UT_TID',
          DisplayLabel: 'Till tid, registrerad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Internal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Utstämpling',
        },
        franTill: {
          AttributeName: 'franTill',
          DisplayLabel: 'franTill',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        tidrapporteringBenamning: {
          AttributeName: 'tidrapporteringBenamning',
          DisplayLabel: 'Tidrapportering',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        franTidpunkt: {
          AttributeName: 'franTidpunkt',
          DisplayLabel: 'Från tid',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Instämpling',
        },
        franDatum: {
          AttributeName: 'franDatum',
          DisplayLabel: 'Från datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        tillTidpunkt: {
          AttributeName: 'tillTidpunkt',
          DisplayLabel: 'Till tid',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Utstämpling',
        },
        tillDatum: {
          AttributeName: 'tillDatum',
          DisplayLabel: 'Till datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Utstämpling',
        },
        regTidpunkt: {
          AttributeName: 'regTidpunkt',
          DisplayLabel: 'Från tid, registrerad',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Instämpling',
        },
        regUtTidpunkt: {
          AttributeName: 'regUtTidpunkt',
          DisplayLabel: 'Till tid, registrerad',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Utstämpling',
        },
        INSTAMPLINGSTYP: {
          AttributeName: 'INSTAMPLINGSTYP',
          DisplayLabel: 'Instämplingstyp',
          Hint: 'Normal/Avvikande tid/Automatiskt inlagd rast',
          DataType: 'Enum',
          EnumValues: new Map([['NORMAL', 'Normal'], ['AVVIKANDE_TID', 'Avvikande tid'], ['AUTOMATISKT_INLAGD_RAST', 'Automatiskt inlagd rast']]),
          EnumSortValues: new Map([['NORMAL', 'N'], ['AVVIKANDE_TID', 'A'], ['AUTOMATISKT_INLAGD_RAST', 'R']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NORMAL=Normal;AVVIKANDE_TID=Avvikande tid;AUTOMATISKT_INLAGD_RAST=Automatiskt inlagd rast"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Instämpling',
          Required: true,
        },
        UTSTAMPLINGSTYP: {
          AttributeName: 'UTSTAMPLINGSTYP',
          DisplayLabel: 'Utstämplingstyp',
          Hint: 'Normal/Avvikande tid/Automatiskt inlagd rast',
          DataType: 'Enum',
          EnumValues: new Map([['NORMAL', 'Normal'], ['AVVIKANDE_TID', 'Avvikande tid'], ['AUTOMATISKT_INLAGD_RAST', 'Automatiskt inlagd rast']]),
          EnumSortValues: new Map([['NORMAL', 'N'], ['AVVIKANDE_TID', 'A'], ['AUTOMATISKT_INLAGD_RAST', 'R']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NORMAL=Normal;AVVIKANDE_TID=Avvikande tid;AUTOMATISKT_INLAGD_RAST=Automatiskt inlagd rast"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Utstämpling',
          Required: true,
        },
        aktuellUppgiftId: {
          AttributeName: 'aktuellUppgiftId',
          DisplayLabel: 'aktuellUppgiftId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Dagrapportering: {
          AssociationName: 'Dagrapportering',
          DisplayLabel: 'Tidrapportering',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidrapportering',
          AssociatedComponentName: 'Tidrapportering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TITEDTISasong: {
      CollectionName: 'TITEDTISasong',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Sasong',
        Abstract: false,
        SOLabel: 'Säsong',
        SOGLabel: 'Säsong',
        SBLabel: 'Säsongen',
        SBGLabel: 'Säsongen',
        POLabel: 'Säsonger',
        POGLabel: 'Säsonger',
        PBLabel: 'Säsongerna',
        PBGLabel: 'Säsongerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Säsongen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Säsongen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Säsongen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Säsongen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FRAN_MAN: {
          AttributeName: 'FRAN_MAN',
          DisplayLabel: 'Från månad',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1";MaxValue="12"',
          GUIEditable: true,
          Required: true,
        },
        TILL_MAN: {
          AttributeName: 'TILL_MAN',
          DisplayLabel: 'Till månad',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1";MaxValue="12"',
          GUIEditable: true,
          Required: true,
        },
        FRAN_DAG: {
          AttributeName: 'FRAN_DAG',
          DisplayLabel: 'Från dag',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1";MaxValue="31"',
          GUIEditable: true,
          Required: true,
        },
        TILL_DAG: {
          AttributeName: 'TILL_DAG',
          DisplayLabel: 'Till dag',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1";MaxValue="31"',
          GUIEditable: true,
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
          Required: true,
        },
        beskrivning: {
          AttributeName: 'beskrivning',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    TITidbank: {
      CollectionName: 'TITidbank',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '14021']]),
      RootType: {
        TypeValue: 'Tidbank',
        Abstract: false,
        SOLabel: 'Tidbank',
        SOGLabel: 'Tidbank',
        SBLabel: 'Tidbanken',
        SBGLabel: 'Tidbanken',
        POLabel: 'Tidbanker',
        POGLabel: 'Tidbanker',
        PBLabel: 'Tidbankerna',
        PBGLabel: 'Tidbankerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Tidbanken primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Tidbanken versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Tidbanken id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Tidbanken fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        ENHET_ID: {
          AttributeName: 'ENHET_ID',
          DisplayLabel: 'Enhet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        totaltSaldo: {
          AttributeName: 'totaltSaldo',
          DisplayLabel: 'Summa tid',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        aktuelltSaldoAntal: {
          AttributeName: 'aktuelltSaldoAntal',
          DisplayLabel: 'Aktuellt saldo',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
        },
        aktuelltSaldoMinuter: {
          AttributeName: 'aktuelltSaldoMinuter',
          DisplayLabel: 'Aktuellt Saldo',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatMinutes',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        tidbanksaldo: {
          AssociationName: 'tidbanksaldo',
          DisplayLabel: 'Tidbanksaldo',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidbankSaldo',
          AssociatedComponentName: 'Tidbanksaldo',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        installningTidbank: {
          AssociationName: 'installningTidbank',
          DisplayLabel: 'Inställningar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIInstallningTidbank',
          AssociatedComponentName: 'InstallningTidbank',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TITidbankSaldo: {
      CollectionName: 'TITidbankSaldo',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Tidbanksaldo',
        Abstract: false,
        SOLabel: 'Tidbanksaldo',
        SOGLabel: 'Tidbanksaldo',
        SBLabel: 'Tidbanksaldo',
        SBGLabel: 'Tidbanksaldo',
        POLabel: 'Tidbanksaldo',
        POGLabel: 'Tidbanksaldo',
        PBLabel: 'Tidbanksaldo',
        PBGLabel: 'Tidbanksaldo',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Tidbanksaldo primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Tidbanksaldo versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Tidbanksaldo id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Tidbanksaldo fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MANAD: {
          AttributeName: 'MANAD',
          DisplayLabel: 'Månad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          FormatterParseParams: 'Format="y-m/ymm"',
          FormatterDisplayParams: 'Format="yyyy-mm"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        SALDO_MINUTER: {
          AttributeName: 'SALDO_MINUTER',
          DisplayLabel: 'Utgående saldo i tid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatMinutes',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ av saldo',
          Hint: 'Senast avslutade månad/Tidigare avslutade månader/Kalkylerat värde',
          DataType: 'Enum',
          EnumValues: new Map([['SENAST_AVSLUTADE_MANAD', 'Senast avslutade månad'], ['TIDIGARE_AVSLUTADE_MANADER', 'Tidigare avslutade månader'], ['KALKYLERAT_VARDE', 'Kalkylerat värde']]),
          EnumSortValues: new Map([['SENAST_AVSLUTADE_MANAD', 'A'], ['TIDIGARE_AVSLUTADE_MANADER', 'H'], ['KALKYLERAT_VARDE', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SENAST_AVSLUTADE_MANAD=Senast avslutade månad;TIDIGARE_AVSLUTADE_MANADER=Tidigare avslutade månader;KALKYLERAT_VARDE=Kalkylerat värde"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        ingSaldo: {
          AttributeName: 'ingSaldo',
          DisplayLabel: 'Ingående saldo',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        tidbankBenamning: {
          AttributeName: 'tidbankBenamning',
          DisplayLabel: 'Tidbank',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        saldoDiff: {
          AttributeName: 'saldoDiff',
          DisplayLabel: 'Förändring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        anstalldNrNamn: {
          AttributeName: 'anstalldNrNamn',
          DisplayLabel: 'Anställd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        utgSaldo: {
          AttributeName: 'utgSaldo',
          DisplayLabel: 'Utgående saldo',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        saldoAntal: {
          AttributeName: 'saldoAntal',
          DisplayLabel: 'Utgående saldo i antal',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        saldoDiffAntal: {
          AttributeName: 'saldoDiffAntal',
          DisplayLabel: 'Förändring i antal',
          Hint: 'T.ex. semesterdagar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        saldoDiffMinuter: {
          AttributeName: 'saldoDiffMinuter',
          DisplayLabel: 'Förändring i tid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatMinutes',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ingSaldoAntal: {
          AttributeName: 'ingSaldoAntal',
          DisplayLabel: 'Ingående saldo i antal',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ingSaldoMinuter: {
          AttributeName: 'ingSaldoMinuter',
          DisplayLabel: 'Ingående saldo i tid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatMinutes',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        tidbankAnvands: {
          AttributeName: 'tidbankAnvands',
          DisplayLabel: 'Tidbank används',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        manAnstalld: {
          AssociationName: 'manAnstalld',
          DisplayLabel: 'Månadsrapportering',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIManAnstalld',
          AssociatedComponentName: 'ManAnstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        tidbank: {
          AssociationName: 'tidbank',
          DisplayLabel: 'Tidbank',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidbank',
          AssociatedComponentName: 'Tidbank',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIRapportFalt: {
      CollectionName: 'TIRapportFalt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'RapportFalt',
        Abstract: false,
        SOLabel: 'Tidrapport, Kolumn',
        SOGLabel: 'Tidrapport, Kolumn',
        SBLabel: 'Tidrapport, Kolumnen',
        SBGLabel: 'Tidrapport, Kolumnen',
        POLabel: 'Tidrapport, Kolumner',
        POGLabel: 'Tidrapport, Kolumner',
        PBLabel: 'Tidrapport, Kolumnerna',
        PBGLabel: 'Tidrapport, Kolumnerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Tidrapport, Kolumnen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Tidrapport, Kolumnen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Tidrapport, Kolumnen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Tidrapport, Kolumnen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SPECIFIKATION: {
          AttributeName: 'SPECIFIKATION',
          DisplayLabel: 'Fältspecifikation',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FALTKOD: {
          AttributeName: 'FALTKOD',
          DisplayLabel: 'Hämtas från',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FROM_AR: {
          AttributeName: 'FROM_AR',
          DisplayLabel: 'Fr o m år',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FROM_AR_RELATIV: {
          AttributeName: 'FROM_AR_RELATIV',
          DisplayLabel: 'Fr o m relativ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TOM_AR: {
          AttributeName: 'TOM_AR',
          DisplayLabel: 'T o m år',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TOM_AR_RELATIV: {
          AttributeName: 'TOM_AR_RELATIV',
          DisplayLabel: 'T o m år relativ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FROM_PER: {
          AttributeName: 'FROM_PER',
          DisplayLabel: 'Fr o m period',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FROM_PER_RELATIV: {
          AttributeName: 'FROM_PER_RELATIV',
          DisplayLabel: 'Fr o m period relativ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TOM_PER: {
          AttributeName: 'TOM_PER',
          DisplayLabel: 'T o m period',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TOM_PER_RELATIV: {
          AttributeName: 'TOM_PER_RELATIV',
          DisplayLabel: 'T o m period relativ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FALT_TYP: {
          AttributeName: 'FALT_TYP',
          DisplayLabel: 'Fälttyp',
          Hint: 'Valuta/Debet/Kredit/Antal',
          DataType: 'Enum',
          EnumValues: new Map([['VALUTA', 'Valuta'], ['DEBET', 'Debet'], ['KREDIT', 'Kredit'], ['ANTAL', 'Antal']]),
          EnumSortValues: new Map([['VALUTA', 'V'], ['DEBET', 'D'], ['KREDIT', 'K'], ['ANTAL', 'A']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="VALUTA=Valuta;DEBET=Debet;KREDIT=Kredit;ANTAL=Antal"',
        },
        VISA_FROM_TOM: {
          AttributeName: 'VISA_FROM_TOM',
          DisplayLabel: 'Visa from/tom',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BAS: {
          AttributeName: 'BAS',
          DisplayLabel: 'Bas',
          Hint: 'Kronor/Tusentals kronor/Miljontals kronor',
          DataType: 'Enum',
          EnumValues: new Map([['KRONOR', 'Kronor'], ['TUSENTALS_KRONOR', 'Tusentals kronor'], ['MILJONTALS_KRONOR', 'Miljontals kronor']]),
          EnumSortValues: new Map([['KRONOR', '1'], ['TUSENTALS_KRONOR', '1000'], ['MILJONTALS_KRONOR', '1000000']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KRONOR=Kronor;TUSENTALS_KRONOR=Tusentals kronor;MILJONTALS_KRONOR=Miljontals kronor"',
        },
        ANTAL_DECIMALER: {
          AttributeName: 'ANTAL_DECIMALER',
          DisplayLabel: 'Antal decimaler',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VAND_TECKEN: {
          AttributeName: 'VAND_TECKEN',
          DisplayLabel: 'Vänd tecken',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BREDD_PROCENT: {
          AttributeName: 'BREDD_PROCENT',
          DisplayLabel: 'Procentuell bredd vid utskrift',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING2: {
          AttributeName: 'BENAMNING2',
          DisplayLabel: 'Benämning 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NOLLUNDERTRYCK: {
          AttributeName: 'NOLLUNDERTRYCK',
          DisplayLabel: 'Nollundertryckning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FIELDID: {
          AttributeName: 'FIELDID',
          DisplayLabel: 'Fält id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUB_FONT_NAMN: {
          AttributeName: 'RUB_FONT_NAMN',
          DisplayLabel: 'Teckensnitt, rubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUB_STORLEK: {
          AttributeName: 'RUB_STORLEK',
          DisplayLabel: 'Rubrik, storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUB_BOLD: {
          AttributeName: 'RUB_BOLD',
          DisplayLabel: 'Rubrik, fet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUB_ITALIC: {
          AttributeName: 'RUB_ITALIC',
          DisplayLabel: 'Rubrik, kursiv',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUB_UNDERLINE: {
          AttributeName: 'RUB_UNDERLINE',
          DisplayLabel: 'Rubrik, understruken',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKRIV_UT: {
          AttributeName: 'SKRIV_UT',
          DisplayLabel: 'Skriv',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP_FARG_NEGATIV: {
          AttributeName: 'BELOPP_FARG_NEGATIV',
          DisplayLabel: 'Färg för negativt belopp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INTERVALL_TYP: {
          AttributeName: 'INTERVALL_TYP',
          DisplayLabel: 'Intervalltyp',
          Hint: 'Period/Datum',
          DataType: 'Enum',
          EnumValues: new Map([['PERIOD', 'Period'], ['DATUM', 'Datum']]),
          EnumSortValues: new Map([['PERIOD', '0'], ['DATUM', '1']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PERIOD=Period;DATUM=Datum"',
        },
        BREDD_MM: {
          AttributeName: 'BREDD_MM',
          DisplayLabel: 'Kolumnbredd i mm',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Kolumntyp',
          Hint: 'Enkel/Beräknad',
          DataType: 'Enum',
          EnumValues: new Map([['ENKEL', 'Enkel'], ['BERAKNAD', 'Beräknad']]),
          EnumSortValues: new Map([['ENKEL', 'F'], ['BERAKNAD', 'B']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ENKEL=Enkel;BERAKNAD=Beräknad"',
          GUIEditable: true,
          Required: true,
        },
        RESULTAT_TYP: {
          AttributeName: 'RESULTAT_TYP',
          DisplayLabel: 'Resultattyp',
          Hint: 'Belopp/Procent',
          DataType: 'Enum',
          EnumValues: new Map([['BELOPP', 'Belopp'], ['PROCENT', 'Procent']]),
          EnumSortValues: new Map([['BELOPP', 'B'], ['PROCENT', 'P']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BELOPP=Belopp;PROCENT=Procent"',
          GUIEditable: true,
          Required: true,
        },
        ENHET_ID: {
          AttributeName: 'ENHET_ID',
          DisplayLabel: 'Enhet, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    TIGruppering: {
      CollectionName: 'TIGruppering',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'Gruppering',
        Abstract: false,
        SOLabel: 'Tidrapport, Radnivå',
        SOGLabel: 'Tidrapport, Radnivå',
        SBLabel: 'Tidrapport, Radnivån',
        SBGLabel: 'Tidrapport, Radnivån',
        POLabel: 'Tidrapport, Radnivåer',
        POGLabel: 'Tidrapport, Radnivåer',
        PBLabel: 'Tidrapport, Radnivåerna',
        PBGLabel: 'Tidrapport, Radnivåerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Tidrapport, Radnivån primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Tidrapport, Radnivån versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Tidrapport, Radnivån id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Tidrapport, Radnivån fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_KONTODEL: {
          AttributeName: 'ORDNINGS_NR_KONTODEL',
          DisplayLabel: 'Ordningsnr för kontodel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STARTPOS: {
          AttributeName: 'STARTPOS',
          DisplayLabel: 'Startposition',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SLUTPOS: {
          AttributeName: 'SLUTPOS',
          DisplayLabel: 'Slutposition',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DOLJ_NIVA: {
          AttributeName: 'DOLJ_NIVA',
          DisplayLabel: 'Dölj nivå',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SIDBRYTNING: {
          AttributeName: 'SIDBRYTNING',
          DisplayLabel: 'Sidbrytning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING_BLANK: {
          AttributeName: 'BENAMNING_BLANK',
          DisplayLabel: 'Benämning för blank kontodel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING_ANTAL_POS: {
          AttributeName: 'BENAMNING_ANTAL_POS',
          DisplayLabel: 'Antal tecken i benämningen',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING_FLERA_RADER: {
          AttributeName: 'BENAMNING_FLERA_RADER',
          DisplayLabel: 'Tillåt benämning på flera rader',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRUPPERINGSTYP: {
          AttributeName: 'GRUPPERINGSTYP',
          DisplayLabel: 'Grupperingstyp',
          Hint: 'Kund/Kundkategori/Projekt/Anställd/Anställd kategori/Arbetsuppgift/Rapporteringskod/Rapporteringskod 2/Artikel/Anställd - lön',
          DataType: 'Enum',
          EnumValues: new Map([['KUND', 'Kund'], ['KUNDKATEGORI', 'Kundkategori'], ['PROJEKT', 'Projekt'], ['ANSTALLD', 'Anställd'], ['ANSTALLD_KATEGORI', 'Anställd kategori'], ['ARBETSUPPGIFT', 'Arbetsuppgift'], ['RAPPORTERINGSKOD', 'Rapporteringskod'], ['RAPPORTERINGSKOD_2', 'Rapporteringskod 2'], ['ARTIKEL', 'Artikel'], ['ANSTALLD___LON', 'Anställd - lön']]),
          EnumSortValues: new Map([['KUND', 'TIKUND'], ['KUNDKATEGORI', 'TIKUNDKAT'], ['PROJEKT', 'TIPROJEKT'], ['ANSTALLD', 'TIAN'], ['ANSTALLD_KATEGORI', 'TIANKAT'], ['ARBETSUPPGIFT', 'TIARB'], ['RAPPORTERINGSKOD', 'TIRAPKOD'], ['RAPPORTERINGSKOD_2', 'TIRAPKOD2'], ['ARTIKEL', 'TIART'], ['ANSTALLD___LON', 'TIANL']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KUND=Kund;KUNDKATEGORI=Kundkategori;PROJEKT=Projekt;ANSTALLD=Anställd;ANSTALLD_KATEGORI=Anställd kategori;ARBETSUPPGIFT=Arbetsuppgift;RAPPORTERINGSKOD=Rapporteringskod;RAPPORTERINGSKOD_2=Rapporteringskod 2;ARTIKEL=Artikel;ANSTALLD___LON=Anställd - lön"',
        },
        FONT_NAMN: {
          AttributeName: 'FONT_NAMN',
          DisplayLabel: 'Teckensnitt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STORLEK: {
          AttributeName: 'STORLEK',
          DisplayLabel: 'Storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOLD: {
          AttributeName: 'BOLD',
          DisplayLabel: 'Fet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ITALIC: {
          AttributeName: 'ITALIC',
          DisplayLabel: 'Kursiv',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UNDERLINE: {
          AttributeName: 'UNDERLINE',
          DisplayLabel: 'Understruken',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STRIKE_OUT: {
          AttributeName: 'STRIKE_OUT',
          DisplayLabel: 'Genomstruken',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DIVERSE: {
          AttributeName: 'DIVERSE',
          DisplayLabel: 'Diverse',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSUMMA: {
          AttributeName: 'DELSUMMA',
          DisplayLabel: 'Delsumma',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKRIV_DELSUMMA: {
          AttributeName: 'SKRIV_DELSUMMA',
          DisplayLabel: 'Skriv delsumma',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSUMMA_FORMAT: {
          AttributeName: 'DELSUMMA_FORMAT',
          DisplayLabel: 'Delsumma format',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSUMMA_FONT_NAMN: {
          AttributeName: 'DELSUMMA_FONT_NAMN',
          DisplayLabel: 'Delsumma, teckensnitt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSUMMA_STORLEK: {
          AttributeName: 'DELSUMMA_STORLEK',
          DisplayLabel: 'Delsumma, storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSUMMA_BOLD: {
          AttributeName: 'DELSUMMA_BOLD',
          DisplayLabel: 'Delsumma, fetstil',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSUMMA_ITALIC: {
          AttributeName: 'DELSUMMA_ITALIC',
          DisplayLabel: 'Delsumma, kursiv',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSUMMA_UNDERLINE: {
          AttributeName: 'DELSUMMA_UNDERLINE',
          DisplayLabel: 'Delsumma, understruken',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSUMMA_STRIKE_OUT: {
          AttributeName: 'DELSUMMA_STRIKE_OUT',
          DisplayLabel: 'Delsumma, genomstruken',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BREDD: {
          AttributeName: 'BREDD',
          DisplayLabel: 'Bredd',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="120"',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    Tidrapport: {
      CollectionName: 'Tidrapport',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'DRapport',
        Abstract: false,
        SOLabel: 'Tidrapport',
        SOGLabel: 'Tidrapport',
        SBLabel: 'Tidrapporten',
        SBGLabel: 'Tidrapporten',
        POLabel: 'Tidrapporter',
        POGLabel: 'Tidrapporter',
        PBLabel: 'Tidrapporterna',
        PBGLabel: 'Tidrapporterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Tidrapporten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Tidrapporten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Tidrapporten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Tidrapporten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP_UTSKRIFT: {
          AttributeName: 'BELOPP_UTSKRIFT',
          DisplayLabel: 'Utskrift av belopp',
          Hint: 'Standard/Enligt rad/Annan',
          DataType: 'Enum',
          EnumValues: new Map([['STANDARD', 'Standard'], ['ENLIGT_RAD', 'Enligt rad'], ['ANNAN', 'Annan']]),
          EnumSortValues: new Map([['STANDARD', 'S'], ['ENLIGT_RAD', 'R'], ['ANNAN', 'A']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STANDARD=Standard;ENLIGT_RAD=Enligt rad;ANNAN=Annan"',
        },
        BELOPP_BOLD_ENL_RAD: {
          AttributeName: 'BELOPP_BOLD_ENL_RAD',
          DisplayLabel: 'Fetstil enligt rad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP_FONT_NAMN: {
          AttributeName: 'BELOPP_FONT_NAMN',
          DisplayLabel: 'Belopp - font',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP_STORLEK: {
          AttributeName: 'BELOPP_STORLEK',
          DisplayLabel: 'Belopp - storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP_BOLD: {
          AttributeName: 'BELOPP_BOLD',
          DisplayLabel: 'Belopp -fetstil',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP_ITALIC: {
          AttributeName: 'BELOPP_ITALIC',
          DisplayLabel: 'Belopp - kursiv',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP_UNDERLINE: {
          AttributeName: 'BELOPP_UNDERLINE',
          DisplayLabel: 'Belopp - understruken',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP_STRIKE_OUT: {
          AttributeName: 'BELOPP_STRIKE_OUT',
          DisplayLabel: 'BELOPP_STRIKE_OUT',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORMAT: {
          AttributeName: 'FORMAT',
          DisplayLabel: 'Stående/Liggande',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP_SEPARATOR: {
          AttributeName: 'BELOPP_SEPARATOR',
          DisplayLabel: 'Avskiljare för kolumner',
          Hint: 'Ingen/Skuggning/Linjer',
          DataType: 'Enum',
          EnumValues: new Map([['INGEN', 'Ingen'], ['SKUGGNING', 'Skuggning'], ['LINJER', 'Linjer']]),
          EnumSortValues: new Map([['INGEN', 'I'], ['SKUGGNING', 'S'], ['LINJER', 'L']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INGEN=Ingen;SKUGGNING=Skuggning;LINJER=Linjer"',
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        HUVUD_ID: {
          AttributeName: 'HUVUD_ID',
          DisplayLabel: 'Sidhuvud',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Rapportmall: {
          AttributeName: 'Rapportmall',
          DisplayLabel: 'Rapportmall',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Sidhuvud: {
          AttributeName: 'Sidhuvud',
          DisplayLabel: 'Sidhuvud',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KONTOSTRANG_DETALJRAD: {
          AttributeName: 'KONTOSTRANG_DETALJRAD',
          DisplayLabel: 'Kontosträng på detaljrader',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKAPAD_DATUM: {
          AttributeName: 'SKAPAD_DATUM',
          DisplayLabel: 'Skapad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANDRAD_DATUM: {
          AttributeName: 'ANDRAD_DATUM',
          DisplayLabel: 'Senast ändrad',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KATEGORI_ID: {
          AttributeName: 'KATEGORI_ID',
          DisplayLabel: 'Rapportkategori, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DOLJ_NOLLRADER: {
          AttributeName: 'DOLJ_NOLLRADER',
          DisplayLabel: 'Dölj nollrader',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        Kategori: {
          AttributeName: 'Kategori',
          DisplayLabel: 'Kategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SKRIV_NOT: {
          AttributeName: 'SKRIV_NOT',
          DisplayLabel: 'Använd not',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STD_RAPPORT: {
          AttributeName: 'STD_RAPPORT',
          DisplayLabel: 'Standardrapport',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        LOPSALDO_DETALJRAD: {
          AttributeName: 'LOPSALDO_DETALJRAD',
          DisplayLabel: 'Löpande saldo på detaljrad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DOLJ_TOTALSUMMA: {
          AttributeName: 'DOLJ_TOTALSUMMA',
          DisplayLabel: 'Dölj totalsumma',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        RAPPORTTYP: {
          AttributeName: 'RAPPORTTYP',
          DisplayLabel: 'Rapporttyp',
          Hint: 'Löpande',
          DataType: 'Enum',
          EnumValues: new Map([['LOPANDE', 'Löpande']]),
          EnumSortValues: new Map([['LOPANDE', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LOPANDE=Löpande"',
          GUIEditable: true,
        },
        INDENTERA_NIVAER: {
          AttributeName: 'INDENTERA_NIVAER',
          DisplayLabel: 'Indentera nivåer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 30,
        },
        BEN_FLERA_RADER: {
          AttributeName: 'BEN_FLERA_RADER',
          DisplayLabel: 'Tillåt flera rader i benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        BEN_BREDD: {
          AttributeName: 'BEN_BREDD',
          DisplayLabel: 'Benämningens bredd (mm)',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        ANVAND_FARG: {
          AttributeName: 'ANVAND_FARG',
          DisplayLabel: 'Färga nivåer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        SUMMA_FONT_NAMN: {
          AttributeName: 'SUMMA_FONT_NAMN',
          DisplayLabel: 'Summa, teckensnitt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        SUMMA_STORLEK: {
          AttributeName: 'SUMMA_STORLEK',
          DisplayLabel: 'Summa, storlek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        SUMMA_BOLD: {
          AttributeName: 'SUMMA_BOLD',
          DisplayLabel: 'Summa, fet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        SUMMA_ITALIC: {
          AttributeName: 'SUMMA_ITALIC',
          DisplayLabel: 'Summa, kursiv',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        SUMMA_UNDERLINE: {
          AttributeName: 'SUMMA_UNDERLINE',
          DisplayLabel: 'Summa, understruken',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        SUMMA_STRIKE_OUT: {
          AttributeName: 'SUMMA_STRIKE_OUT',
          DisplayLabel: 'Summe, genomstruken',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        DETALJ_FONT_NAMN: {
          AttributeName: 'DETALJ_FONT_NAMN',
          DisplayLabel: 'Detaljnivå, teckensnitt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        DETALJ_STORLEK: {
          AttributeName: 'DETALJ_STORLEK',
          DisplayLabel: 'Detalj, storlek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        DETALJ_BOLD: {
          AttributeName: 'DETALJ_BOLD',
          DisplayLabel: 'Detaljnivå, fet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        DETALJ_ITALIC: {
          AttributeName: 'DETALJ_ITALIC',
          DisplayLabel: 'Detaljnivå, kursiv',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        DETALJ_UNDERLINE: {
          AttributeName: 'DETALJ_UNDERLINE',
          DisplayLabel: 'Detaljnivå, understruken',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        DETALJ_STRIKE_OUT: {
          AttributeName: 'DETALJ_STRIKE_OUT',
          DisplayLabel: 'Detaljnivå, genomstruken',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        DETAIL_OPTIONS: {
          AttributeName: 'DETAIL_OPTIONS',
          DisplayLabel: 'Detaljval',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Rapportmall: {
          AssociationName: 'Rapportmall',
          DisplayLabel: 'Rapportmall',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKRapportMall',
          AssociatedComponentName: 'RapportMall',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Sidhuvud: {
          AssociationName: 'Sidhuvud',
          DisplayLabel: 'Sidhuvud',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKRapportHuvud',
          AssociatedComponentName: 'Rapporthuvud',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kategori: {
          AssociationName: 'Kategori',
          DisplayLabel: 'Kategori',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIRapportkategori',
          AssociatedComponentName: 'Rapportkategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Rapportfalt: {
          AssociationName: 'Rapportfalt',
          DisplayLabel: 'Rapportfält',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKRapportFalt',
          AssociatedComponentName: 'RapportFalt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKRapportUrval',
          AssociatedComponentName: 'RapportUrval',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIRappLonerad: {
      CollectionName: 'TIRappLonerad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'RappLonerad',
        Abstract: false,
        SOLabel: 'TidrapporteringLönerad',
        SOGLabel: 'TidrapporteringLönerad',
        SBLabel: 'TidrapporteringLönerad',
        SBGLabel: 'TidrapporteringLönerad',
        POLabel: 'TidrapporteringLönerad',
        POGLabel: 'TidrapporteringLönerad',
        PBLabel: 'TidrapporteringLönerad',
        PBGLabel: 'TidrapporteringLönerad',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'TidrapporteringLönerad primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'TidrapporteringLönerad versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'TidrapporteringLönerad id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'TidrapporteringLönerad fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LONERAD_ID: {
          AttributeName: 'LONERAD_ID',
          DisplayLabel: 'Lönerad',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TIDRAPPORTERING_ID: {
          AttributeName: 'TIDRAPPORTERING_ID',
          DisplayLabel: 'Tidrapportering',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        tidrappDatum: {
          AttributeName: 'tidrappDatum',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        tidrappAnstalldNamn: {
          AttributeName: 'tidrappAnstalldNamn',
          DisplayLabel: 'Anställd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        tidrappBenamning: {
          AttributeName: 'tidrappBenamning',
          DisplayLabel: 'Arbetsuppgift',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        tidrappAntalTid: {
          AttributeName: 'tidrappAntalTid',
          DisplayLabel: 'Antal/Tid',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        tidrappProjektBenamning: {
          AttributeName: 'tidrappProjektBenamning',
          DisplayLabel: 'Projekt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        tidrappRappkod: {
          AttributeName: 'tidrappRappkod',
          DisplayLabel: 'Rapporteringskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        tidrappRappkod2: {
          AttributeName: 'tidrappRappkod2',
          DisplayLabel: 'Rapporteringskod 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Tidrapportering: {
          AssociationName: 'Tidrapportering',
          DisplayLabel: 'Tidrapportering',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TITidrapportering',
          AssociatedComponentName: 'Tidrapportering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Lonerad: {
          AssociationName: 'Lonerad',
          DisplayLabel: 'Lönerad',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TILonerad',
          AssociatedComponentName: 'Lonerad',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
        },
      },
    },
    TITidrappAttest: {
      CollectionName: 'TITidrappAttest',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'TidrappAttest',
        Abstract: false,
        SOLabel: 'Tidrapporteringsattest',
        SOGLabel: 'Tidrapporteringsattest',
        SBLabel: 'Tidrapporteringsattester',
        SBGLabel: 'Tidrapporteringsattester',
        POLabel: 'Tidrapporteringsattester',
        POGLabel: 'Tidrapporteringsattester',
        PBLabel: 'Tidrapporteringsattesterna',
        PBGLabel: 'Tidrapporteringsattesterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Tidrapporteringsattester primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Tidrapporteringsattester versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Tidrapporteringsattester fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANV_ID: {
          AttributeName: 'ANV_ID',
          DisplayLabel: 'Användare, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Signatur: {
          AttributeName: 'Signatur',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    TITidGrupp: {
      CollectionName: 'TITidGrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '14010']]),
      RootType: {
        TypeValue: 'TidGrupp',
        Abstract: false,
        SOLabel: 'Tidredovisningsgrupp',
        SOGLabel: 'Tidredovisningsgrupp',
        SBLabel: 'Tidredovisningsgruppen',
        SBGLabel: 'Tidredovisningsgruppen',
        POLabel: 'Tidredovisningsgrupper',
        POGLabel: 'Tidredovisningsgrupper',
        PBLabel: 'Tidredovisningsgrupperna',
        PBGLabel: 'Tidredovisningsgrupperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Tidredovisningsgruppen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Tidredovisningsgruppen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Tidredovisningsgruppen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Tidredovisningsgruppen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        NUMMERSERIE_ID: {
          AttributeName: 'NUMMERSERIE_ID',
          DisplayLabel: 'Nummerserie',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        nummerserie: {
          AssociationName: 'nummerserie',
          DisplayLabel: 'Nummerserie',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSNummerserie',
          AssociatedComponentName: 'Nummerserie',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIUppgiftIPU: {
      CollectionName: 'TIUppgiftIPU',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'UppgiftIPU',
        Abstract: false,
        SOLabel: 'Uppgift',
        SOGLabel: 'Uppgift',
        SBLabel: 'Uppgiften',
        SBGLabel: 'Uppgiften',
        POLabel: 'Uppgifter',
        POGLabel: 'Uppgifter',
        PBLabel: 'Uppgifterna',
        PBGLabel: 'Uppgifterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Uppgiften primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Uppgiften versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Uppgiften id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Uppgiften fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    TIUtdelatTill: {
      CollectionName: 'TIUtdelatTill',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'UtdelatTill',
        Abstract: false,
        SOLabel: 'Utdelning',
        SOGLabel: 'Utdelning',
        SBLabel: 'Utdelningen',
        SBGLabel: 'Utdelningen',
        POLabel: 'Utdelningar',
        POGLabel: 'Utdelningar',
        PBLabel: 'Utdelningarna',
        PBGLabel: 'Utdelningarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Utdelningen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Utdelningen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Utdelningen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Utdelningen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MEDDELANDE: {
          AttributeName: 'MEDDELANDE',
          DisplayLabel: 'Meddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 250,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FRAMSKJUTEN_TILL: {
          AttributeName: 'FRAMSKJUTEN_TILL',
          DisplayLabel: 'Framskjuten till',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxRecommendedDate="+12m";MinRecommendedDate="-12m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PRIORITET_ID: {
          AttributeName: 'PRIORITET_ID',
          DisplayLabel: 'Prioritet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REG_ANV_ID: {
          AttributeName: 'REG_ANV_ID',
          DisplayLabel: 'REG_ANV_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REG_TID: {
          AttributeName: 'REG_TID',
          DisplayLabel: 'Registreringsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DOLD: {
          AttributeName: 'DOLD',
          DisplayLabel: 'Dold',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        AVSLUTAD: {
          AttributeName: 'AVSLUTAD',
          DisplayLabel: 'Avslutad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        AVSLUTAD_TID: {
          AttributeName: 'AVSLUTAD_TID',
          DisplayLabel: 'Avslutad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        arbetsuppgiftRubrik: {
          AttributeName: 'arbetsuppgiftRubrik',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        anstalldNamn: {
          AttributeName: 'anstalldNamn',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        registreradAvNamn: {
          AttributeName: 'registreradAvNamn',
          DisplayLabel: 'Registrerad av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        arbetstid: {
          AttributeName: 'arbetstid',
          DisplayLabel: 'Tid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatMinutes',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        arbetsuppgiftNrRubrikKund: {
          AttributeName: 'arbetsuppgiftNrRubrikKund',
          DisplayLabel: 'Arbetsuppgift',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        prislista: {
          AttributeName: 'prislista',
          DisplayLabel: 'Prislista',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        prioritetBenamning: {
          AttributeName: 'prioritetBenamning',
          DisplayLabel: 'Prioritet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        foreslagenLoneartId: {
          AttributeName: 'foreslagenLoneartId',
          DisplayLabel: 'Föreslagen rapporteringskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        arbetsuppgiftNr: {
          AttributeName: 'arbetsuppgiftNr',
          DisplayLabel: 'Arbetsuppgiftsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        foreslagenRappkod2: {
          AttributeName: 'foreslagenRappkod2',
          DisplayLabel: 'Föreslagen rapporteringskod 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        projektArbetsuppgift: {
          AttributeName: 'projektArbetsuppgift',
          DisplayLabel: 'projektArbetsuppgift',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        arbetsuppgiftNrRubrik: {
          AttributeName: 'arbetsuppgiftNrRubrik',
          DisplayLabel: 'Arbetsuppgift',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        projektNrBenamning: {
          AttributeName: 'projektNrBenamning',
          DisplayLabel: 'Projekt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        visasVidStampling: {
          AttributeName: 'visasVidStampling',
          DisplayLabel: 'Visas i stämpelklocka',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        antalRapporteringar: {
          AttributeName: 'antalRapporteringar',
          DisplayLabel: 'Antal rapporteringar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        anstalldInstallningId: {
          AttributeName: 'anstalldInstallningId',
          DisplayLabel: 'Inställning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        anvandKod2: {
          AttributeName: 'anvandKod2',
          DisplayLabel: 'Använd Rapporteringskod 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        arbetsuppgift: {
          AssociationName: 'arbetsuppgift',
          DisplayLabel: 'Arbetsuppgift',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIArbetsuppgift',
          AssociatedComponentName: 'Arbetsuppgift',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        anstalld: {
          AssociationName: 'anstalld',
          DisplayLabel: 'Anställd',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAnstalld',
          AssociatedComponentName: 'Anstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        prioritet: {
          AssociationName: 'prioritet',
          DisplayLabel: 'Prioritet',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIPrioritet',
          AssociatedComponentName: 'Prioritet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        registreradAv: {
          AssociationName: 'registreradAv',
          DisplayLabel: 'Registrerad av',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        dagrapporteringar: {
          AssociationName: 'dagrapporteringar',
          DisplayLabel: 'Tidrapporteringar',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidrapportering',
          AssociatedComponentName: 'Tidrapportering',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIVarning: {
      CollectionName: 'TIVarning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Varning',
        Abstract: false,
        SOLabel: 'Varning',
        SOGLabel: 'Varning',
        SBLabel: 'Varningen',
        SBGLabel: 'Varningen',
        POLabel: 'Varningar',
        POGLabel: 'Varningar',
        PBLabel: 'Varningarna',
        PBGLabel: 'Varningarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Varningen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Varningen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Varningen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Varningen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANSTALLD_ID: {
          AttributeName: 'ANSTALLD_ID',
          DisplayLabel: 'Anställd',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MANAD: {
          AttributeName: 'MANAD',
          DisplayLabel: 'Månad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'Format="y-m/ymm"',
          FormatterDisplayParams: 'Format="yyyy-mm"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        VARNINGSTYP_ID: {
          AttributeName: 'VARNINGSTYP_ID',
          DisplayLabel: 'Varning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REG_TID: {
          AttributeName: 'REG_TID',
          DisplayLabel: 'Registrerad, tid',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        VARNINGSLISTA_ID: {
          AttributeName: 'VARNINGSLISTA_ID',
          DisplayLabel: 'Varningslista',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TIDRAPPORTERING_ID: {
          AttributeName: 'TIDRAPPORTERING_ID',
          DisplayLabel: 'Tidrapportering',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        varningstypBenamning: {
          AttributeName: 'varningstypBenamning',
          DisplayLabel: 'Varning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        objektBeskrivning: {
          AttributeName: 'objektBeskrivning',
          DisplayLabel: 'Objekt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        namn: {
          AttributeName: 'namn',
          DisplayLabel: 'Anställd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        sortDatum: {
          AttributeName: 'sortDatum',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        anstalldNr: {
          AttributeName: 'anstalldNr',
          DisplayLabel: 'Anställningsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        arbetstid: {
          AttributeName: 'arbetstid',
          DisplayLabel: 'Tid',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        anstalld: {
          AssociationName: 'anstalld',
          DisplayLabel: 'Anställd',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIAnstalld',
          AssociatedComponentName: 'Anstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        man_anstalld: {
          AssociationName: 'man_anstalld',
          DisplayLabel: 'Månadsrapportering',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIManAnstalld',
          AssociatedComponentName: 'ManAnstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        varningstyp: {
          AssociationName: 'varningstyp',
          DisplayLabel: 'Varningstyp',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIVarningstyp',
          AssociatedComponentName: 'Varningstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        varningslista: {
          AssociationName: 'varningslista',
          DisplayLabel: 'Varningslista',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIVarningslista',
          AssociatedComponentName: 'Varningslista',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        dag_anstalld: {
          AssociationName: 'dag_anstalld',
          DisplayLabel: 'Dagrapportering',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIDagAnstalld',
          AssociatedComponentName: 'DagAnstalld',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        tidrapportering: {
          AssociationName: 'tidrapportering',
          DisplayLabel: 'Tidrapportering',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TITidrapportering',
          AssociatedComponentName: 'Tidrapportering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIVarningslista: {
      CollectionName: 'TIVarningslista',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Varningslista',
        Abstract: false,
        SOLabel: 'Varningslista',
        SOGLabel: 'Varningslista',
        SBLabel: 'Varningslistan',
        SBGLabel: 'Varningslistan',
        POLabel: 'Varningslistor',
        POGLabel: 'Varningslistor',
        PBLabel: 'Varningslistorna',
        PBGLabel: 'Varningslistorna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Varningslistan primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Varningslistan versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Varningslistan id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Varningslistan fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        SKAPAD_DATUM: {
          AttributeName: 'SKAPAD_DATUM',
          DisplayLabel: 'Skapad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Varningar: {
          AssociationName: 'Varningar',
          DisplayLabel: 'Varningar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'TIVarning',
          AssociatedComponentName: 'Varning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    TIVarningstyp: {
      CollectionName: 'TIVarningstyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Varningstyp',
        Abstract: false,
        SOLabel: 'Varningstyp',
        SOGLabel: 'Varningstyp',
        SBLabel: 'Varningstypen',
        SBGLabel: 'Varningstypen',
        POLabel: 'Varningstyper',
        POGLabel: 'Varningstyper',
        PBLabel: 'Varningstyperna',
        PBGLabel: 'Varningstyperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Varningstypen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Varningstypen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Varningstypen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Varningstypen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        OBJEKT: {
          AttributeName: 'OBJEKT',
          DisplayLabel: 'Objekt',
          Hint: 'Dagrapportering/Månadsrapportering/Tidrapportering',
          DataType: 'Enum',
          EnumValues: new Map([['DAGRAPPORTERING', 'Dagrapportering'], ['MANADSRAPPORTERING', 'Månadsrapportering'], ['TIDRAPPORTERING', 'Tidrapportering']]),
          EnumSortValues: new Map([['DAGRAPPORTERING', 'TEDTIDagAnstalldSaml'], ['MANADSRAPPORTERING', 'TEDTIManAnstalldSaml'], ['TIDRAPPORTERING', 'TEDTITidrapporteringSaml']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="DAGRAPPORTERING=Dagrapportering;MANADSRAPPORTERING=Månadsrapportering;TIDRAPPORTERING=Tidrapportering"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urval',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MANADSAVSLUT: {
          AttributeName: 'MANADSAVSLUT',
          DisplayLabel: 'Varna vid månadsavslut',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        urval: {
          AssociationName: 'urval',
          DisplayLabel: 'Urval',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
  },
};

export default TI;
